
function $parcel$import(url) {
  url = parcelRequire.i?.[url] || url;
  return import($parcel$distDir + url);
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirea202"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirea202"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("3jPiW", function(module, exports) {
module.exports = $parcel$import("6z40I").then(()=>parcelRequire('aexh3'));

});

var $e7f55278018167e8$exports = {};
$parcel$extendImportMap({
    "6z40I": "es.e18d237c.js"
});

/**
 * ELL Store Self Scan - Main Application Entry Point
 *
 * This file initializes the application and wires up event handlers.
 * Business logic is delegated to specialized modules.
 */ /**
 * Application version - imported from package.json (single source of truth)
 */ var $47d4700db3a3167c$exports = {};
$47d4700db3a3167c$exports = JSON.parse("{\"name\":\"barcode-scanner\",\"version\":\"1.3.3\",\"description\":\"A Progressive Web Application (PWA) that scans barcodes of various formats, using the Barcode Detection API.\",\"source\":\"src/index.html\",\"scripts\":{\"lint\":\"eslint src/js/**\",\"format\":\"prettier --ignore-unknown --write .\",\"clean\":\"rimraf dist .parcel-cache\",\"generateSW\":\"workbox generateSW\",\"start\":\"parcel\",\"build:parcel\":\"parcel build --dist-dir=dist --public-url=./\",\"build\":\"npm-run-all clean build:parcel\",\"postbuild\":\"npm run generateSW\",\"predeploy\":\"npm run build\",\"deploy\":\"gh-pages -d dist\"},\"repository\":{\"type\":\"git\",\"url\":\"git+https://github.com/georapbox/barcode-scanner.git\"},\"keywords\":[\"aztec\",\"code_128\",\"code_39\",\"code_93\",\"codabar\",\"data_matrix\",\"ean_13\",\"ean_8\",\"itf\",\"pdf417\",\"qr_code\",\"upc_a\",\"upc_e\",\"scanner\"],\"author\":{\"name\":\"George Raptis\",\"email\":\"georapbox@gmail.com\"},\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/georapbox/barcode-scanner/issues\"},\"homepage\":\"https://github.com/georapbox/barcode-scanner#readme\",\"devDependencies\":{\"@eslint/js\":\"~9.26.0\",\"@parcel/packager-raw-url\":\"~2.15.0\",\"@parcel/transformer-webmanifest\":\"~2.15.0\",\"eslint\":\"~9.26.0\",\"gh-pages\":\"~6.3.0\",\"globals\":\"~16.1.0\",\"npm-run-all\":\"~4.1.5\",\"parcel\":\"~2.15.0\",\"prettier\":\"~3.5.3\",\"process\":\"~0.11.10\",\"rimraf\":\"~6.0.1\",\"svgo\":\"~3.3.2\",\"workbox-cli\":\"~7.3.0\"},\"dependencies\":{\"@georapbox/a-tab-group\":\"~2.4.1\",\"@georapbox/alert-element\":\"~1.0.1\",\"@georapbox/clipboard-copy-element\":\"~3.0.2\",\"@georapbox/files-dropzone-element\":\"~2.0.1\",\"@georapbox/modal-element\":\"~1.9.0\",\"@georapbox/resize-observer-element\":\"~2.0.1\",\"@georapbox/web-share-element\":\"~3.1.1\",\"barcode-detector\":\"~3.0.4\",\"idb-keyval\":\"~6.2.2\"},\"browserslist\":\"> 0.5%, last 2 versions, not dead\"}");


const $cb0eca7d9f6f47d1$export$a4ad2735b021c132 = (0, $47d4700db3a3167c$exports.version);


/*!
 * @georapbox/a-tab-group
 * A custom element to create a group of tabs and tab panels.
 *
 * @version 2.4.1
 * @homepage https://github.com/georapbox/a-tab-group#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $5a53255ef6289be5$var$h = (a = "", t = "")=>{
    let e = typeof a == "string" && a !== "" ? a + "-" : "", s = typeof t == "string" && t !== "" ? "-" + t : "", i = Math.random().toString(36).substring(2, 8);
    return `${e}${i}${s}`;
};
var $5a53255ef6289be5$var$b = (a, t)=>{
    if (Object.prototype.hasOwnProperty.call(t, a)) {
        let e = t[a];
        delete t[a], t[a] = e;
    }
};
var $5a53255ef6289be5$var$E = 0, $5a53255ef6289be5$var$C = `
  :host {
    box-sizing: border-box;
    display: inline-block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab {
    display: inline-flex;
    align-items: center;
    gap: 0.5rem;
    width: 100%;
    padding: 0.375rem 0.75rem;
    white-space: nowrap;
    cursor: pointer;
  }

  :host([disabled]) .tab {
    opacity: 0.7;
    cursor: not-allowed;
  }

  :host([selected]) .tab {
    color: var(--selected-tab-color);
    background-color: var(--selected-tab-bg-color);
  }

  .tab__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0.25rem;
    font-size: inherit;
    cursor: pointer;
  }
`, $5a53255ef6289be5$var$w = document.createElement("template");
$5a53255ef6289be5$var$w.innerHTML = `
  <style>
    ${$5a53255ef6289be5$var$C}
  </style>

  <div part="base" class="tab">
    <slot></slot>
  </div>
`;
var $5a53255ef6289be5$export$6824c350c20eab3a = class a extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$w.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "selected",
            "disabled",
            "closable"
        ];
    }
    attributeChangedCallback(t, e, s) {
        if (t === "selected" && e !== s && (this.setAttribute("aria-selected", this.selected.toString()), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0")), t === "disabled" && e !== s && (this.setAttribute("aria-disabled", this.disabled.toString()), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0")), t === "closable" && e !== s) {
            if (this.closable) {
                let i = document.createElement("span");
                i.className = "tab__close", i.setAttribute("part", "close-tab"), i.innerHTML = '<svg part="close-tab-icon" xmlns="http://www.w3.org/2000/svg" width="0.875em" height="0.875em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true"><path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/></svg>', this.shadowRoot?.querySelector(".tab")?.appendChild(i), i.addEventListener("click", this.#e);
            } else {
                let i = this.shadowRoot?.querySelector(".tab__close");
                i?.removeEventListener("click", this.#e), i?.remove();
            }
        }
    }
    connectedCallback() {
        this.#s("selected"), this.#s("disabled"), this.#s("closable"), this.id || (this.id = $5a53255ef6289be5$var$h("tab", (++$5a53255ef6289be5$var$E).toString())), this.setAttribute("slot", "tab"), this.setAttribute("role", "tab"), this.setAttribute("aria-selected", "false"), this.setAttribute("tabindex", this.disabled || !this.selected ? "-1" : "0");
    }
    disconnectedCallback() {
        this.shadowRoot?.querySelector(".tab__close")?.removeEventListener("click", this.#e);
    }
    get selected() {
        return this.hasAttribute("selected");
    }
    set selected(t) {
        this.toggleAttribute("selected", !!t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get closable() {
        return this.hasAttribute("closable");
    }
    set closable(t) {
        this.toggleAttribute("closable", !!t);
    }
    #e = (t)=>{
        t.stopPropagation(), this.dispatchEvent(new CustomEvent("a-tab-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: this.id
            }
        }));
    };
    #s(t) {
        return $5a53255ef6289be5$var$b(t, this);
    }
    static defineCustomElement(t = "a-tab") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$6824c350c20eab3a.defineCustomElement();
var $5a53255ef6289be5$var$L = 0, $5a53255ef6289be5$var$S = `
  :host {
    box-sizing: border-box;
    display: block;
    contain: content;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }
`, $5a53255ef6289be5$var$T = document.createElement("template");
$5a53255ef6289be5$var$T.innerHTML = `
  <style>
    ${$5a53255ef6289be5$var$S}
  </style>

  <div part="base" class="tab-panel">
    <slot></slot>
  </div>
`;
var $5a53255ef6289be5$export$185adf5fa2c760b1 = class a extends HTMLElement {
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$T.content.cloneNode(!0));
    }
    connectedCallback() {
        this.setAttribute("slot", "panel"), this.setAttribute("role", "tabpanel"), this.setAttribute("hidden", ""), this.id || (this.id = $5a53255ef6289be5$var$h("panel", (++$5a53255ef6289be5$var$L).toString()));
    }
    static defineCustomElement(t = "a-tab-panel") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$185adf5fa2c760b1.defineCustomElement();
var $5a53255ef6289be5$var$y = 200, $5a53255ef6289be5$var$n = {
    TOP: "top",
    BOTTOM: "bottom",
    START: "start",
    END: "end"
}, $5a53255ef6289be5$var$l = {
    LTR: "ltr",
    RTL: "rtl"
}, $5a53255ef6289be5$var$R = Object.entries($5a53255ef6289be5$var$n).map(([, a])=>a), $5a53255ef6289be5$var$r = {
    AUTO: "auto",
    MANUAL: "manual"
}, $5a53255ef6289be5$var$c = {
    DOWN: "ArrowDown",
    LEFT: "ArrowLeft",
    RIGHT: "ArrowRight",
    UP: "ArrowUp",
    HOME: "Home",
    END: "End",
    ENTER: "Enter",
    SPACE: " "
}, $5a53255ef6289be5$var$x = `
  :host {
    --selected-tab-color: #005fcc;
    --selected-tab-bg-color: transparent;
    --tabs-scroll-behavior: smooth;
    --scroll-button-width: 2.125em;
    --scroll-button-height: 2.125em;
    --scroll-button-inline-offset: 0rem;

    box-sizing: border-box;
    display: block;
    contain: content;
  }

  @media (prefers-reduced-motion: reduce) {
    :host {
      --tabs-scroll-behavior: auto;
    }
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  .tab-group {
    display: flex;
    width: 100%;
  }

  .tab-group__nav {
    position: relative;
  }

  .tab-group__nav--has-scroll-controls {
    padding: 0 calc(var(--scroll-button-width) + var(--scroll-button-inline-offset));
  }

  .tab-group__scroll-button {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: var(--scroll-button-width);
    height: var(--scroll-button-height);
    padding: 0; /* Required for iOS, otherwise the svg is not visible: https://stackoverflow.com/questions/66532071/flex-svg-behaving-strange-in-ios-safari-14-0-3 */
    border: 0;
    z-index: 1;
    background-color: transparent;
    font-size: inherit;
    cursor: pointer;
    color: currentColor;
  }

  .tab-group__scroll-button--start {
    left: var(--scroll-button-inline-offset);
  }

  .tab-group__scroll-button--end {
    right: var(--scroll-button-inline-offset);
  }

  :host([dir="${$5a53255ef6289be5$var$l.RTL}"]) .tab-group__scroll-button--start,
  :host(:dir(${$5a53255ef6289be5$var$l.RTL})) .tab-group__scroll-button--start {
    right: var(--scroll-button-inline-offset);
    left: auto;
    transform: translateY(-50%) rotate(180deg);
  }

  :host([dir="${$5a53255ef6289be5$var$l.RTL}"]) .tab-group__scroll-button--end,
  :host(:dir(${$5a53255ef6289be5$var$l.RTL})) .tab-group__scroll-button--end {
    left: var(--scroll-button-inline-offset);
    right: auto;
    transform: translateY(-50%) rotate(180deg);
  }

  .tab-group__tabs {
    display: flex;
    padding: 0.25rem;
    overflow-x: auto;
    scroll-behavior: var(--tabs-scroll-behavior);
    scrollbar-width: none;
  }

  .tab-group__tabs::-webkit-scrollbar {
    display: none;
  }

  .tab-group__panels {
    padding: 1rem 0;
  }

  /* placement="top" */
  .tab-group,
  :host([placement="${$5a53255ef6289be5$var$n.TOP}"]) .tab-group {
    flex-direction: column;
  }

  /* placement="bottom" */
  :host([placement="${$5a53255ef6289be5$var$n.BOTTOM}"]) .tab-group {
    flex-direction: column;
  }

  :host([placement="${$5a53255ef6289be5$var$n.BOTTOM}"]) .tab-group__nav {
    order: 1;
  }

  /* placement="start" */
  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$5a53255ef6289be5$var$n.START}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }

  /* placement="end" */
  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group {
    flex-direction: row;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__nav {
    order: 1;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__tabs {
    flex-direction: column;
    align-items: flex-start;
  }

  :host([placement="${$5a53255ef6289be5$var$n.END}"]) .tab-group__panels {
    flex: 1;
    padding: 0 1rem;
  }
`, $5a53255ef6289be5$var$A = document.createElement("template");
$5a53255ef6289be5$var$A.innerHTML = `
  <style>${$5a53255ef6289be5$var$x}</style>

  <div part="base" class="tab-group">
    <div part="nav" class="tab-group__nav">
      <button type="button" part="scroll-button scroll-button--start" class="tab-group__scroll-button tab-group__scroll-button--start" aria-label="Scroll to start">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"/>
        </svg>
      </button>

      <div part="tabs" class="tab-group__tabs" role="tablist" tabindex="-1">
        <slot name="tab"></slot>
      </div>

      <button type="button" part="scroll-button scroll-button--end" class="tab-group__scroll-button tab-group__scroll-button--end" aria-label="Scroll to end">
        <svg xmlns="http://www.w3.org/2000/svg" width="1rem" height="1em" fill="currentColor" viewBox="0 0 16 16" part="scroll-button-icon">
          <path fill-rule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"/>
        </svg>
      </button>
    </div>

    <div part="panels" class="tab-group__panels">
      <slot name="panel"></slot>
    </div>
  </div>
`;
var $5a53255ef6289be5$export$4ac05a649254e913 = class a extends HTMLElement {
    #e = null;
    #s = null;
    #l = !1;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($5a53255ef6289be5$var$A.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "placement",
            "no-scroll-controls"
        ];
    }
    attributeChangedCallback(t, e, s) {
        t === "placement" && e !== s && this.#i(), t === "no-scroll-controls" && e !== s && this.#i();
    }
    get placement() {
        return this.getAttribute("placement") || $5a53255ef6289be5$var$n.TOP;
    }
    set placement(t) {
        t != null && this.setAttribute("placement", t);
    }
    get noScrollControls() {
        return this.hasAttribute("no-scroll-controls");
    }
    set noScrollControls(t) {
        this.toggleAttribute("no-scroll-controls", !!t);
    }
    get scrollDistance() {
        let t = Number(this.getAttribute("scroll-distance"));
        return Math.abs(t) || $5a53255ef6289be5$var$y;
    }
    set scrollDistance(t) {
        this.setAttribute("scroll-distance", Math.abs(t).toString() || $5a53255ef6289be5$var$y.toString());
    }
    get activation() {
        return this.getAttribute("activation") || $5a53255ef6289be5$var$r.AUTO;
    }
    set activation(t) {
        this.setAttribute("activation", t || $5a53255ef6289be5$var$r.AUTO);
    }
    get noTabCycling() {
        return this.hasAttribute("no-tab-cycling");
    }
    set noTabCycling(t) {
        this.toggleAttribute("no-tab-cycling", !!t);
    }
    connectedCallback() {
        this.#o("placement"), this.#o("noScrollControls"), this.#o("scrollDistance"), this.#o("activation"), this.#o("noTabCycling");
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), i = this.shadowRoot?.querySelector(".tab-group__nav"), o = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.addEventListener("slotchange", this.#n), e?.addEventListener("slotchange", this.#n), s?.addEventListener("click", this.#g), s?.addEventListener("keydown", this.#p), o.forEach((d)=>d.addEventListener("click", this.#f)), this.addEventListener("a-tab-close", this.#m), "ResizeObserver" in window && (this.#e = new ResizeObserver((d)=>{
            this.#s = window.requestAnimationFrame(()=>{
                let v = d?.[0]?.target, g = v?.scrollWidth > v?.clientWidth;
                o.forEach((_)=>_.toggleAttribute("hidden", !g)), i?.part.toggle("nav--has-scroll-controls", g), i?.classList.toggle("tab-group__nav--has-scroll-controls", g);
            });
        })), this.#h(), this.#i();
    }
    disconnectedCallback() {
        let t = this.shadowRoot?.querySelector("slot[name=tab]"), e = this.shadowRoot?.querySelector("slot[name=panel]"), s = this.shadowRoot?.querySelector(".tab-group__tabs"), i = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        t?.removeEventListener("slotchange", this.#n), e?.removeEventListener("slotchange", this.#n), s?.removeEventListener("click", this.#g), s?.removeEventListener("keydown", this.#p), i.forEach((o)=>o.removeEventListener("click", this.#f)), this.removeEventListener("a-tab-close", this.#m), this.#c();
    }
    #v() {
        if (!this.#e) return;
        let t = this.shadowRoot?.querySelector(".tab-group__tabs");
        t && (this.#e.unobserve(t), this.#e.observe(t));
    }
    #c() {
        this.#e && (this.#e.disconnect(), this.#s !== null && (window.cancelAnimationFrame(this.#s), this.#s = null));
    }
    #d() {
        return window.CSS.supports("selector(:dir(ltr))") ? this.matches(":dir(ltr)") ? $5a53255ef6289be5$var$l.LTR : $5a53255ef6289be5$var$l.RTL : window.getComputedStyle(this).direction || $5a53255ef6289be5$var$l.LTR;
    }
    #h() {
        this.hidden = this.#t().length === 0;
    }
    #w() {
        let t = this.#t();
        this.#h(), t.forEach((e)=>{
            let s = e.nextElementSibling;
            if (!s || s.tagName.toLowerCase() !== "a-tab-panel") return console.error(`Tab #${e.id} is not a sibling of a <a-tab-panel>`);
            e.setAttribute("aria-controls", s.id), s.setAttribute("aria-labelledby", e.id);
        });
    }
    #T() {
        return Array.from(this.querySelectorAll("a-tab-panel"));
    }
    #t() {
        return Array.from(this.querySelectorAll("a-tab"));
    }
    #b(t) {
        let e = t.getAttribute("aria-controls");
        return this.querySelector(`#${e}`);
    }
    #y() {
        return this.#t().find((e)=>!e.disabled) || null;
    }
    #A() {
        let t = this.#t();
        for(let e = t.length - 1; e >= 0; e--)if (!t[e].disabled) return t[e];
        return null;
    }
    #a() {
        let t = this.#t(), e = this.activation === $5a53255ef6289be5$var$r.MANUAL ? t.findIndex((s)=>s.matches(":focus")) - 1 : t.findIndex((s)=>s.selected) - 1;
        for(; t[(e + t.length) % t.length].disabled;)e--;
        return this.noTabCycling && e < 0 ? null : t[(e + t.length) % t.length];
    }
    #r() {
        let t = this.#t(), e = this.activation === $5a53255ef6289be5$var$r.MANUAL ? t.findIndex((s)=>s.matches(":focus")) + 1 : t.findIndex((s)=>s.selected) + 1;
        for(; t[e % t.length].disabled;)e++;
        return this.noTabCycling && e >= t.length ? null : t[e % t.length];
    }
    #_() {
        let t = this.#t(), e = this.#T();
        t.forEach((s)=>s.selected = !1), e.forEach((s)=>s.hidden = !0);
    }
    #i() {
        let t = this.shadowRoot?.querySelector(".tab-group__nav"), e = this.shadowRoot?.querySelector(".tab-group__tabs"), s = Array.from(this.shadowRoot?.querySelectorAll(".tab-group__scroll-button") || []);
        this.noScrollControls || this.placement === $5a53255ef6289be5$var$n.START || this.placement === $5a53255ef6289be5$var$n.END ? (this.#c(), s.forEach((i)=>i.hidden = !0), t?.part.remove("nav--has-scroll-controls"), t?.classList.remove("tab-group__nav--has-scroll-controls"), e?.setAttribute("aria-orientation", "vertical")) : (this.#v(), s.forEach((i)=>i.hidden = !1), e?.setAttribute("aria-orientation", "horizontal"));
    }
    #E() {
        let t = this.#t(), e = t.find((s)=>s.selected && !s.disabled) || t.find((s)=>!s.disabled);
        e && (this.#l && !e.selected && this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.#u(e));
    }
    #u(t) {
        this.#_(), t && (t.selected = !0);
        let e = this.#b(t);
        e && (e.hidden = !1);
    }
    #n = (t)=>{
        this.#w(), this.#i(), this.#E(), t.target.name === "tab" && (this.#l = !0);
    };
    #p = (t)=>{
        if (t.target.tagName.toLowerCase() !== "a-tab" || t.altKey) return;
        let e = $5a53255ef6289be5$var$R.includes(this.placement || "") ? this.placement : $5a53255ef6289be5$var$n.TOP, s = [
            $5a53255ef6289be5$var$n.TOP,
            $5a53255ef6289be5$var$n.BOTTOM
        ].includes(e || "") ? "horizontal" : "vertical", i = this.#d(), o = null;
        switch(t.key){
            case $5a53255ef6289be5$var$c.LEFT:
                s === "horizontal" && (o = i === $5a53255ef6289be5$var$l.LTR ? this.#a() : this.#r(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.RIGHT:
                s === "horizontal" && (o = i === $5a53255ef6289be5$var$l.LTR ? this.#r() : this.#a(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.UP:
                s === "vertical" && (o = this.#a(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.DOWN:
                s === "vertical" && (o = this.#r(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o)));
                break;
            case $5a53255ef6289be5$var$c.HOME:
                o = this.#y(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $5a53255ef6289be5$var$c.END:
                o = this.#A(), o && (this.activation === $5a53255ef6289be5$var$r.MANUAL ? o.focus() : this.selectTab(o));
                break;
            case $5a53255ef6289be5$var$c.ENTER:
            case $5a53255ef6289be5$var$c.SPACE:
                o = t.target, o && this.selectTab(o);
                break;
            default:
                return;
        }
        t.preventDefault();
    };
    #g = (t)=>{
        let e = t.target.closest("a-tab");
        e && this.selectTab(e);
    };
    #f = (t)=>{
        let e = t.target.closest(".tab-group__scroll-button"), s = this.shadowRoot?.querySelector(".tab-group__tabs");
        if (!e || !s) return;
        let i = e.classList.contains("tab-group__scroll-button--start"), o = this.#d() === $5a53255ef6289be5$var$l.LTR, d = i ? o ? -1 : 1 : o ? 1 : -1, m = s.scrollLeft;
        s.scrollTo({
            left: m + d * this.scrollDistance
        });
    };
    #m = (t)=>{
        let e = t.target, s = this.#b(e);
        e && (e.remove(), e.selected && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        }))), s && s.tagName.toLowerCase() === "a-tab-panel" && s.remove();
    };
    #o(t) {
        return $5a53255ef6289be5$var$b(t, this);
    }
    selectTabByIndex(t) {
        let s = this.#t()[t];
        s && this.selectTab(s);
    }
    selectTabById(t) {
        let s = this.#t().find((i)=>i.id === t);
        s && this.selectTab(s);
    }
    selectTab(t) {
        let e = this.#t().find((s)=>s.selected);
        !t || t.disabled || t.selected || t.tagName.toLowerCase() !== "a-tab" || (this.#u(t), window.requestAnimationFrame(()=>{
            t.scrollIntoView({
                inline: "nearest",
                block: "nearest"
            }), t.focus();
        }), e && this.dispatchEvent(new CustomEvent("a-tab-hide", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: e.id
            }
        })), this.dispatchEvent(new CustomEvent("a-tab-show", {
            bubbles: !0,
            composed: !0,
            detail: {
                tabId: t.id
            }
        })));
    }
    static defineCustomElement(t = "a-tab-group") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$5a53255ef6289be5$export$4ac05a649254e913.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $cd62c5572235e737$var$h = `
  :host {
    display: inline-block;
  }
`, $cd62c5572235e737$var$r = document.createElement("template");
$cd62c5572235e737$var$r.innerHTML = `
  <style>${$cd62c5572235e737$var$h}</style>
  <slot name="button"><button type="button" part="button"><slot name="button-content">Share</slot></button></slot>
`;
var $cd62c5572235e737$export$30b344bef3e55b67 = class a extends HTMLElement {
    #e;
    #t;
    #r = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($cd62c5572235e737$var$r.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector('slot[name="button"]') || null, this.#t = this.#h();
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, e, i) {
        t === "disabled" && e !== i && this.#t && (this.#t.toggleAttribute("disabled", this.disabled), this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part && this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#s("shareUrl"), this.#s("shareTitle"), this.#s("shareText"), this.#s("shareFiles"), this.#s("disabled"), this.#e?.addEventListener("slotchange", this.#a), this.#t?.addEventListener("click", this.#i);
    }
    disconnectedCallback() {
        this.#e?.removeEventListener("slotchange", this.#a), this.#t?.removeEventListener("click", this.#i);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get shareUrl() {
        return this.getAttribute("share-url") || "";
    }
    set shareUrl(t) {
        this.setAttribute("share-url", t);
    }
    get shareTitle() {
        return this.getAttribute("share-title") || "";
    }
    set shareTitle(t) {
        this.setAttribute("share-title", t);
    }
    get shareText() {
        return this.getAttribute("share-text") || "";
    }
    set shareText(t) {
        this.setAttribute("share-text", t);
    }
    get shareFiles() {
        return this.#r;
    }
    set shareFiles(t) {
        Array.isArray(t) && t.length > 0 && (this.#r = t);
    }
    async share() {
        if (!this.disabled) try {
            let t = {};
            this.shareUrl && (t.url = this.shareUrl), this.shareTitle && (t.title = this.shareTitle), this.shareText && (t.text = this.shareText), Array.isArray(this.shareFiles) && this.shareFiles.length > 0 && navigator.canShare && navigator.canShare({
                files: this.shareFiles
            }) && (t.files = this.shareFiles), await navigator.share(t), this.dispatchEvent(new CustomEvent("web-share:success", {
                bubbles: !0,
                composed: !0,
                detail: {
                    shareData: t
                }
            }));
        } catch (t) {
            if (t instanceof Error && t.name === "AbortError") {
                this.dispatchEvent(new CustomEvent("web-share:abort", {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
                return;
            }
            this.dispatchEvent(new CustomEvent("web-share:error", {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #i = (t)=>{
        t.preventDefault(), !this.disabled && this.share();
    };
    #a = (t)=>{
        t.target && t.target.name === "button" && (this.#t?.removeEventListener("click", this.#i), this.#t = this.#h(), this.#t && (this.#t.addEventListener("click", this.#i), this.#t.nodeName !== "BUTTON" && !this.#t.hasAttribute("role") && this.#t.setAttribute("role", "button")));
    };
    #h() {
        return this.#e && this.#e.assignedElements({
            flatten: !0
        }).find((t)=>t.nodeName === "BUTTON" || t.getAttribute("slot") === "button") || null;
    }
    #s(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let i = e[t];
            delete e[t], e[t] = i;
        }
    }
    static defineCustomElement(t = "web-share") {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$cd62c5572235e737$export$30b344bef3e55b67.defineCustomElement();


/*!
 * @georapbox/files-dropzone-element
 * A custom element that creates a drag and drop zone for files
 *
 * @version 2.0.1
 * @homepage https://github.com/georapbox/files-dropzone-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $9351176e8d763a78$var$u(o, e = "") {
    if (!e) return !0;
    let t = [
        ...new Set(e.split(",").map((r)=>r.trim()).filter(Boolean))
    ], i = o.type, s = i.replace(/\/.*$/, "");
    for (let r of t)if (r.charAt(0) === ".") {
        if (o.name.toLowerCase().indexOf(r.toLowerCase(), o.name.length - r.length) !== -1) return !0;
    } else if (/\/\*$/.test(r)) {
        if (s === r.replace(/\/.*$/, "")) return !0;
    } else if (i === r) return !0;
    return !1;
}
var $9351176e8d763a78$var$x = new Map([
    [
        "aac",
        "audio/aac"
    ],
    [
        "abw",
        "application/x-abiword"
    ],
    [
        "arc",
        "application/x-freearc"
    ],
    [
        "avif",
        "image/avif"
    ],
    [
        "avi",
        "video/x-msvideo"
    ],
    [
        "azw",
        "application/vnd.amazon.ebook"
    ],
    [
        "bin",
        "application/octet-stream"
    ],
    [
        "bmp",
        "image/bmp"
    ],
    [
        "bz",
        "application/x-bzip"
    ],
    [
        "bz2",
        "application/x-bzip2"
    ],
    [
        "cda",
        "application/x-cdf"
    ],
    [
        "csh",
        "application/x-csh"
    ],
    [
        "css",
        "text/css"
    ],
    [
        "csv",
        "text/csv"
    ],
    [
        "doc",
        "application/msword"
    ],
    [
        "docx",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    [
        "eot",
        "application/vnd.ms-fontobject"
    ],
    [
        "epub",
        "application/epub+zip"
    ],
    [
        "gz",
        "application/gzip"
    ],
    [
        "gif",
        "image/gif"
    ],
    [
        "heic",
        "image/heic"
    ],
    [
        "heif",
        "image/heif"
    ],
    [
        "htm",
        "text/html"
    ],
    [
        "html",
        "text/html"
    ],
    [
        "ico",
        "image/vnd.microsoft.icon"
    ],
    [
        "ics",
        "text/calendar"
    ],
    [
        "jar",
        "application/java-archive"
    ],
    [
        "jpeg",
        "image/jpeg"
    ],
    [
        "jpg",
        "image/jpeg"
    ],
    [
        "jxl",
        "image/jxl"
    ],
    [
        "js",
        "text/javascript"
    ],
    [
        "json",
        "application/json"
    ],
    [
        "jsonld",
        "application/ld+json"
    ],
    [
        "markdown",
        "text/markdown"
    ],
    [
        "md",
        "text/markdown"
    ],
    [
        "mid",
        "audio/midi"
    ],
    [
        "midi",
        "audio/midi"
    ],
    [
        "mjs",
        "text/javascript"
    ],
    [
        "mp3",
        "audio/mpeg"
    ],
    [
        "mp4",
        "video/mp4"
    ],
    [
        "mpeg",
        "video/mpeg"
    ],
    [
        "mpkg",
        "application/vnd.apple.installer+xml"
    ],
    [
        "odp",
        "application/vnd.oasis.opendocument.presentation"
    ],
    [
        "ods",
        "application/vnd.oasis.opendocument.spreadsheet"
    ],
    [
        "odt",
        "application/vnd.oasis.opendocument.text"
    ],
    [
        "oga",
        "audio/ogg"
    ],
    [
        "ogv",
        "video/ogg"
    ],
    [
        "ogx",
        "application/ogg"
    ],
    [
        "opus",
        "audio/opus"
    ],
    [
        "otf",
        "font/otf"
    ],
    [
        "png",
        "image/png"
    ],
    [
        "pdf",
        "application/pdf"
    ],
    [
        "php",
        "application/x-httpd-php"
    ],
    [
        "ppt",
        "application/vnd.ms-powerpoint"
    ],
    [
        "pptx",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    [
        "rar",
        "application/vnd.rar"
    ],
    [
        "rtf",
        "application/rtf"
    ],
    [
        "sh",
        "application/x-sh"
    ],
    [
        "svg",
        "image/svg+xml"
    ],
    [
        "swf",
        "application/x-shockwave-flash"
    ],
    [
        "tar",
        "application/x-tar"
    ],
    [
        "tif",
        "image/tiff"
    ],
    [
        "tiff",
        "image/tiff"
    ],
    [
        "ts",
        "video/mp2t"
    ],
    [
        "ttf",
        "font/ttf"
    ],
    [
        "txt",
        "text/plain"
    ],
    [
        "vsd",
        "application/vnd.visio"
    ],
    [
        "wav",
        "audio/wav"
    ],
    [
        "weba",
        "audio/webm"
    ],
    [
        "webm",
        "video/webm"
    ],
    [
        "webp",
        "image/webp"
    ],
    [
        "woff",
        "font/woff"
    ],
    [
        "woff2",
        "font/woff2"
    ],
    [
        "xhtml",
        "application/xhtml+xml"
    ],
    [
        "xls",
        "application/vnd.ms-excel"
    ],
    [
        "xlsx",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    [
        "xml",
        "application/xml"
    ],
    [
        "xul",
        "application/vnd.mozilla.xul+xml"
    ],
    [
        "zip",
        "application/zip"
    ],
    [
        "7z",
        "application/x-7z-compressed"
    ],
    [
        "mkv",
        "video/x-matroska"
    ],
    [
        "mov",
        "video/quicktime"
    ],
    [
        "msg",
        "application/vnd.ms-outlook"
    ]
]), $9351176e8d763a78$var$b = [
    ".DS_Store",
    "Thumbs.db"
], $9351176e8d763a78$var$y = (o)=>{
    let { name: e } = o;
    if (e && e.lastIndexOf(".") !== -1 && !o.type) {
        let i = (e.split(".").pop() || "").toLowerCase(), s = $9351176e8d763a78$var$x.get(i);
        s && Object.defineProperty(o, "type", {
            value: s,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return o;
}, $9351176e8d763a78$var$g = (o, e)=>{
    let t = $9351176e8d763a78$var$y(o);
    if (typeof t.path != "string") {
        let { webkitRelativePath: i } = o;
        Object.defineProperty(t, "path", {
            value: typeof e == "string" ? e : i || o.name,
            writable: !1,
            configurable: !1,
            enumerable: !0
        });
    }
    return t;
}, $9351176e8d763a78$var$m = async (o)=>await new Promise((e, t)=>{
        o.readEntries(e, t);
    }), $9351176e8d763a78$var$w = async (o)=>{
    let e = [], t = await $9351176e8d763a78$var$m(o);
    for(; t.length > 0;)e.push(...t), t = await $9351176e8d763a78$var$m(o);
    return e;
}, $9351176e8d763a78$var$E = (o)=>new Promise((e, t)=>{
        o.file((i)=>e($9351176e8d763a78$var$g(i, o.fullPath)), t);
    }), $9351176e8d763a78$var$F = async (o)=>{
    let e = [], t = [];
    for (let i of o){
        if (i.kind !== "file") continue;
        let s = i.getAsEntry ? i.getAsEntry() : i.webkitGetAsEntry();
        t.push(s);
    }
    for(; t.length > 0;){
        let i = t.shift();
        if (i) {
            if (i.isFile) {
                let s = await $9351176e8d763a78$var$E(i);
                $9351176e8d763a78$var$b.indexOf(s.name) === -1 && e.push(s);
            } else i.isDirectory && t.push(...await $9351176e8d763a78$var$w(i.createReader()));
        } else continue;
    }
    return e;
}, $9351176e8d763a78$var$f = async (o)=>{
    let e = [];
    for (let t of o)$9351176e8d763a78$var$b.indexOf(t.name) === -1 && e.push($9351176e8d763a78$var$g(t));
    return e;
}, $9351176e8d763a78$var$l = async (o)=>o.dataTransfer ? o.dataTransfer.items ? await $9351176e8d763a78$var$F(o.dataTransfer.items) : await $9351176e8d763a78$var$f(o.dataTransfer.files) : await $9351176e8d763a78$var$f(o.target.files);
var $9351176e8d763a78$var$n = "files-dropzone", $9351176e8d763a78$var$v = "TOO_MANY_FILES", $9351176e8d763a78$var$L = "FILE_TOO_LARGE", $9351176e8d763a78$var$k = "FILE_TOO_SMALL", $9351176e8d763a78$var$A = "INVALID_MIME_TYPE", $9351176e8d763a78$var$z = document.createElement("template"), $9351176e8d763a78$var$S = `
  *,
  *::before,
  *::after {
    box-sizing: border-box;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  :host {
    --dropzone-border-width: 2px;
    --dropzone-border-style: dashed;
    --dropzone-border-radius: 0.25rem;
    --dropzone-border-color: #6c757d;
    --dropzone-border-color-dragover: #0d6efd;
    --dropzone-border-color-hover: var(--dropzone-border-color-dragover);
    --dropzone-background-color: #ffffff;
    --dropzone-background-color-dragover: #f4f4f5;
    --dropzone-background-color-hover: var(--dropzone-background-color-dragover);
    --dropzone-body-color: #3f3f46;
    --dropzone-body-color-dragover: var(--dropzone-body-color);
    --dropzone-body-color-hover: var(--dropzone-body-color-dragover);
    --dropzone-focus-shadow-rgb: 49,132,253;
    --dropzone-focus-box-shadow: 0 0 0 0.25rem rgba(var(--dropzone-focus-shadow-rgb), 0.5);
    --transition-duration: 0.2s; /* for backwards compatibility */
    --dropzone-transition-duration: var(--transition-duration);

    display: block;
  }

  :host(:not([no-style])) .dropzone {
    border: var(--dropzone-border-width) var(--dropzone-border-style) var(--dropzone-border-color);
    border-radius: var(--dropzone-border-radius);
    padding: 3rem 1rem;
    overflow: hidden;
    background-color: var(--dropzone-background-color);
    color: var(--dropzone-body-color);
    text-align: center;
    cursor: pointer;
    transition: border var(--dropzone-transition-duration) ease-in-out, background-color var(--dropzone-transition-duration) ease-in-out, color var(--dropzone-transition-duration) ease-in-out, box-shadow var(--dropzone-transition-duration) ease-in-out;
  }

  :host(:not([no-style])[disabled]) .dropzone {
    opacity: 0.8;
    cursor: not-allowed;
    user-select: none;
  }

  :host(:not([no-style]):not([disabled])) .dropzone--dragover {
    border-color: var(--dropzone-border-color-dragover);
    background-color: var(--dropzone-background-color-dragover);
    color: var(--dropzone-body-color-dragover);
  }

  :host(:not([no-style]):not([disabled])) .dropzone:focus-visible {
    outline: none;
    box-shadow: var(--dropzone-focus-box-shadow);
  }

  @media (hover: hover) {
    :host(:not([no-style]):not([disabled])) .dropzone:not(.dropzone--dragover):hover {
      border-color: var(--dropzone-border-color-hover);
      background-color: var(--dropzone-background-color-hover);
      color: var(--dropzone-body-color-hover);
    }
  }
`;
$9351176e8d763a78$var$z.innerHTML = `
  <style>
    ${$9351176e8d763a78$var$S}
  </style>

  <input type="file" id="file-input" hidden>

  <div part="dropzone" class="dropzone" id="dropzone" tabindex="0" role="button" aria-disabled="false">
    <slot>Drag 'n' drop files here, or click to select files</slot>
  </div>
`;
var $9351176e8d763a78$export$6ccd1735166caad9 = class o extends HTMLElement {
    #t = null;
    #e = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open",
            delegatesFocus: !0
        }).appendChild($9351176e8d763a78$var$z.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.getElementById("file-input"), this.#e = this.shadowRoot.getElementById("dropzone"));
    }
    static get observedAttributes() {
        return [
            "accept",
            "disabled",
            "multiple"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "accept" && t !== i && this.#t && (this.#t.accept = this.accept), e === "disabled" && t !== i && this.#t && (this.#t.disabled = this.disabled, this.disabled ? (this.#e?.removeAttribute("tabindex"), this.#e?.setAttribute("aria-disabled", "true")) : (this.#e?.setAttribute("tabindex", "0"), this.#e?.setAttribute("aria-disabled", "false"))), e === "multiple" && t !== i && this.#t && (this.#t.multiple = this.multiple);
    }
    connectedCallback() {
        this.#o("accept"), this.#o("disabled"), this.#o("maxFiles"), this.#o("maxSize"), this.#o("minSize"), this.#o("multiple"), this.#o("autoFocus"), this.#o("noStyle"), this.#t?.addEventListener("change", this.#i), this.#e?.addEventListener("dragenter", this.#r), this.#e?.addEventListener("dragover", this.#s), this.#e?.addEventListener("dragleave", this.#n), this.#e?.addEventListener("drop", this.#a), this.#e?.addEventListener("click", this.#d), this.#e?.addEventListener("keyup", this.#l), this.autoFocus && this.#e?.focus();
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("change", this.#i), this.#e?.removeEventListener("dragenter", this.#r), this.#e?.removeEventListener("dragover", this.#s), this.#e?.removeEventListener("dragleave", this.#n), this.#e?.removeEventListener("drop", this.#a), this.#e?.removeEventListener("click", this.#d), this.#e?.removeEventListener("keyup", this.#l);
    }
    get accept() {
        return this.getAttribute("accept") || "";
    }
    set accept(e) {
        this.setAttribute("accept", e != null ? e.toString() : e);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    get maxFiles() {
        let e = Number(this.getAttribute("max-files")) || 0;
        return e <= 0 ? 1 / 0 : Math.floor(Math.abs(e));
    }
    set maxFiles(e) {
        this.setAttribute("max-files", e != null ? e.toString() : e);
    }
    get maxSize() {
        let e = this.getAttribute("max-size");
        if (e === null) return 1 / 0;
        let t = Number(e);
        return Number.isNaN(t) ? 1 / 0 : t;
    }
    set maxSize(e) {
        this.setAttribute("max-size", e != null ? e.toString() : e);
    }
    get minSize() {
        let e = this.getAttribute("min-size");
        if (e === null) return 0;
        let t = Number(e);
        return Number.isNaN(t) ? 0 : t;
    }
    set minSize(e) {
        this.setAttribute("min-size", e != null ? e.toString() : e);
    }
    get multiple() {
        return this.hasAttribute("multiple");
    }
    set multiple(e) {
        this.toggleAttribute("multiple", !!e);
    }
    get autoFocus() {
        return this.hasAttribute("auto-focus");
    }
    set autoFocus(e) {
        this.toggleAttribute("auto-focus", !!e);
    }
    get noStyle() {
        return this.hasAttribute("no-style");
    }
    set noStyle(e) {
        this.toggleAttribute("no-style", !!e);
    }
    #i = async (e)=>{
        try {
            this.#c(await $9351176e8d763a78$var$l(e));
        } catch (t) {
            this.dispatchEvent(new CustomEvent(`${$9351176e8d763a78$var$n}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    };
    #r = ()=>{
        this.disabled || this.dispatchEvent(new Event(`${$9351176e8d763a78$var$n}-dragenter`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #s = (e)=>{
        if (e.preventDefault(), this.disabled) {
            e.dataTransfer.dropEffect = "none";
            return;
        }
        e.dataTransfer.dropEffect = "copy", this.#e && (this.#e.classList.add("dropzone--dragover"), this.#e.part.add("dropzone--dragover")), this.dispatchEvent(new Event(`${$9351176e8d763a78$var$n}-dragover`, {
            bubbles: !0,
            composed: !0
        }));
    };
    #n = ()=>{
        this.disabled || (this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover")), this.dispatchEvent(new Event(`${$9351176e8d763a78$var$n}-dragleave`, {
            bubbles: !0,
            composed: !0
        })));
    };
    #a = async (e)=>{
        if (!this.disabled) {
            e.preventDefault(), this.#e && (this.#e.classList.remove("dropzone--dragover"), this.#e.part.remove("dropzone--dragover"));
            try {
                this.#c(await $9351176e8d763a78$var$l(e));
            } catch (t) {
                this.dispatchEvent(new CustomEvent(`${$9351176e8d763a78$var$n}-error`, {
                    bubbles: !0,
                    composed: !0,
                    detail: {
                        error: t
                    }
                }));
            }
        }
    };
    #d = ()=>{
        this.disabled || this.#t?.click();
    };
    #l = (e)=>{
        this.disabled || (e.key === " " || e.key === "Enter") && this.#t?.click();
    };
    #c(e) {
        if (!Array.isArray(e) || !e.length) return;
        let t = [], i = [], s = e.length;
        if (!this.multiple && s > 1) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: $9351176e8d763a78$var$v,
                    message: "Too many files selected. Only 1 file is allowed."
                }
            ]
        });
        else if (this.multiple && s > this.maxFiles) for (let r of e)i.push({
            file: r,
            errors: [
                {
                    code: $9351176e8d763a78$var$v,
                    message: `Too many files selected. Only ${this.maxFiles} ${this.maxFiles > 1 ? "files are" : "file is"} allowed.`
                }
            ]
        });
        else for (let r of e){
            let c = $9351176e8d763a78$var$u(r, this.accept), p = r.size > this.maxSize, h = r.size < this.minSize;
            if (c && !p && !h) t.push(r);
            else {
                let a = [];
                c || a.push({
                    code: $9351176e8d763a78$var$A,
                    message: `File type "${r.type}" is not accepted.`
                }), p && a.push({
                    code: $9351176e8d763a78$var$L,
                    message: `File size ${r.size} exceeds the maximum size of ${this.maxSize}.`
                }), h && a.push({
                    code: $9351176e8d763a78$var$k,
                    message: `File size ${r.size} is smaller than the minimum size of ${this.minSize}.`
                }), i.push({
                    file: r,
                    errors: a
                });
            }
        }
        this.dispatchEvent(new CustomEvent(`${$9351176e8d763a78$var$n}-drop`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t,
                rejectedFiles: i
            }
        })), t.length > 0 && this.dispatchEvent(new CustomEvent(`${$9351176e8d763a78$var$n}-drop-accepted`, {
            bubbles: !0,
            composed: !0,
            detail: {
                acceptedFiles: t
            }
        })), i.length > 0 && this.dispatchEvent(new CustomEvent(`${$9351176e8d763a78$var$n}-drop-rejected`, {
            bubbles: !0,
            composed: !0,
            detail: {
                rejectedFiles: i
            }
        })), this.#t && (this.#t.value = this.#t.defaultValue);
    }
    openFileDialog() {
        this.disabled || this.#t?.click();
    }
    #o(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = $9351176e8d763a78$var$n) {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, o);
    }
};
$9351176e8d763a78$export$6ccd1735166caad9.defineCustomElement();


/*!
 * @georapbox/resize-observer-element
 * A custom element that offers a declarative interface to the ResizeObserver API.
 *
 * @version 2.0.1
 * @homepage https://github.com/georapbox/resize-observer-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $1c2cbcdf680d66d4$var$d = ":host { display: contents; }", $1c2cbcdf680d66d4$var$o = document.createElement("template");
$1c2cbcdf680d66d4$var$o.innerHTML = `
  <style>${$1c2cbcdf680d66d4$var$d}</style>
  <slot></slot>
`;
var $1c2cbcdf680d66d4$export$f0e45424cc896229 = class n extends HTMLElement {
    #e = null;
    #t = null;
    #s = [];
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($1c2cbcdf680d66d4$var$o.content.cloneNode(!0)), this.#e = this.shadowRoot?.querySelector("slot") ?? null;
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(e, t, i) {
        e === "disabled" && t !== i && (this.disabled ? this.#o() : this.#i());
    }
    connectedCallback() {
        this.#d("disabled"), "ResizeObserver" in window && (this.#t = new ResizeObserver((e)=>{
            this.dispatchEvent(new CustomEvent("resize-observer:resize", {
                bubbles: !0,
                composed: !0,
                detail: {
                    entries: e
                }
            }));
        }), this.disabled || this.#i(), this.#e?.addEventListener("slotchange", this.#n));
    }
    disconnectedCallback() {
        this.#o(), this.#e?.removeEventListener("slotchange", this.#n);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(e) {
        this.toggleAttribute("disabled", !!e);
    }
    #i() {
        !this.#e || !this.#t || (this.#s.forEach((e)=>this.#t?.unobserve(e)), this.#s = [], this.#e.assignedElements().forEach((e)=>{
            this.#t?.observe(e), this.#s.push(e);
        }));
    }
    #o() {
        this.#t?.disconnect();
    }
    #n = ()=>{
        this.disabled || this.#i();
    };
    #d(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    static defineCustomElement(e = "resize-observer") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, n);
    }
};
$1c2cbcdf680d66d4$export$f0e45424cc896229.defineCustomElement();


/*!
 * @georapbox/modal-element
 * A custom element to create a modal, using the native dialog element under the hood.
 *
 * @version 1.9.0
 * @homepage https://github.com/georapbox/modal-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $d9c5053bade2d3f8$var$a = document.createElement("template"), $d9c5053bade2d3f8$var$r = `
  :host {
    --me-width: 32rem;
    --me-height: fit-content;
    --me-border-color: initial;
    --me-border-style: solid;
    --me-border-width: initial;
    --me-border-radius: 0;
    --me-box-shadow: none;
    --me-background-color: canvas;
    --me-color: canvastext;

    --me-header-spacing: 1rem;
    --me-footer-spacing: 1rem;
    --me-header-background-color: transparent;
    --me-header-color: initial;

    --me-body-spacing: 1rem;
    --me-body-background-color: transparent;
    --me-body-color: initial;
    --me-footer-background-color: transparent;
    --me-footer-color: initial;

    --me-close-padding: 0.4375rem;
    --me-close-border: none;
    --me-close-border-radius: 0;
    --me-close-background-color: transparent;
    --me-close-color: inherit;
    --me-close-font-size: 1rem;

    --me-backdrop-background: rgba(0, 0, 0, 0.5);
    --me-backdrop-filter: none;

    display: contents;
    box-sizing: border-box;
  }

  :host *,
  :host *:after,
  :host *:before {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden] {
    display: none !important;
  }

  /* Dialog */
  .dialog {
    --dialog-placement-margin: calc((2em + 6px) / 2);

    width: var(--me-width);
    height: var(--me-height);
    padding: 0;
    border-color: var(--me-border-color);
    border-style: var(--me-border-style);
    border-width: var(--me-border-width);
    border-radius: var(--me-border-radius);
    box-shadow: var(--me-box-shadow);
    background-color: var(--me-background-color);
    color: var(--me-color);
  }

  .dialog[open] {
    display: flex;
  }

  :host([fullscreen]) .dialog {
    max-width: 100%;
    max-height: 100%;
    width: 100%;
    height: 100%;
  }

  .dialog::backdrop {
    background: var(--me-backdrop-background, rgba(0, 0, 0, 0.5));
    backdrop-filter: var(--me-backdrop-filter, none);
    opacity: 0;
  }

  .dialog[open]::backdrop {
    opacity: 1;
  }

  /* Dialog placement */
  :host(:not([fullscreen])[placement="top-start"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-center"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="top-end"]) .dialog {
    margin-block-start: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center-start"]) .dialog {
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="center"]) .dialog {
    margin: auto;
  }

  :host(:not([fullscreen])[placement="center-end"]) .dialog {
    margin-inline-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-start"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-start: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-center"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
  }

  :host(:not([fullscreen])[placement="bottom-end"]) .dialog {
    margin-block-end: var(--dialog-placement-margin);
    margin-inline-end: var(--dialog-placement-margin);
  }

  /* Dialog animations */
  @media (prefers-reduced-motion: no-preference) {
    .dialog:not(.dialog--no-animations),
    .dialog:not(.dialog--no-animations)::backdrop {
      transition: transform 0.3s, opacity 0.3s, display 0.3s allow-discrete, overlay 0.3s allow-discrete;
    }

    /* 1. IS-OPEN STATE */
    .dialog[open]:not(.dialog--no-animations) {
      transform: scale(1);
      opacity: 1;
    }

    /* 2. EXIT STATE */
    .dialog:not(.dialog--no-animations) {
      transform: scale(0.95);
      opacity: 0;
    }

    /* 0. BEFORE-OPEN STATE */
    @starting-style {
      .dialog[open]:not(.dialog--no-animations) {
        transform: scale(0.95);
        opacity: 0;
      }

      .dialog[open]:not(.dialog--no-animations)::backdrop {
        opacity: 0;
      }
    }

    .dialog--pulse:not(.dialog--no-animations) {
      animation-name: pulse;
      animation-duration: 300ms;
      animation-timing-function: cubic-bezier(0.2, 0, 0.38, 0.9);
    }

    @keyframes pulse {
      0% { transform: scale(1); }
      50% { transform: scale(1.02); }
      100% { transform: scale(1); }
    }
  }

  /* Dialog panel, header, body, footer */
  .dialog__panel {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    width: 100%;
  }

  .dialog__header {
    display: flex;
    align-items: center;
    padding: var(--me-header-spacing);
    column-gap: 0.5rem;
    background-color: var(--me-header-background-color);
    color: var(--me-header-color);
  }

  :host([no-close-button]) .dialog__header {
    column-gap: 0;
  }

  .dialog__title {
    display: block;
    flex: 1 1 auto;
    padding: 0;
    margin: 0;
  }

  .dialog__body {
    display: block;
    flex: 1 1 auto;
    padding: var(--me-body-spacing);
    overflow: auto;
    background-color: var(--me-body-background-color);
    color: var(--me-body-color);
    overscroll-behavior: contain;
  }

  .dialog__footer {
    flex: 0 0 auto;
    text-align: end;
    padding: var(--me-footer-spacing);
    background-color: var(--me-footer-background-color);
    color: var(--me-footer-color);
  }

  .dialog__close {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: var(--me-close-padding);
    border: var(--me-close-border);
    border-radius: var(--me-close-border-radius);
    background-color: var(--me-close-background-color);
    color: var(--me-close-color);
    font-size: var(--me-close-font-size);
  }

  .dialog__close:not(:disabled) {
    cursor: pointer;
  }

  .dialog__close:disabled {
    cursor: not-allowed;
  }
`;
$d9c5053bade2d3f8$var$a.innerHTML = `
  <style>${$d9c5053bade2d3f8$var$r}</style>

  <dialog part="base" class="dialog">
    <div part="panel" class="dialog__panel" aria-labelledby="title">
      <header part="header" class="dialog__header">
        <slot name="header" part="title" class="dialog__title" id="title"></slot>

        <form method="dialog">
          <button type="submit" part="close" class="dialog__close" aria-label="Close">
            <slot name="close">
              <svg part="close-icon" xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
              </svg>
            </slot>
          </button>
        </form>
      </header>

      <slot part="body" class="dialog__body"></slot>

      <footer part="footer" class="dialog__footer" hidden>
        <slot name="footer"></slot>
      </footer>
    </div>
  </dialog>
`;
var $d9c5053bade2d3f8$export$32589115725b904b = class s extends HTMLElement {
    #e = null;
    #a = null;
    #s = null;
    #o = void 0;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($d9c5053bade2d3f8$var$a.content.cloneNode(!0)), this.shadowRoot && (this.#e = this.shadowRoot.querySelector("dialog"), this.#a = this.shadowRoot.querySelector('slot[name="footer"]'), this.#s = this.shadowRoot.querySelector('slot[name="close"]'));
    }
    static get observedAttributes() {
        return [
            "open",
            "no-header",
            "no-animations",
            "no-close-button",
            "close-label"
        ];
    }
    attributeChangedCallback(e, t, i) {
        if (this.#e !== null) {
            if (e === "open" && t !== i && (this.open ? (this.#e.showModal(), this.dispatchEvent(new CustomEvent("me-open", {
                bubbles: !0,
                composed: !0,
                detail: {
                    element: this
                }
            })), document.body && !this.preserveOverflow && (document.body.style.overflow = "hidden")) : this.#e.close()), e === "no-header" && t !== i) {
                let o = this.#e.querySelector(".dialog__header");
                o !== null && (o.hidden = this.noHeader);
            }
            if (e === "no-animations" && t !== i && this.#e.classList.toggle("dialog--no-animations", this.noAnimations), e === "no-close-button" && t !== i) {
                let o = this.#e.querySelector(".dialog__close");
                o !== null && (o.hidden = this.noCloseButton);
            }
            e === "close-label" && t !== i && this.#r();
        }
    }
    connectedCallback() {
        this.#t("open"), this.#t("staticBackdrop"), this.#t("noHeader"), this.#t("noAnimations"), this.#t("noCloseButton"), this.#t("fullscreen"), this.#t("preserveOverflow"), this.#t("placement"), this.#t("closeLabel"), this.#e?.addEventListener("click", this.#h), this.#e?.addEventListener("close", this.#l), this.#e?.addEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.addEventListener("submit", this.#c), this.#a?.addEventListener("slotchange", this.#g), this.#s?.addEventListener("slotchange", this.#u), this.addEventListener("command", this.#m);
    }
    disconnectedCallback() {
        this.#o && clearTimeout(this.#o), this.#e?.addEventListener("click", this.#h), this.#e?.removeEventListener("close", this.#l), this.#e?.removeEventListener("cancel", this.#d), this.#e?.querySelector('form[method="dialog"]')?.removeEventListener("submit", this.#c), this.#a?.removeEventListener("slotchange", this.#g), this.#s?.removeEventListener("slotchange", this.#u), this.removeEventListener("command", this.#m);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(e) {
        this.toggleAttribute("open", !!e);
    }
    get staticBackdrop() {
        return this.hasAttribute("static-backdrop");
    }
    set staticBackdrop(e) {
        this.toggleAttribute("static-backdrop", !!e);
    }
    get noHeader() {
        return this.hasAttribute("no-header");
    }
    set noHeader(e) {
        this.toggleAttribute("no-header", !!e);
    }
    get noAnimations() {
        return this.hasAttribute("no-animations");
    }
    set noAnimations(e) {
        this.toggleAttribute("no-animations", !!e);
    }
    get noCloseButton() {
        return this.hasAttribute("no-close-button");
    }
    set noCloseButton(e) {
        this.toggleAttribute("no-close-button", !!e);
    }
    get fullscreen() {
        return this.hasAttribute("fullscreen");
    }
    set fullscreen(e) {
        this.toggleAttribute("fullscreen", !!e);
    }
    get preserveOverflow() {
        return this.hasAttribute("preserve-overflow");
    }
    set preserveOverflow(e) {
        this.toggleAttribute("preserve-overflow", !!e);
    }
    get placement() {
        return this.getAttribute("placement") || "center";
    }
    set placement(e) {
        this.setAttribute("placement", e != null ? e.toString() : e);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(e) {
        this.setAttribute("close-label", e != null ? e.toString() : e);
    }
    #r() {
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__close");
        if (e === null) return;
        (this.#s?.assignedElements() || [])?.some((o)=>o.textContent?.replace(/\s/g, "") !== "") ? e.removeAttribute("aria-label") : e.setAttribute("aria-label", this.closeLabel);
    }
    #i() {
        this.#o || (this.#e?.classList.add("dialog--pulse"), this.#o = setTimeout(()=>{
            this.#e?.classList.remove("dialog--pulse"), clearTimeout(this.#o), this.#o = void 0;
        }, 300));
    }
    #l = ()=>{
        this.open = !1, this.dispatchEvent(new CustomEvent("me-close", {
            bubbles: !0,
            composed: !0,
            detail: {
                element: this
            }
        })), document.body && !this.preserveOverflow && (document.body.style.overflow = "");
    };
    #d = (e)=>{
        let t = this.#n("escape-key");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#i());
    };
    #c = (e)=>{
        let t = this.#n("close-button");
        this.dispatchEvent(t), t.defaultPrevented && (e.preventDefault(), !this.noAnimations && this.#i());
    };
    #h = (e)=>{
        let t = e.target, i = e.currentTarget;
        if (t === i) {
            let o = this.#n("backdrop-click");
            this.dispatchEvent(o), o.defaultPrevented || this.staticBackdrop ? !this.noAnimations && this.#i() : this.hide();
        }
        if (t instanceof HTMLElement && t.closest("[data-me-close]") !== null) {
            let o = this.#n("external-invoker");
            this.dispatchEvent(o), o.defaultPrevented ? !this.noAnimations && this.#i() : this.hide();
        }
    };
    #m = (e)=>{
        if (e.command === "--me-open" && !this.open && this.show(), e.command === "--me-close" && this.open) {
            let t = this.#n("external-invoker");
            this.dispatchEvent(t), t.defaultPrevented ? !this.noAnimations && this.#i() : this.hide();
        }
    };
    #g = ()=>{
        if (this.#e === null) return;
        let e = this.#e.querySelector(".dialog__footer");
        if (e === null) return;
        let t = this.#a?.assignedNodes(), i = t ? t.length > 0 : !1;
        e.hidden = !i;
    };
    #u = ()=>{
        this.#r();
    };
    #n(e) {
        return new CustomEvent("me-request-close", {
            bubbles: !0,
            composed: !0,
            cancelable: !0,
            detail: {
                reason: e,
                element: this
            }
        });
    }
    #t(e) {
        let t = this;
        if (Object.prototype.hasOwnProperty.call(t, e)) {
            let i = t[e];
            delete t[e], t[e] = i;
        }
    }
    show() {
        this.open || (this.open = !0);
    }
    hide() {
        this.open && (this.open = !1);
    }
    static defineCustomElement(e = "modal-element") {
        typeof window < "u" && !window.customElements.get(e) && window.customElements.define(e, s);
    }
};
$d9c5053bade2d3f8$export$32589115725b904b.defineCustomElement();


/*!
 * @georapbox/alert-element
 * A custom HTML element for displaying dismissible alerts and toast notifications
 *
 * @version 1.0.1
 * @homepage https://github.com/georapbox/alert-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $92e4d942855edcf9$var$f() {
    let a = Object.assign(document.createElement("div"), {
        className: "alert-toast-stack"
    }), t = a.attachShadow({
        mode: "open"
    }), e = `
    :host {
      display: contents;
      box-sizing: border-box;
    }

    :host *,
    :host *::before,
    :host *::after {
      box-sizing: inherit;
    }

    .stack {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 1000;
      width: 30rem;
      max-width: 100%;
      max-height: 100%;
      overflow: auto;
      scrollbar-width: none;
    }

    @media (prefers-reduced-motion: no-preference) {
      .stack {
        scroll-behavior: smooth;
      }
    }

    .stack > ::slotted(*) {
      margin: 1rem;
    }
  `;
    return t.innerHTML = `
    <style>${e}</style>
    <div class="stack" part="base"><slot></slot></div>
  `, a;
}
var $92e4d942855edcf9$var$u = "alert-element", $92e4d942855edcf9$var$p = "alert-show", $92e4d942855edcf9$var$m = "alert-after-show", $92e4d942855edcf9$var$v = "alert-hide", $92e4d942855edcf9$var$l = "alert-after-hide", $92e4d942855edcf9$var$b = "--alert-show", $92e4d942855edcf9$var$E = "--alert-hide", $92e4d942855edcf9$var$g = "user", $92e4d942855edcf9$var$_ = "timeout", $92e4d942855edcf9$var$h = "api";
var $92e4d942855edcf9$var$r = $92e4d942855edcf9$var$f(), $92e4d942855edcf9$var$w = `
  :host {
    display: contents;
    box-sizing: border-box;

    --alert-border-radius: 0.25rem;
    --alert-fg-color: #3f3f46;
    --alert-bg-color: #ffffff;
    --alert-border-color: #e4e4e7;
    --alert-info-variant-color: #0584c7;
    --alert-success-variant-color: #16a34a;
    --alert-neutral-variant-color: #52525b;
    --alert-warning-variant-color: #d87708;
    --alert-danger-variant-color: #dc2626;
  }

  @media (prefers-color-scheme: dark) {
    :host {
      --alert-fg-color: #b6b6be;
      --alert-bg-color: #252528;
      --alert-border-color: #36363a;
      --alert-info-variant-color: #27bbfc;
      --alert-success-variant-color: #3ae075;
      --alert-neutral-variant-color: #8e8e9a;
      --alert-warning-variant-color: #ffbd11;
      --alert-danger-variant-color: #fe5c5c;
    }
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  .alert {
    display: flex;
    align-items: center;
    margin: inherit;
    border: 1px solid var(--alert-border-color);
    border-top-width: 3px;
    border-radius: var(--alert-border-radius);
    background-color: var(--alert-bg-color);
  }

  :host([variant='info']) .alert {
    border-top-color: var(--alert-info-variant-color);
  }

  :host([variant='success']) .alert {
    border-top-color: var(--alert-success-variant-color);
  }

  :host([variant='neutral']) .alert {
    border-top-color: var(--alert-neutral-variant-color);
  }

  :host([variant='warning']) .alert {
    border-top-color: var(--alert-warning-variant-color);
  }

  :host([variant='danger']) .alert {
    border-top-color: var(--alert-danger-variant-color);
  }

  .alert__icon {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    color: var(--alert-fg-color);
    font-size: inherit;
    line-height: 0;
  }

  .alert__icon ::slotted(*) {
    margin-inline-start: 1rem;
  }

  :host([variant='info']) .alert__icon {
    color: var(--alert-info-variant-color);
  }

  :host([variant='success']) .alert__icon {
    color: var(--alert-success-variant-color);
  }

  :host([variant='neutral']) .alert__icon {
    color: var(--alert-neutral-variant-color);
  }

  :host([variant='warning']) .alert__icon {
    color: var(--alert-warning-variant-color);
  }

  :host([variant='danger']) .alert__icon {
    color: var(--alert-danger-variant-color);
  }

  .alert__message {
    flex: 1 1 auto;
    padding: 1.25rem;
    overflow: hidden;
    color: var(--alert-fg-color);
    line-height: 1.5;
  }

  .alert__close {
    display: flex;
    align-items: center;
    margin-inline-end:  1rem;
    padding: 0.5rem;
    border: none;
    line-height: 0;
    background: transparent;
    color: var(--alert-fg-color);
    font-size: inherit;
    cursor: pointer;
  }

  :host(:not([closable])) .alert__close {
    display: none !important;
  }
`, $92e4d942855edcf9$var$A = document.createElement("template");
$92e4d942855edcf9$var$A.innerHTML = `
  <style>${$92e4d942855edcf9$var$w}</style>
  <div class="alert" part="base" role="alert" hidden>
    <div class="alert__icon" part="icon">
      <slot name="icon"></slot>
    </div>
    <div class="alert__message" part="message" aria-live="polite">
      <slot></slot>
    </div>
    <button type="button" class="alert__close" part="close" aria-label="Close">
      <slot name="close">
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
          <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z"/>
        </svg>
      </slot>
    </button>
  </div>
`;
var $92e4d942855edcf9$export$d43a820132db491 = class a extends HTMLElement {
    #t = null;
    #o = null;
    #a = null;
    #n = void 0;
    #e = null;
    #u;
    static customAnimations;
    #s = $92e4d942855edcf9$var$h;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($92e4d942855edcf9$var$A.content.cloneNode(!0));
    }
    static get observedAttributes() {
        return [
            "open",
            "duration",
            "close-label"
        ];
    }
    attributeChangedCallback(t, e, o) {
        if (!(!this.isConnected || e === o)) switch(t){
            case "open":
                this.#_();
                break;
            case "duration":
                this.#i(), this.#c() && this.#l();
                break;
            case "close-label":
                this.#d();
                break;
            default:
                break;
        }
    }
    get closable() {
        return this.hasAttribute("closable");
    }
    set closable(t) {
        this.toggleAttribute("closable", !!t);
    }
    get open() {
        return this.hasAttribute("open");
    }
    set open(t) {
        this.toggleAttribute("open", !!t);
    }
    get duration() {
        let t = this.getAttribute("duration");
        if (t === null) return 1 / 0;
        let e = Number(t);
        return Number.isNaN(e) ? 1 / 0 : e;
    }
    set duration(t) {
        this.setAttribute("duration", t != null ? t.toString() : t);
    }
    get variant() {
        return this.getAttribute("variant") || "";
    }
    set variant(t) {
        this.setAttribute("variant", t);
    }
    get closeLabel() {
        return this.getAttribute("close-label") || "Close";
    }
    set closeLabel(t) {
        this.setAttribute("close-label", t != null ? t.toString() : t);
    }
    get customAnimations() {
        return this.#u;
    }
    set customAnimations(t) {
        this.#u = t;
    }
    connectedCallback() {
        this.#r("closable"), this.#r("open"), this.#r("duration"), this.#r("variant"), this.#r("closeLabel"), this.#r("customAnimations"), this.#t = this.shadowRoot?.querySelector(".alert") ?? null, this.#o = this.shadowRoot?.querySelector(".alert__close") ?? null, this.#a = this.shadowRoot?.querySelector('slot[name="close"]') ?? null, this.#o?.addEventListener("click", this.#m), this.#a?.addEventListener("slotchange", this.#v), this.addEventListener("mouseenter", this.#f), this.addEventListener("mouseleave", this.#p), this.addEventListener("command", this.#b), this.open ? (this.#t?.removeAttribute("hidden"), this.#c() && this.#l()) : this.#t?.setAttribute("hidden", ""), this.closeLabel && this.#d();
    }
    disconnectedCallback() {
        this.#i(), this.#o?.removeEventListener("click", this.#m), this.#a?.removeEventListener("slotchange", this.#v), this.removeEventListener("mouseenter", this.#f), this.removeEventListener("mouseleave", this.#p), this.removeEventListener("command", this.#b);
    }
    #_() {
        this.#i(), this.open ? (this.#c() && this.#l(), this.#t?.removeAttribute("hidden"), this.#h($92e4d942855edcf9$var$p), this.#A(this.#t)?.finished.finally(()=>{
            this.#h($92e4d942855edcf9$var$m);
        })) : (this.#h($92e4d942855edcf9$var$v, {
            reason: this.#s
        }), this.#w(this.#t)?.finished.finally(()=>{
            this.#t?.setAttribute("hidden", ""), this.#h($92e4d942855edcf9$var$l, {
                reason: this.#s
            }), this.#s = $92e4d942855edcf9$var$h;
        }));
    }
    #i() {
        this.#n !== void 0 && (clearTimeout(this.#n), this.#n = void 0);
    }
    #l() {
        this.#n = window.setTimeout(()=>{
            this.#s = $92e4d942855edcf9$var$_, this.open = !1;
        }, this.duration);
    }
    #c() {
        return this.open && this.duration !== 1 / 0;
    }
    #m = ()=>{
        this.closable && (this.#s = $92e4d942855edcf9$var$g, this.open = !1);
    };
    #f = ()=>{
        this.#i();
    };
    #p = ()=>{
        this.#i(), this.#c() && this.#l();
    };
    #v = ()=>{
        this.#d();
    };
    #b = (t)=>{
        switch(t.command){
            case $92e4d942855edcf9$var$b:
                this.open = !0;
                break;
            case $92e4d942855edcf9$var$E:
                this.#s = $92e4d942855edcf9$var$h, this.open = !1;
                break;
            default:
                break;
        }
    };
    #d() {
        if (!this.#o) return;
        (this.#a?.assignedElements() || [])?.some((o)=>o.textContent?.replace(/\s/g, "") !== "") ? this.#o.removeAttribute("aria-label") : this.#o.setAttribute("aria-label", this.closeLabel);
    }
    #E() {
        let t = window.matchMedia("(prefers-reduced-motion: reduce)").matches, e = {
            show: {
                keyframes: [
                    {
                        opacity: 0,
                        transform: "scale(0.9)"
                    },
                    {
                        opacity: 1,
                        transform: "scale(1)"
                    }
                ],
                options: {
                    duration: 250,
                    easing: "ease"
                }
            },
            hide: {
                keyframes: [
                    {
                        opacity: 1,
                        transform: "scale(1)"
                    },
                    {
                        opacity: 0,
                        transform: "scale(0.9)"
                    }
                ],
                options: {
                    duration: 250,
                    easing: "ease"
                }
            }
        }, o = this.customAnimations || a.customAnimations || {}, s = (i)=>{
            let n = o[i]?.options ?? {}, c = e[i].options;
            return {
                ...c,
                ...n,
                duration: t || this.customAnimations === null || a.customAnimations === null ? 0 : n.duration ?? c.duration
            };
        };
        return {
            show: {
                keyframes: o.show?.keyframes ?? e.show.keyframes,
                options: s("show")
            },
            hide: {
                keyframes: o.hide?.keyframes ?? e.hide.keyframes,
                options: s("hide")
            }
        };
    }
    #A(t) {
        let { keyframes: e, options: o } = this.#E().show;
        return t?.animate(e, o);
    }
    #w(t) {
        let { keyframes: e, options: o } = this.#E().hide;
        return t?.animate(e, o);
    }
    #h(t, e = null) {
        let o = {
            bubbles: !0,
            composed: !0,
            detail: e
        }, s = new CustomEvent(t, o);
        this.dispatchEvent(s);
    }
    #g(t, e) {
        return new Promise((o)=>{
            let s = (i)=>{
                i.target === t && o();
            };
            t.addEventListener(e, s, {
                once: !0
            });
        });
    }
    show() {
        return this.open ? Promise.resolve() : (this.open = !0, this.#g(this, $92e4d942855edcf9$var$m));
    }
    hide() {
        return this.open ? (this.open = !1, this.#g(this, $92e4d942855edcf9$var$l)) : Promise.resolve();
    }
    toast(t = {}) {
        if (t = {
            forceRestart: !1,
            ...t
        }, this.#e) {
            if (!t.forceRestart) return this.#e.promise;
            this.#e.resolve(), this.#e.cleanup();
        }
        let o = ()=>{}, s = new Promise((c)=>o = c), i = ()=>{
            this.#e?.resolve(), this.#e?.cleanup();
        };
        this.#e = {
            promise: s,
            resolve: o,
            cleanup: ()=>{
                this.removeEventListener($92e4d942855edcf9$var$l, i), this.parentNode === $92e4d942855edcf9$var$r && $92e4d942855edcf9$var$r.removeChild(this), $92e4d942855edcf9$var$r.querySelector($92e4d942855edcf9$var$u) || $92e4d942855edcf9$var$r.remove(), this.open = !1, this.#e = null;
            }
        }, $92e4d942855edcf9$var$r.parentElement || document.body.append($92e4d942855edcf9$var$r), $92e4d942855edcf9$var$r.appendChild(this), this.#t?.setAttribute("data-toast", ""), this.open = !0;
        let n = $92e4d942855edcf9$var$r.shadowRoot?.querySelector(".stack");
        return n?.scrollTo({
            top: n.scrollHeight
        }), this.addEventListener($92e4d942855edcf9$var$l, i, {
            once: !0
        }), s;
    }
    #r(t) {
        let e = this;
        if (Object.prototype.hasOwnProperty.call(e, t)) {
            let o = e[t];
            delete e[t], e[t] = o;
        }
    }
    static defineCustomElement(t = $92e4d942855edcf9$var$u) {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, a);
    }
};
$92e4d942855edcf9$export$d43a820132db491.defineCustomElement();


const $65136e012e05e2d7$export$d726fc97fa83318d = 'experimental';
const $65136e012e05e2d7$export$63e7bed68b07a85c = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/apng',
    'image/gif',
    'image/webp',
    'image/avif'
];
const $65136e012e05e2d7$export$de9c958f6873b048 = 30000; // 30 seconds
const $65136e012e05e2d7$export$bcfc9cb4df0e0590 = 3;
const $65136e012e05e2d7$export$90b50795b902d1b4 = 300000; // 5 minutes before expiry
const $65136e012e05e2d7$export$d41d2f17218678e7 = 1000; // milliseconds between scans
const $65136e012e05e2d7$export$6fa442c45400f9a = 5000; // milliseconds
const $65136e012e05e2d7$export$1ec3328eed0aedd9 = 250; // milliseconds
const $65136e012e05e2d7$export$a236ec278a617d1d = 500; // milliseconds
const $65136e012e05e2d7$export$5aae9b6b3e0e7094 = {
    CLIENT_ID: 'clientId',
    DOSSIER_ID: 'dossierId',
    TOKEN: 'barcode-scanner/api-token',
    TOKEN_EXPIRY: 'barcode-scanner/api-token-expiry',
    SETTINGS: 'barcode-scanner/settings',
    HISTORY: 'barcode-scanner/history'
};
const $65136e012e05e2d7$export$69d25b90d0002cf3 = {
    NETWORK_ERROR: "Erreur de connexion. Veuillez v\xe9rifier votre connexion internet.",
    TIMEOUT_ERROR: "La requ\xeate a expir\xe9. Veuillez r\xe9essayer.",
    AUTH_ERROR: "Session expir\xe9e. Veuillez vous reconnecter.",
    PRODUCT_NOT_FOUND: "Produit non trouv\xe9.",
    CLIENT_NOT_FOUND: "Client non trouv\xe9.",
    DOSSIER_NOT_FOUND: "Dossier non trouv\xe9.",
    DOSSIER_CREATE_ERROR: "Erreur lors de la cr\xe9ation du dossier.",
    DOSSIER_UPDATE_ERROR: "Erreur lors de la mise \xe0 jour du dossier.",
    DOSSIER_MISMATCH: "Le dossier est associ\xe9 \xe0 un autre client.",
    VALIDATION_REQUIRED: "Veuillez d'abord valider un client.",
    INVALID_RESPONSE: "R\xe9ponse du serveur invalide.",
    EMPTY_RESPONSE: "Le serveur a retourn\xe9 une r\xe9ponse vide.",
    EMPTY_CLIENT_ID: "Veuillez entrer un num\xe9ro de client.",
    EMPTY_DOSSIER_ID: "Veuillez entrer un num\xe9ro de dossier.",
    MISSING_DOSSIER_PRODUCT_ID: "ID de produit de dossier non trouv\xe9.",
    CONFIRM_DELETE_PRODUCT: "\xcates-vous s\xfbr de vouloir supprimer ce produit ?",
    CONFIRM_EDIT_CUSTOMER: "\xcates-vous s\xfbr de vouloir modifier le num\xe9ro de client ?",
    CONFIRM_EDIT_DOSSIER: "\xcates-vous s\xfbr de vouloir modifier le num\xe9ro de dossier ?",
    CONFIRM_END_SESSION: "\xcates-vous s\xfbr de vouloir terminer la session de scan en cours ?",
    SCAN_ERROR: "Erreur lors du scan. Veuillez r\xe9essayer.",
    CAMERA_PERMISSION_DENIED: "Permission d'acc\xe8s \xe0 la cam\xe9ra refus\xe9e.",
    CAMERA_NOT_FOUND: "Aucune cam\xe9ra trouv\xe9e.",
    UNKNOWN_ERROR: 'Une erreur inattendue est survenue.'
};


function $dc2f4a51b83babfd$var$_slicedToArray(r, e) {
    return $dc2f4a51b83babfd$var$_arrayWithHoles(r) || $dc2f4a51b83babfd$var$_iterableToArrayLimit(r, e) || $dc2f4a51b83babfd$var$_unsupportedIterableToArray(r, e) || $dc2f4a51b83babfd$var$_nonIterableRest();
}
function $dc2f4a51b83babfd$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $dc2f4a51b83babfd$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $dc2f4a51b83babfd$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $dc2f4a51b83babfd$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $dc2f4a51b83babfd$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $dc2f4a51b83babfd$export$b327150396135fe7(request) {
    return new Promise(function(resolve, reject) {
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = function() {
            return resolve(request.result);
        };
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = function() {
            return reject(request.error);
        };
    });
}
function $dc2f4a51b83babfd$export$f51a9068ac82ea43(dbName, storeName) {
    var dbp;
    var getDB = function getDB() {
        if (dbp) return dbp;
        var request = indexedDB.open(dbName);
        request.onupgradeneeded = function() {
            return request.result.createObjectStore(storeName);
        };
        dbp = $dc2f4a51b83babfd$export$b327150396135fe7(request);
        dbp.then(function(db) {
            // It seems like Safari sometimes likes to just close the connection.
            // It's supposed to fire this event when that happens. Let's hope it does!
            db.onclose = function() {
                return dbp = undefined;
            };
        }, function() {});
        return dbp;
    };
    return function(txMode, callback) {
        return getDB().then(function(db) {
            return callback(db.transaction(storeName, txMode).objectStore(storeName));
        });
    };
}
var $dc2f4a51b83babfd$var$defaultGetStoreFunc;
function $dc2f4a51b83babfd$var$defaultGetStore() {
    if (!$dc2f4a51b83babfd$var$defaultGetStoreFunc) $dc2f4a51b83babfd$var$defaultGetStoreFunc = $dc2f4a51b83babfd$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $dc2f4a51b83babfd$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3988ae62b71be9a3(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
    });
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$adaa4cf7ef1b65be(key, value) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.put(value, key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$daa0a5170277c7a8(entries) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        entries.forEach(function(entry) {
            return store.put(entry[1], entry[0]);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$5df405cccea42673(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        return Promise.all(keys.map(function(key) {
            return $dc2f4a51b83babfd$export$b327150396135fe7(store.get(key));
        }));
    });
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$722fbec263ad908a(key, updater) {
    var customStore = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        return(// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise(function(resolve, reject) {
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($dc2f4a51b83babfd$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
    });
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$1d2f21e549771e67(key) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.delete(key);
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$c8aa84257229cac8(keys) {
    var customStore = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        keys.forEach(function(key) {
            return store.delete(key);
        });
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$42ffd38884aecdac() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readwrite', function(store) {
        store.clear();
        return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
    });
}
function $dc2f4a51b83babfd$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $dc2f4a51b83babfd$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$ed97f33186d4b816() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAllKeys) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.key);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$68c286be0e7e55b7() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        if (store.getAll) return $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll());
        var items = [];
        return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
            return items.push(cursor.value);
        }).then(function() {
            return items;
        });
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $dc2f4a51b83babfd$export$3e9f948b41964866() {
    var customStore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : $dc2f4a51b83babfd$var$defaultGetStore();
    return customStore('readonly', function(store) {
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAllKeys()),
            $dc2f4a51b83babfd$export$b327150396135fe7(store.getAll())
        ]).then(function(_ref) {
            var _ref2 = $dc2f4a51b83babfd$var$_slicedToArray(_ref, 2), keys = _ref2[0], values = _ref2[1];
            return keys.map(function(key, i) {
                return [
                    key,
                    values[i]
                ];
            });
        });
        var items = [];
        return customStore('readonly', function(store) {
            return $dc2f4a51b83babfd$var$eachCursor(store, function(cursor) {
                return items.push([
                    cursor.key,
                    cursor.value
                ]);
            }).then(function() {
                return items;
            });
        });
    });
}


const $0eb43b201e9f90c7$var$STORAGE_PREFIX = 'barcode-scanner/';
const $0eb43b201e9f90c7$var$SETTINGS_STORAGE_KEY = 'settings';
const $0eb43b201e9f90c7$var$HISTORY_STORAGE_KEY = 'history';
/**
 * Gets an item from the storage.
 *
 * @param {string} key - The key to get the item from.
 * @returns {Promise<[ error: any, value: any ]>} The item and an error if occurred.
 */ const $0eb43b201e9f90c7$var$getItem = async (key)=>{
    try {
        return [
            null,
            await (0, $dc2f4a51b83babfd$export$3988ae62b71be9a3)(key)
        ];
    } catch (error) {
        return [
            error,
            void 0
        ];
    }
};
/**
 * Sets an item in the storage.
 *
 * @param {string} key - The key to set the item to.
 * @param {any} data - The data to set.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */ const $0eb43b201e9f90c7$var$setItem = async (key, data)=>{
    try {
        await (0, $dc2f4a51b83babfd$export$adaa4cf7ef1b65be)(key, data);
        return [
            null
        ];
    } catch (error) {
        return [
            error
        ];
    }
};
/**
 * Deletes an item from the storage.
 *
 * @param {string} key - The key to delete the item from.
 * @returns {Promise<[ error: any ]>} An error if occurred.
 */ const $0eb43b201e9f90c7$var$deleteItem = async (key)=>{
    try {
        await (0, $dc2f4a51b83babfd$export$1d2f21e549771e67)(key);
        return [
            null
        ];
    } catch (error) {
        return [
            error
        ];
    }
};
const $0eb43b201e9f90c7$export$4a647155031ece = async ()=>{
    return $0eb43b201e9f90c7$var$getItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$SETTINGS_STORAGE_KEY);
};
const $0eb43b201e9f90c7$export$dc86d17a64679bc7 = async (data)=>{
    return $0eb43b201e9f90c7$var$setItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$SETTINGS_STORAGE_KEY, data);
};
const $0eb43b201e9f90c7$export$f9582a3c130d9538 = async ()=>{
    return $0eb43b201e9f90c7$var$getItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$HISTORY_STORAGE_KEY);
};
const $0eb43b201e9f90c7$export$96fe1132eb44c325 = async (data)=>{
    return $0eb43b201e9f90c7$var$setItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$HISTORY_STORAGE_KEY, data);
};
const $0eb43b201e9f90c7$export$b969c7435cea2ca6 = async ()=>{
    await $0eb43b201e9f90c7$var$deleteItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$HISTORY_STORAGE_KEY);
    await $0eb43b201e9f90c7$var$deleteItem($0eb43b201e9f90c7$var$STORAGE_PREFIX + $0eb43b201e9f90c7$var$SETTINGS_STORAGE_KEY);
    // We should also clear any other session-related data here
    localStorage.removeItem('dossierNumber');
    document.getElementById('scanned-items-container').innerHTML = '';
    document.querySelector('#global-total span').textContent = '0.00';
    document.getElementById('dossier-display').textContent = '';
    document.getElementById('dossier-input-container').hidden = false;
    document.getElementById('dossier-display-container').hidden = true;
};


/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * 'n' milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing.
 *
 * @param {function} fn The function to be executed.
 * @param {Number} [wait=0] Time of delay in milliseconds. It is required if `immediate` is used.
 * @param {Boolean} [immediate=false] If true or any truthy value, triggers the function on the leading edge.
 * @throws {TypeError} If `fn` is not function.
 * @returns {function} A new debounced function.
 * @example
 *
 * const debouncedHandler = debounce(() => {
 *   // Do your thing here...
 * }, 250);
 *
 * window.addEventListener('resize', debouncedHandler, false);
 */ function $4481690a5b2e12d6$export$61fc7d43ac8f84b0(fn, wait = 0, immediate = false) {
    let timerId = null;
    if (typeof fn !== 'function') throw new TypeError('Expected a function for first argument');
    return (...args)=>{
        clearTimeout(timerId);
        if (immediate && !timerId) fn(...args);
        timerId = setTimeout(()=>{
            timerId = null;
            if (!immediate) fn(...args);
        }, wait);
    };
}


const $6dda9643863448b4$var$isDevelopment = false;
const $6dda9643863448b4$export$bef1f36f5486a6a3 = {
    info: (...args)=>{
        $6dda9643863448b4$var$isDevelopment && console.log(...args);
    },
    error: (...args)=>{
        console.error(...args);
    },
    warn: (...args)=>{
        console.warn(...args);
    }
};


/**
 * Check if the dialog element is supported.
 *
 * @returns {boolean} - Returns true if the dialog element is supported.
 */ function $2d4d0eca101a8031$export$c694186e9d94f0() {
    return typeof HTMLDialogElement === 'function';
}


/**
 * Resizes the scan frame to match the video element's dimensions.
 *
 * @param {HTMLVideoElement} videoEl - Video element
 * @param {HTMLElement} scanFrameEl - Scan frame element
 */ function $451e357ed50655d6$export$1404f0e91c73fec(videoEl, scanFrameEl) {
    if (!videoEl || !scanFrameEl) return;
    const rect = videoEl.getBoundingClientRect();
    scanFrameEl.style.cssText = `width: ${rect.width}px; height: ${rect.height}px`;
}



// https://developer.mozilla.org/en-US/docs/Web/API/Barcode_Detection_API#supported_barcode_formats
const $8510600959e31c2c$var$WHITELISTED_FORMATS = [
    'aztec',
    'code_128',
    'code_39',
    'code_93',
    'codabar',
    'data_matrix',
    'ean_13',
    'ean_8',
    'itf',
    'pdf417',
    'qr_code',
    'upc_a',
    'upc_e'
];

/**
 * BarcodeReader class to detect barcodes from images or videos.
 *
 * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector
 */ class $8510600959e31c2c$export$f21d9483ebeee00a {
    static async polyfill() {
        if (!('BarcodeDetector' in window)) try {
            console.log('Loading BarcodeDetector polyfill...');
            await (parcelRequire("3jPiW"));
            console.log('BarcodeDetector polyfill loaded successfully');
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Using BarcodeDetector polyfill.');
        } catch (error) {
            console.error('Failed to load BarcodeDetector polyfill:', error);
            throw new Error('BarcodeDetector API is not supported by your browser.', {
                cause: error
            });
        }
        else (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Using the native BarcodeDetector API.');
    }
    /**
   * Get the supported barcode formats.
   *
   * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector/getSupportedFormats
   * @returns {Promise<Array<string>>} - Supported barcode formats
   */ static async getSupportedFormats() {
        const nativeSupportedFormats = await window.BarcodeDetector.getSupportedFormats() || [];
        const filteredFormats = $8510600959e31c2c$var$WHITELISTED_FORMATS.filter((format)=>nativeSupportedFormats.includes(format));
        //console.log('Native supported formats:', nativeSupportedFormats);
        return filteredFormats;
    }
    /**
   * Create a new BarcodeReader instance.
   *
   * @param {Array<string>} supportedFormats - Supported barcode formats
   * @returns {Promise<BarcodeReader>} - New BarcodeReader instance
   */ static async create(supportedFormats) {
        const isValidFormats = Array.isArray(supportedFormats) && supportedFormats.length > 0;
        const formats = isValidFormats ? supportedFormats : await $8510600959e31c2c$export$f21d9483ebeee00a.getSupportedFormats();
        return new $8510600959e31c2c$export$f21d9483ebeee00a(formats);
    }
    /**
   * Sets up BarcodeReader by polyfilling the BarcodeDetector API if needed.
   *
   * @returns {Promise<{ barcodeReaderError: Error }>} - BarcodeReader setup result
   */ static async setup() {
        try {
            await $8510600959e31c2c$export$f21d9483ebeee00a.polyfill();
            return {
                barcodeReaderError: null
            };
        } catch (error) {
            return {
                barcodeReaderError: error
            };
        }
    }
    /**
   * Create a new BarcodeReader instance.
   *
   * @param {Array<string>} formats - Supported barcode formats
   */ constructor(formats){
        this.barcodeReader = new window.BarcodeDetector({
            formats: formats
        });
    }
    /**
   * Detect barcodes from the provided source.
   *
   * @see https://developer.mozilla.org/docs/Web/API/BarcodeDetector/detect
   * @param {HTMLImageElement|HTMLVideoElement|ImageBitmap} source - Image or video element or ImageBitmap
   * @returns {Promise<BarcodeDetection>} - Barcode detection result
   */ async detect(source) {
        if (!this.barcodeReader) throw new Error('BarcodeReader is not initialized.');
        const results = await this.barcodeReader.detect(source);
        if (Array.isArray(results) && results.length > 0) {
            const firstResult = results[0];
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info({
                rawValue: firstResult.rawValue,
                format: firstResult.format
            });
            return firstResult;
        } else throw new Error('Could not detect barcode from provided source.');
    }
}


/**
 * Toggles the torch button status.
 * The torch button has two icons, one for on and one for off.
 * This function toggles the visibility of the icons based on the torch state and updates the button title.
 *
 * @param {HTMLButtonElement} buttonEl - The torch button element.
 * @param {boolean} isTorchOn - The torch state.
 */ function $ac0619973d2d242a$export$d1bd0b12fe0d046(options = {}) {
    const defaults = {
        el: document.getElementById('torchButton'),
        isTorchOn: false
    };
    const { el: el, isTorchOn: isTorchOn } = {
        ...defaults,
        ...options
    };
    const iconPaths = el.querySelectorAll('svg path');
    if (iconPaths.length !== 2) return;
    iconPaths[0].style.display = isTorchOn ? 'none' : 'block';
    iconPaths[1].style.display = isTorchOn ? 'block' : 'none';
    el.setAttribute('aria-label', `Turn ${isTorchOn ? 'off' : 'on'} flash`);
}


/**
 * Displays a toast notification.
 *
 * @param {string} message - The message to display in the toast.
 * @param {Object} [options] - Options for the toast.
 * @param {number} [options.duration=5000] - Duration in milliseconds before the toast disappears.
 * @param {string} [options.variant='neutral'] - The variant of the toast (e.g., 'success', 'danger', 'info').
 * @param {boolean} [options.trustDangerousInnerHTML=false] - Whether to trust dangerous HTML in the message.
 * @returns {Promise<AlertElement>} - A promise that resolves to the alert element.
 */ function $0344530667b8f8fd$export$cbcbdc571577a620(message, options = {}) {
    const defaults = {
        duration: 5000,
        variant: 'neutral',
        icon: ''
    };
    options = {
        ...defaults,
        ...options
    };
    const icons = {
        info: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
        <path d="m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>
      </svg>
    `,
        success: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"/>
        <path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"/>
      </svg>
    `,
        warning: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z"/>
        <path d="M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z"/>
      </svg>
    `,
        danger: `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
        <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
      </svg>
    `
    };
    const icon = icons[options.icon || options.variant] || '';
    const alert = Object.assign(document.createElement('alert-element'), {
        closable: true,
        duration: options.duration,
        variant: options.variant,
        innerHTML: `${icon ? `<span slot="icon">${icon}</span>` : ''}${options.trustDangerousInnerHTML ? message : $0344530667b8f8fd$var$escapeHtml(message)}`
    });
    return alert.toast();
}
function $0344530667b8f8fd$var$escapeHtml(html) {
    const div = document.createElement('div');
    div.textContent = html;
    return div.innerHTML;
}


/**
 * Clamps number within the inclusive `min` and `max` bounds,
 * making sure it does not go beyond them on either side.
 * If `min` is greater than `max` the parameters are swapped to support inverted ranges.
 *
 * @param {number} value - The number to clamp.
 * @param {number} lower - The lower bound.
 * @param {number} upper - The upper bound.
 * @throws {TypeError} - If one or more of the arguments passed is not a number.
 * @returns {number} - The clamped number.
 * @example
 *
 * clamp(10, -5, 5);
 * // => 5
 *
 * clamp(-10, -5, 5);
 * // => -5
 *
 * clamp(-15, 0, 100);
 * // => 0
 *
 * clamp(120, 0, 100);
 * // => 100
 *
 * clamp(-5, NaN, 5); // If any of lower or upper bound are `NaN`, they will be converted to `0`.
 * // => 0
 *
 * clamp(120, 100, 0); // The order of lower and upper bounds is reversed (100 > 0)
 * // => 100
 */ function $f39ac7e49ce95944$export$7d15b64cf5a3a4c4(value, lower, upper) {
    if (Number.isNaN(lower)) lower = 0;
    if (Number.isNaN(upper)) upper = 0;
    return Math.min(Math.max(value, Math.min(lower, upper)), Math.max(lower, upper));
}


const $40cc5a5311c08f52$var$COMPONENT_NAME = 'video-capture';
const $40cc5a5311c08f52$var$styles = /* css */ `
  :host { display: block; box-sizing: border-box; }
  :host *, :host *::before, :host *::after { box-sizing: inherit;}
  :host([hidden]), [hidden], ::slotted([hidden]) { display: none; }
  video { display: block; }
  #output:empty { display: none; }
`;
const $40cc5a5311c08f52$var$template = document.createElement('template');
$40cc5a5311c08f52$var$template.innerHTML = /* html */ `
  <style>${$40cc5a5311c08f52$var$styles}</style>
  <video part="video" playsinline></video>
  <div part="actions-container"><slot name="actions"></slot></div>
  <slot></slot>
`;
class $40cc5a5311c08f52$export$682e9ed90a89bb4a extends HTMLElement {
    #supportedConstraints = {};
    #stream = null;
    #videoElement = null;
    constructor(){
        super();
        this.#supportedConstraints = this.getSupportedConstraints();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($40cc5a5311c08f52$var$template.content.cloneNode(true));
        }
    }
    static get observedAttributes() {
        return [
            'no-image',
            'pan',
            'tilt',
            'zoom',
            'torch'
        ];
    }
    /**
   * Lifecycle method that is called when attributes are changed, added, removed, or replaced.
   *
   * @param {string} name - The name of the attribute.
   * @param {string} oldValue - The old value of the attribute.
   * @param {string} newValue - The new value of the attribute.
   */ attributeChangedCallback(name, oldValue, newValue) {
        if (!this.isConnected) return;
        const trackCapabilities = this.getTrackCapabilities();
        if (name === 'zoom' && oldValue !== newValue && 'zoom' in this.#supportedConstraints) {
            const zoomInAllowedRange = 'zoom' in trackCapabilities && trackCapabilities.zoom?.min && trackCapabilities.zoom?.max ? this.zoom >= trackCapabilities.zoom.min && this.zoom <= trackCapabilities.zoom.max : false;
            if (typeof this.zoom === 'number' && zoomInAllowedRange) this.#applyConstraint('zoom', this.zoom);
        }
        if (name === 'torch' && oldValue !== newValue && 'torch' in this.#supportedConstraints) this.#applyConstraint('torch', this.torch);
    }
    /**
   * Lifecycle method that is called when the element is added to the DOM.
   */ async connectedCallback() {
        this.#upgradeProperty('autoPlay');
        this.#upgradeProperty('facingMode');
        this.#upgradeProperty('zoom');
        this.#upgradeProperty('torch');
        this.#videoElement = this.shadowRoot?.querySelector('video') || null;
        this.#videoElement?.addEventListener('loadedmetadata', this.#onVideoLoadedMetaData);
        if (!$40cc5a5311c08f52$export$682e9ed90a89bb4a.isSupported()) return this.dispatchEvent(new CustomEvent(`${$40cc5a5311c08f52$var$COMPONENT_NAME}:error`, {
            bubbles: true,
            composed: true,
            detail: {
                error: {
                    name: 'NotSupportedError',
                    message: 'Not supported'
                }
            }
        }));
        if (this.autoPlay) this.startVideoStream();
    }
    /**
   * Lifecycle method that is called when the element is removed from the DOM.
   */ disconnectedCallback() {
        this.stopVideoStream();
        this.#videoElement?.removeEventListener('loadedmetadata', this.#onVideoLoadedMetaData);
    }
    get autoPlay() {
        return this.hasAttribute('auto-play');
    }
    set autoPlay(value) {
        this.toggleAttribute('auto-play', !!value);
    }
    get facingMode() {
        const value = this.getAttribute('facing-mode');
        if (value !== 'user') return 'environment';
        return value;
    }
    set facingMode(value) {
        this.setAttribute('facing-mode', value);
    }
    get zoom() {
        return Number(this.getAttribute('zoom')) || 1;
    }
    set zoom(value) {
        this.setAttribute('zoom', value != null ? value.toString() : value);
    }
    get torch() {
        return this.hasAttribute('torch');
    }
    set torch(value) {
        this.toggleAttribute('torch', !!value);
    }
    get loading() {
        return this.hasAttribute('loading');
    }
    /**
   * Handles the loadedmetadata event of the video element.
   *
   * @param {Event} evt - The event object.
   */ #onVideoLoadedMetaData = (evt)=>{
        const video = evt.target;
        video.play().then(()=>{
            this.dispatchEvent(new CustomEvent(`${$40cc5a5311c08f52$var$COMPONENT_NAME}:video-play`, {
                bubbles: true,
                composed: true,
                detail: {
                    video: video
                }
            }));
        }).catch((error)=>{
            this.dispatchEvent(new CustomEvent(`${$40cc5a5311c08f52$var$COMPONENT_NAME}:error`, {
                bubbles: true,
                composed: true,
                detail: {
                    error: error
                }
            }));
        }).finally(()=>{
            this.removeAttribute('loading');
        });
    };
    /**
   * Applies a constraint to the video track.
   *
   * @param {string} constraint - The name of the constraint.
   * @param {any} value - The value of the constraint.
   */ #applyConstraint(constraint, value) {
        if (!this.#stream) return;
        const [track] = this.#stream.getVideoTracks();
        const trackCapabilities = this.getTrackCapabilities();
        const trackSettings = this.getTrackSettings();
        const constraintValue = constraint === 'pan' || constraint === 'tilt' || constraint === 'zoom' ? (0, $f39ac7e49ce95944$export$7d15b64cf5a3a4c4)(Number(value), trackCapabilities[constraint]?.min || 1, trackCapabilities[constraint]?.max || 1) : value;
        if (constraint in trackSettings) track.applyConstraints({
            advanced: [
                {
                    [constraint]: constraintValue
                }
            ]
        }).catch(()=>{
        // Fail silently...
        });
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and
   * set a value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would
   * miss that property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {string} prop - The property to upgrade.
   */ #upgradeProperty(prop) {
        if (Object.prototype.hasOwnProperty.call(this, prop)) {
            const value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }
    /**
   * Starts the video stream.
   *
   * @param {string} [videoInputId] - The video input device ID.
   * @returns Promise<void>
   */ async startVideoStream(videoInputId) {
        if (!$40cc5a5311c08f52$export$682e9ed90a89bb4a.isSupported() || this.#stream) return;
        this.setAttribute('loading', '');
        const constraints = {
            video: {
                facingMode: {
                    ideal: this.facingMode
                }
            },
            audio: false
        };
        // Only add torch constraint if explicitly supported
        if ('torch' in this.#supportedConstraints && this.torch) constraints.video.torch = this.torch;
        // Add other constraints only if supported
        if ('zoom' in this.#supportedConstraints) constraints.video.zoom = true;
        if ('pan' in this.#supportedConstraints) constraints.video.pan = true;
        if ('tilt' in this.#supportedConstraints) constraints.video.tilt = true;
        if (typeof videoInputId === 'string' && videoInputId.trim().length > 0) constraints.video.deviceId = {
            exact: videoInputId
        };
        if (typeof this.cameraResolution === 'string' && this.cameraResolution.trim().length > 0) {
            const [width = 0, height = 0] = this.cameraResolution.split('x').map((x)=>Number(x));
            if (width > 0 && height > 0) {
                constraints.video.width = width;
                constraints.video.height = height;
            }
        }
        try {
            this.#stream = await navigator.mediaDevices.getUserMedia(constraints);
            if (this.#videoElement) this.#videoElement.srcObject = this.#stream;
            this.#applyConstraint('pan', this.pan);
            this.#applyConstraint('tilt', this.tilt);
            this.#applyConstraint('zoom', this.zoom);
        } catch (error) {
            this.dispatchEvent(new CustomEvent(`${$40cc5a5311c08f52$var$COMPONENT_NAME}:error`, {
                bubbles: true,
                composed: true,
                detail: {
                    error: error
                }
            }));
        } finally{
            this.removeAttribute('loading');
        }
    }
    /**
   * Restarts the video stream.
   *
   * @param {string} [videoInputId] - The video input device ID.
   */ restartVideoStream(videoInputId) {
        if (this.#stream && this.#videoElement) this.stopVideoStream();
        this.startVideoStream(videoInputId);
    }
    /**
   * Stops the video stream.
   */ stopVideoStream() {
        if (!this.#videoElement || !this.#stream) return;
        const [track] = this.#stream.getVideoTracks();
        track?.stop();
        this.#videoElement.srcObject = null;
        this.#stream = null;
    }
    /**
   * Returns an object based on the `MediaTrackSupportedConstraints` dictionary,
   * whose member fields each specify one ofthe constrainable properties the user agent understands.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaDevices/getSupportedConstraints
   * @returns {MediaTrackSupportedConstraints | {}}
   */ getSupportedConstraints() {
        if (!$40cc5a5311c08f52$export$682e9ed90a89bb4a.isSupported()) return {};
        return navigator.mediaDevices.getSupportedConstraints() || {};
    }
    /**
   * Returns a `MediaTrackCapabilities` object which specifies the values or range of values
   * which each constrainable property, based upon the platform and user agent.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaStreamTrack/getCapabilities
   * @returns {MediaTrackCapabilities | {}}
   */ getTrackCapabilities() {
        if (!this.#stream) return {};
        const [track] = this.#stream.getVideoTracks();
        if (track && typeof track.getCapabilities === 'function') return track.getCapabilities() || {};
        return {};
    }
    /**
   * Returns a `MediaTrackSettings` object containing the current values of each of
   * the constrainable properties for the current MediaStreamTrack.
   *
   * @see https://developer.mozilla.org/docs/Web/API/MediaStreamTrack/getSettings
   * @returns {MediaTrackSettings | {}}
   */ getTrackSettings() {
        if (!this.#stream) return {};
        const [track] = this.#stream.getVideoTracks();
        if (track && typeof track.getSettings === 'function') return track.getSettings() || {};
        return {};
    }
    /**
   * Returns the available video input devices.
   *
   * @returns {Promise<MediaDeviceInfo[]>}
   */ static async getVideoInputDevices() {
        if (!navigator.mediaDevices || !navigator.mediaDevices.enumerateDevices) return [];
        const devices = await navigator.mediaDevices.enumerateDevices() || [];
        return devices.filter((device)=>device.kind === 'videoinput' && !!device.deviceId);
    }
    /**
   * Checks if the `MediaDevices.getUserMedia()` method is supported.
   *
   * @returns {boolean}
   */ static isSupported() {
        return Boolean(navigator.mediaDevices?.getUserMedia);
    }
    /**
   * Defines a custom element with the given name.
   * The name must contain a dash (-).
   *
   * @param {string} [elementName='video-capture'] - The name of the custom element.
   */ static defineCustomElement(elementName = $40cc5a5311c08f52$var$COMPONENT_NAME) {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $40cc5a5311c08f52$export$682e9ed90a89bb4a);
    }
}


/*!
 * @georapbox/clipboard-copy-element
 * A custom element that implements the Clipboard API to copy text content from elements or input values to the clipboard.
 *
 * @version 3.0.2
 * @homepage https://github.com/georapbox/clipboard-copy-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ var $449da37d108ee4fe$var$i = "clipboard-copy";
var $449da37d108ee4fe$var$o = "success", $449da37d108ee4fe$var$n = "error", $449da37d108ee4fe$var$h = document.createElement("template"), $449da37d108ee4fe$var$a = `
  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }
`;
$449da37d108ee4fe$var$h.innerHTML = `
  <style>${$449da37d108ee4fe$var$a}</style>
  <button type="button" part="button">
    <slot name="copy">Copy</slot>
    <slot name="success" hidden>Copied!</slot>
    <slot name="error" hidden>Error</slot>
  </button>
`;
var $449da37d108ee4fe$export$ea3b71af1761ff40 = class d extends HTMLElement {
    #e = void 0;
    #t = null;
    #s = null;
    #i = null;
    #o = null;
    constructor(){
        super(), this.shadowRoot || this.attachShadow({
            mode: "open"
        }).appendChild($449da37d108ee4fe$var$h.content.cloneNode(!0)), this.shadowRoot && (this.#t = this.shadowRoot.querySelector("button"), this.#s = this.shadowRoot.querySelector('slot[name="copy"]'), this.#i = this.shadowRoot.querySelector('slot[name="success"]'), this.#o = this.shadowRoot.querySelector('slot[name="error"]'));
    }
    static get observedAttributes() {
        return [
            "disabled"
        ];
    }
    attributeChangedCallback(t, s, e) {
        t === "disabled" && s !== e && this.#t && (this.#t.disabled = this.disabled, this.#t.setAttribute("aria-disabled", this.disabled.toString()), this.#t.part.contains("button") && this.#t.part.toggle("button--disabled", this.disabled));
    }
    connectedCallback() {
        this.#n("value"), this.#n("from"), this.#n("disabled"), this.#n("feedbackDuration"), this.#t?.addEventListener("click", this.#r);
    }
    disconnectedCallback() {
        this.#t?.removeEventListener("click", this.#r), this.#a();
    }
    get value() {
        return this.getAttribute("value") || "";
    }
    set value(t) {
        this.setAttribute("value", t != null ? t.toString() : t);
    }
    get from() {
        return this.getAttribute("from") || "";
    }
    set from(t) {
        this.setAttribute("from", t != null ? t.toString() : t);
    }
    get disabled() {
        return this.hasAttribute("disabled");
    }
    set disabled(t) {
        this.toggleAttribute("disabled", !!t);
    }
    get feedbackDuration() {
        return Number(this.getAttribute("feedback-duration")) || 1e3;
    }
    set feedbackDuration(t) {
        this.setAttribute("feedback-duration", t != null ? t.toString() : t);
    }
    async #d() {
        if (!(!this.value && !this.from)) try {
            let t = "";
            if (this.value) t = this.value;
            else if (this.from) {
                let s = "getRootNode" in Element.prototype ? this.#t?.getRootNode({
                    composed: !0
                }) : this.#t?.ownerDocument;
                if (!s || !(s instanceof Document || s instanceof ShadowRoot)) return;
                let e = s.querySelector(this.from);
                if (!e) return;
                e instanceof HTMLInputElement || e instanceof HTMLTextAreaElement ? t = e.value : e instanceof HTMLAnchorElement && e.hasAttribute("href") ? t = e.href : t = e.textContent || "";
            }
            await navigator.clipboard.writeText(t), this.#h($449da37d108ee4fe$var$o), this.dispatchEvent(new CustomEvent(`${$449da37d108ee4fe$var$i}-success`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    value: t
                }
            }));
        } catch (t) {
            this.#h($449da37d108ee4fe$var$n), this.dispatchEvent(new CustomEvent(`${$449da37d108ee4fe$var$i}-error`, {
                bubbles: !0,
                composed: !0,
                detail: {
                    error: t
                }
            }));
        }
    }
    #r = (t)=>{
        t.preventDefault(), !(this.disabled || this.#e) && this.#d();
    };
    #h(t) {
        this.#s && (this.#s.hidden = !0), this.#i && (this.#i.hidden = t !== $449da37d108ee4fe$var$o), this.#o && (this.#o.hidden = t !== $449da37d108ee4fe$var$n), this.#t?.part.remove("button--success"), this.#t?.part.remove("button--error"), this.#t?.part.add(`button--${t}`), this.#e && clearTimeout(this.#e), this.#e = setTimeout(()=>{
            this.#s && (this.#s.hidden = !1), this.#i && (this.#i.hidden = !0), this.#o && (this.#o.hidden = !0), this.#t?.part.remove(`button--${t}`), this.#e = void 0;
        }, this.feedbackDuration);
    }
    #a() {
        this.#e && clearTimeout(this.#e), this.#e = void 0, this.#s && (this.#s.hidden = !1), this.#i && (this.#i.hidden = !0), this.#o && (this.#o.hidden = !0), this.#t?.part.remove("button--success"), this.#t?.part.remove("button--error");
    }
    #n(t) {
        let s = this;
        if (Object.prototype.hasOwnProperty.call(s, t)) {
            let e = s[t];
            delete s[t], s[t] = e;
        }
    }
    static defineCustomElement(t = $449da37d108ee4fe$var$i) {
        typeof window < "u" && !window.customElements.get(t) && window.customElements.define(t, d);
    }
};


/**
 * Extends the `ClipboardCopy` element to override the default `copy` and `success` slots,
 * in order to avoid repetition of the same markup throughout the application.
 * It also adds aditional properties and attributes, specific to the application.
 *
 * @class CustomClipboardCopy
 * @extends ClipboardCopy
 */ class $3d31f226494869e5$var$CustomClipboardCopy extends (0, $449da37d108ee4fe$export$ea3b71af1761ff40) {
    constructor(){
        super();
        const copySlot = this.shadowRoot.querySelector('slot[name="copy"]');
        const successSlot = this.shadowRoot.querySelector('slot[name="success"]');
        const errorSlot = this.shadowRoot.querySelector('slot[name="error"]');
        copySlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
      </svg>
      <span class="text">Copy</span>
    `;
        successSlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path fill-rule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0z"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
      </svg>
      <span class="text">Copied!</span>
    `;
        errorSlot.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
        <path fill-rule="evenodd" d="M6.146 7.146a.5.5 0 0 1 .708 0L8 8.293l1.146-1.147a.5.5 0 1 1 .708.708L8.707 9l1.147 1.146a.5.5 0 0 1-.708.708L8 9.707l-1.146 1.147a.5.5 0 0 1-.708-.708L7.293 9 6.146 7.854a.5.5 0 0 1 0-.708"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
      </svg>
      <span class="text">Error</span>
    `;
    }
    static get observedAttributes() {
        return [
            ...super.observedAttributes,
            'only-icon'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        super.attributeChangedCallback(name, oldValue, newValue);
        if (name === 'only-icon' && oldValue !== newValue) {
            const copySlot = this.shadowRoot.querySelector('slot[name="copy"]');
            const successSlot = this.shadowRoot.querySelector('slot[name="success"]');
            const errorSlot = this.shadowRoot.querySelector('slot[name="error"]');
            const copyText = copySlot.querySelector('.text');
            const successText = successSlot.querySelector('.text');
            const errorText = errorSlot.querySelector('.text');
            copyText?.toggleAttribute('hidden', this.onlyIcon);
            successText?.toggleAttribute('hidden', this.onlyIcon);
            errorText?.toggleAttribute('hidden', this.onlyIcon);
        }
    }
    get onlyIcon() {
        return this.hasAttribute('only-icon');
    }
    set onlyIcon(value) {
        if (value) this.setAttribute('only-icon', '');
        else this.removeAttribute('only-icon');
    }
    connectedCallback() {
        super.connectedCallback();
        this.#upgradeProperty('onlyIcon');
        if (!this.hasAttribute('feedback-duration')) this.setAttribute('feedback-duration', '1500');
    }
    disconnectedCallback() {
        super.disconnectedCallback();
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and
   * set a value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would
   * miss that property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {string} prop - The property to upgrade.
   */ #upgradeProperty(prop) {
        if (Object.prototype.hasOwnProperty.call(this, prop)) {
            const value = this[prop];
            delete this[prop];
            this[prop] = value;
        }
    }
    static defineCustomElement(elementName = 'custom-clipboard-copy') {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $3d31f226494869e5$var$CustomClipboardCopy);
    }
}
$3d31f226494869e5$var$CustomClipboardCopy.defineCustomElement();


/*!
 * @georapbox/web-share-element
 * A custom element that implements the Web Share API to share user-defined data.
 *
 * @version 3.1.1
 * @homepage https://github.com/georapbox/web-share-element#readme
 * @author George Raptis <georapbox@gmail.com>
 * @license MIT
 */ function $7a2aca835bb05064$export$c37129e465f64ef0(a) {
    return a !== null && typeof a == "object" ? "share" in navigator && "canShare" in navigator && navigator.canShare(a) : "share" in navigator;
}



const $93b8b904bae85789$export$59113f23fb667b84 = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'short',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
});


const $1070105e2e55dcbd$var$styles = /* css */ `
  :host {
    --color-flash: #ffff99;

    box-sizing: border-box;
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  .result {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.5rem;
    position: relative;
    width: 100%;
    padding: 0.5rem;
  }

  .result__item {
    word-wrap: break-word;
    word-break: break-word;
  }

  a.result__item {
    color: var(--links);
  }

  .result__datetime {
    font-size: 0.8rem;
    color: var(--text-muted);
    margin-block-start: 0.25rem;
  }

  .result__datetime:empty {
    display: none !important;
  }

  .result__actions {
    display: flex;
    align-items: center;
    align-items: center;
    justify-content: center;
    gap: 0.75rem;
  }

  .result web-share button,
  .result custom-clipboard-copy::part(button) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem;
    background-color: transparent;
    border: 0;
    border-radius: var(--border-radius);
    color: inherit;
    line-height: 1;
    font-family: inherit;
    font-size: 0.9rem;
    cursor: pointer;
  }

  .result custom-clipboard-copy::part(button--success) {
    color: var(--success-color);
  }

  .result custom-clipboard-copy::part(button--error) {
    color: var(--danger-color);
  }

  .flash {
    animation: flash 0.4s ease-out;
  }

  @keyframes flash {
    0% {
      background-color: #ffff99;
    }
    100% {
      background-color: transparent;
    }
  }
`;
const $1070105e2e55dcbd$var$template = document.createElement('template');
$1070105e2e55dcbd$var$template.innerHTML = /* html */ `
  <style>${$1070105e2e55dcbd$var$styles}</style>

  <div class="result" part="result">
    <div class="result__content">
      <div class="result__datetime"></div>
    </div>

    <div class="result__actions">
      <custom-clipboard-copy only-icon></custom-clipboard-copy>

      <web-share>
        <button slot="button" type="button">
          <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
            <path d="M13.5 1a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM11 2.5a2.5 2.5 0 1 1 .603 1.628l-6.718 3.12a2.499 2.499 0 0 1 0 1.504l6.718 3.12a2.5 2.5 0 1 1-.488.876l-6.718-3.12a2.5 2.5 0 1 1 0-3.256l6.718-3.12A2.5 2.5 0 0 1 11 2.5zm-8.5 4a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zm11 5.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3z"/>
          </svg>
        </button>
      </web-share>
    </div>
  </div>
`;
class $1070105e2e55dcbd$var$BSResult extends HTMLElement {
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($1070105e2e55dcbd$var$template.content.cloneNode(true));
        }
    }
    get value() {
        return this.getAttribute('value');
    }
    set value(value) {
        this.setAttribute('value', value);
    }
    static get observedAttributes() {
        return [
            'value'
        ];
    }
    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'value' && oldValue !== newValue) this.#handleValueChange(this.value);
    }
    connectedCallback() {
        this.#upgradeProperty('value');
        if (window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
            const baseEl = this.shadowRoot.querySelector('.result');
            baseEl?.animate([
                {
                    backgroundColor: 'var(--color-flash)'
                },
                {
                    backgroundColor: 'transparent'
                }
            ], {
                duration: 400,
                easing: 'ease-out'
            });
        }
        if (!(0, $7a2aca835bb05064$export$c37129e465f64ef0)()) {
            const webShareEl = this.shadowRoot.querySelector('web-share');
            if (webShareEl) webShareEl.hidden = true;
        }
    }
    async #handleValueChange(value) {
        const baseEl = this.shadowRoot.querySelector('.result');
        const resultContentEl = baseEl?.querySelector('.result__content');
        const resultDatetimeEl = baseEl?.querySelector('.result__datetime');
        const oldResultEl = baseEl?.querySelector('.result__item');
        let resultEl;
        if (oldResultEl) oldResultEl?.remove();
        try {
            const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
            new URL(value);
            resultEl = document.createElement('a');
            resultEl.href = value;
            if (!settings?.openWebPageSameTab) {
                resultEl.setAttribute('target', '_blank');
                resultEl.setAttribute('rel', 'noreferrer noopener');
            }
            if (settings?.openWebPage) resultEl.click();
            else window.requestAnimationFrame(()=>resultEl.focus());
        } catch  {
            resultEl = document.createElement('span');
        }
        resultEl.className = 'result__item';
        resultEl.part = 'result__item';
        resultEl.textContent = value;
        resultDatetimeEl.textContent = (0, $93b8b904bae85789$export$59113f23fb667b84).format(new Date());
        resultContentEl?.insertBefore(resultEl, resultDatetimeEl);
        const copyEl = baseEl?.querySelector('custom-clipboard-copy');
        const shareEl = baseEl?.querySelector('web-share');
        if (copyEl) {
            const copyBtn = copyEl.shadowRoot?.querySelector('button');
            copyEl.setAttribute('value', value);
            copyBtn?.setAttribute('aria-label', `Copy to clipboard ${value}`);
            copyEl.hidden = false;
        }
        if (shareEl && (0, $7a2aca835bb05064$export$c37129e465f64ef0)()) {
            const shareBtn = shareEl.querySelector('button');
            shareEl.setAttribute('share-text', value);
            shareEl.hidden = false;
            shareBtn?.setAttribute('aria-label', `Share ${value}`);
        }
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and
   * set a value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would
   * miss that property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {string} prop - The property to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    static defineCustomElement(elementName = 'bs-result') {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $1070105e2e55dcbd$var$BSResult);
    }
}
$1070105e2e55dcbd$var$BSResult.defineCustomElement();



class $6dd5a0a81bb7e066$export$7759dbe45ea59582 extends HTMLElement {
    #formatsWrapperEl = null;
    #formEl = null;
    #supportedFormats = [];
    #settings;
    constructor(){
        super();
    }
    get supportedFormats() {
        return this.#supportedFormats;
    }
    set supportedFormats(value) {
        this.#supportedFormats = value;
        this.#renderFormats();
    }
    async connectedCallback() {
        this.#upgradeProperty('supportedFormats');
        this.#formatsWrapperEl = this.querySelector('#formatsList');
        this.#formEl = this.querySelector('form');
        const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
        this.#settings = settings ?? {};
        this.#formEl?.querySelectorAll(`[name="general-settings"]`).forEach((input)=>{
            input.checked = this.#settings[input.value];
        });
    }
    #renderFormats() {
        if (!this.#formatsWrapperEl) return;
        const formatsFromStorage = this.#settings?.formats;
        this.#formatsWrapperEl.replaceChildren();
        this.supportedFormats.forEach((format)=>{
            const li = document.createElement('li');
            const label = document.createElement('label');
            const input = document.createElement('input');
            input.type = 'checkbox';
            input.name = 'formats-settings';
            input.value = format;
            input.checked = formatsFromStorage != null ? formatsFromStorage.includes(format) : true;
            label.appendChild(input);
            label.appendChild(document.createTextNode(format));
            li.appendChild(label);
            this.#formatsWrapperEl.appendChild(li);
        });
    }
    /**
   * This is to safe guard against cases where, for instance, a framework may have added the element to the page and
   * set a value on one of its properties, but lazy loaded its definition. Without this guard, the upgraded element would
   * miss that property and the instance property would prevent the class property setter from ever being called.
   *
   * https://developers.google.com/web/fundamentals/web-components/best-practices#lazy-properties
   *
   * @param {string} prop - The property to upgrade.
   */ #upgradeProperty(prop) {
        const instance = this;
        if (Object.prototype.hasOwnProperty.call(instance, prop)) {
            const value = instance[prop];
            delete instance[prop];
            instance[prop] = value;
        }
    }
    static defineCustomElement(elementName = 'bs-settings') {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $6dd5a0a81bb7e066$export$7759dbe45ea59582);
    }
}
$6dd5a0a81bb7e066$export$7759dbe45ea59582.defineCustomElement();




const $fb81289e9081c547$var$styles = /* css */ `
  :host {
    --empty-history-button-color: #ffffff;

    display: block;
    box-sizing: border-box;
  }

  @media (prefers-color-scheme: dark) {
    :host {
      --empty-history-button-color: #000000;
    }
  }

  :host *,
  :host *::before,
  :host *::after {
    box-sizing: inherit;
  }

  :host([hidden]),
  [hidden],
  ::slotted([hidden]) {
    display: none !important;
  }

  ul {
    max-width: 36.25rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  ul li {
    position: relative;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
    padding: 0.5rem 0.75rem;
    border-bottom: 1px solid var(--border);
    color: var(--text-main);
  }

  ul li:last-of-type {
    border-bottom: none;
  }

  ul li a {
    color: var(--links);
  }

  ul li a,
  ul li span {
    word-break: break-all;
  }

  @supports (-webkit-line-clamp: 1) and (display: -webkit-box) and (-webkit-box-orient: vertical) {
    ul li a,
    ul li span {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    }
  }

  .actions {
    display: flex;
    gap: 0.25rem;
  }

  .actions button,
  .actions custom-clipboard-copy::part(button) {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.25rem;
    padding: 0.25rem 0.5rem;
    margin: 0;
    border: 0;
    border-radius: var(--border-radius);
    background-color: transparent !important;
    line-height: 1;
    font-size: 1rem;
    color: var(--text-main);
    cursor: pointer;
  }

  .actions custom-clipboard-copy::part(button--success) {
    color: var(--success-color);
  }

  .actions custom-clipboard-copy::part(button--error) {
    color: var(--danger-color);
  }

  .actions .delete-action {
    color: var(--danger-color);
    margin-right: -0.5rem;
  }

  footer {
    position: sticky;
    bottom: 0;
    padding: 0.75rem;
    background-color: var(--dialog-background);
  }

  footer > button {
    width: 100%;
    padding: 0.625rem;
    border: 0;
    border-radius: var(--border-radius);
    background-color: var(--danger-color);
    color: var(--empty-history-button-color);
    font-size: 1rem;
    cursor: pointer;
  }

  ul:empty + footer > button {
    display: none;
  }

  ul:not(:empty) + footer > div {
    display: none;
  }
`;
const $fb81289e9081c547$var$template = document.createElement('template');
$fb81289e9081c547$var$template.innerHTML = /* html */ `
  <style>${$fb81289e9081c547$var$styles}</style>
  <ul id="historyList"></ul>
  <footer>
    <div>There are no saved items in history.</div>
    <button type="button" id="emptyHistoryBtn">Empty history</button>
  </footer>
`;
class $fb81289e9081c547$export$3863abf332fe6b5e extends HTMLElement {
    #historyListEl = null;
    #emptyHistoryBtn = null;
    constructor(){
        super();
        if (!this.shadowRoot) {
            const shadowRoot = this.attachShadow({
                mode: 'open'
            });
            shadowRoot.appendChild($fb81289e9081c547$var$template.content.cloneNode(true));
        }
    }
    async connectedCallback() {
        this.#historyListEl = this.shadowRoot?.getElementById('historyList');
        this.#emptyHistoryBtn = this.shadowRoot?.getElementById('emptyHistoryBtn');
        this.#renderHistoryList((await (0, $0eb43b201e9f90c7$export$f9582a3c130d9538)())[1] || []);
        this.#historyListEl?.addEventListener('click', this.#handleHistoryListClick);
        this.#emptyHistoryBtn?.addEventListener('click', this.#handleEmptyHistoryClick);
    }
    disconnectedCallback() {
        this.#historyListEl?.removeEventListener('click', this.#handleHistoryListClick);
        this.#emptyHistoryBtn?.removeEventListener('click', this.#handleEmptyHistoryClick);
    }
    /**
   * Adds an item to the history.
   * If the item is already in history, it will not be added.
   *
   * @param {string} item - Item to add to history
   * @return {Promise<null|Error>} - Returns null if successful, or an error if there was an issue
   */ async add(item) {
        if (!item) return;
        const errPayload = {
            type: 'add',
            message: 'Error adding barcode to history'
        };
        const [getHistoryError, history = []] = await (0, $0eb43b201e9f90c7$export$f9582a3c130d9538)();
        if (getHistoryError || !Array.isArray(history)) {
            this.#emitEvent('bs-history-error', errPayload);
            return getHistoryError;
        }
        if (history.find((h)=>h === item)) return;
        const data = [
            ...history,
            item
        ];
        const [setHistoryError] = await (0, $0eb43b201e9f90c7$export$96fe1132eb44c325)(data);
        if (setHistoryError) {
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Error setting history', setHistoryError);
            this.#emitEvent('bs-history-error', errPayload);
            return setHistoryError;
        }
        this.#historyListEl?.insertBefore(this.#createHistoryItemElement(item), this.#historyListEl.firstElementChild);
        this.#emitEvent('bs-history-success', {
            type: 'add',
            message: 'Barcode added to history'
        });
        return null;
    }
    /**
   * Removes an item from the history.
   *
   * @param {string} item - Item to remove from history
   * @return {Promise<null|Error>} - Returns null if successful, or an error if there was an issue
   */ async remove(item) {
        if (!item) return;
        const errPayload = {
            type: 'remove',
            message: 'Error removing barcode from history'
        };
        const [getHistoryError, history = []] = await (0, $0eb43b201e9f90c7$export$f9582a3c130d9538)();
        if (getHistoryError || !Array.isArray(history)) {
            this.#emitEvent('bs-history-error', errPayload);
            return getHistoryError;
        }
        const data = history.filter((el)=>el !== item);
        const [setHistoryError] = await (0, $0eb43b201e9f90c7$export$96fe1132eb44c325)(data);
        if (setHistoryError) {
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Error setting history', setHistoryError);
            this.#emitEvent('bs-history-error', errPayload);
            return setHistoryError;
        }
        const historyItem = this.#historyListEl?.querySelector(`li[data-value="${item}"]`);
        historyItem?.remove();
        this.#emitEvent('bs-history-success', {
            type: 'remove',
            message: 'Barcode removed from history'
        });
        return null;
    }
    /**
   * Removes all items from the history.
   *
   * @return {Promise<null|Error>} - Returns null if successful, or an error if there was an issue
   */ async empty() {
        const errPayload = {
            type: 'empty',
            message: 'Error emptying history'
        };
        const [setHistoryError] = await (0, $0eb43b201e9f90c7$export$96fe1132eb44c325)([]);
        if (setHistoryError) {
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Error setting history', setHistoryError);
            this.#emitEvent('bs-history-error', errPayload);
            return setHistoryError;
        }
        this.#historyListEl?.replaceChildren();
        this.#emitEvent('bs-history-success', {
            type: 'empty',
            message: 'History emptied successfully'
        });
        return null;
    }
    /**
   * Renders the history list. If there are no items in history, it will show a message.
   *
   * @param {Array<string>} data - History data as an array of strings
   */ #renderHistoryList(data) {
        if (!this.#historyListEl) return;
        this.#historyListEl.replaceChildren();
        const fragment = document.createDocumentFragment();
        [
            ...data
        ].reverse().forEach((item)=>fragment.appendChild(this.#createHistoryItemElement(item)));
        this.#historyListEl.appendChild(fragment);
    }
    /**
   * Creates a history item element.
   * If the item is a URL, it will be an anchor element, otherwise a span element.
   *
   * @param {string} item - The history item to create an element for
   * @returns {HTMLLIElement} The history item element
   */ #createHistoryItemElement(item) {
        const li = document.createElement('li');
        li.setAttribute('data-value', item);
        let historyItem;
        try {
            new URL(item);
            historyItem = document.createElement('a');
            historyItem.href = item;
            historyItem.setAttribute('target', '_blank');
            historyItem.setAttribute('rel', 'noreferrer noopener');
        } catch  {
            historyItem = document.createElement('span');
        }
        historyItem.textContent = item;
        const actionsEl = document.createElement('div');
        actionsEl.className = 'actions';
        const copyEl = document.createElement('custom-clipboard-copy');
        const copyBtn = copyEl.shadowRoot?.querySelector('button');
        copyEl.setAttribute('only-icon', '');
        copyEl.setAttribute('value', item);
        copyBtn?.setAttribute('aria-label', `Copy to clipboard ${item}`);
        actionsEl.appendChild(copyEl);
        const removeBtn = document.createElement('button');
        removeBtn.type = 'button';
        removeBtn.className = 'delete-action';
        removeBtn.setAttribute('data-action', 'delete');
        removeBtn.setAttribute('aria-label', `Remove from history ${item}`);
        removeBtn.innerHTML = /* html */ `
      <svg xmlns="http://www.w3.org/2000/svg" width="1.125em" height="1.125em" fill="currentColor" viewBox="0 0 16 16">
        <path d="M11 1.5v1h3.5a.5.5 0 0 1 0 1h-.538l-.853 10.66A2 2 0 0 1 11.115 16h-6.23a2 2 0 0 1-1.994-1.84L2.038 3.5H1.5a.5.5 0 0 1 0-1H5v-1A1.5 1.5 0 0 1 6.5 0h3A1.5 1.5 0 0 1 11 1.5Zm-5 0v1h4v-1a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5ZM4.5 5.029l.5 8.5a.5.5 0 1 0 .998-.06l-.5-8.5a.5.5 0 1 0-.998.06Zm6.53-.528a.5.5 0 0 0-.528.47l-.5 8.5a.5.5 0 0 0 .998.058l.5-8.5a.5.5 0 0 0-.47-.528ZM8 4.5a.5.5 0 0 0-.5.5v8.5a.5.5 0 0 0 1 0V5a.5.5 0 0 0-.5-.5Z"/>
      </svg>
    `;
        actionsEl.appendChild(removeBtn);
        li.appendChild(historyItem);
        li.appendChild(actionsEl);
        return li;
    }
    /**
   * Handles the click event on the history list.
   *
   * @param {Event} evt - The event object
   */ #handleHistoryListClick = async (evt)=>{
        const target = evt.target;
        if (target.closest('[data-action="delete"]')) {
            const value = target.closest('li').dataset.value;
            if (window.confirm(`Delete history item ${value}?`)) this.remove(value);
        }
    };
    /**
   * Handles the click event on the empty history button.
   */ #handleEmptyHistoryClick = async ()=>{
        if (window.confirm('Empty history? This action cannot be undone.')) this.empty();
    };
    /**
   * Dispatches a custom event with the given name.
   *
   * @param {string} eventName - The name of the event to dispatch.
   * @param {Nullable<any>} detail - The detail object to include with the event.
   */ #emitEvent(eventName, detail = null) {
        const options = {
            bubbles: true,
            composed: true,
            detail: detail
        };
        const evt = new CustomEvent(eventName, options);
        this.dispatchEvent(evt);
    }
    static defineCustomElement(elementName = 'bs-history') {
        if (typeof window !== 'undefined' && !window.customElements.get(elementName)) window.customElements.define(elementName, $fb81289e9081c547$export$3863abf332fe6b5e);
    }
}
$fb81289e9081c547$export$3863abf332fe6b5e.defineCustomElement();



/**
 * Centralized application state
 * This provides a single source of truth for all application state
 */ const $fd2d3348854bcc99$export$ca000e230c0caa3e = {
    // Scanning state
    shouldScan: true,
    scanTimeoutId: null,
    // Barcode reader instance
    barcodeReader: null,
    // Current session data
    currentClientId: null,
    currentDossierId: null,
    // UI state
    isEditing: false
};
/**
 * State change listeners
 */ const $fd2d3348854bcc99$var$listeners = new Map();
function $fd2d3348854bcc99$export$50fdfeece43146fd(key) {
    return $fd2d3348854bcc99$export$ca000e230c0caa3e[key];
}
function $fd2d3348854bcc99$export$42fffed799c298bb(key, value) {
    const oldValue = $fd2d3348854bcc99$export$ca000e230c0caa3e[key];
    $fd2d3348854bcc99$export$ca000e230c0caa3e[key] = value;
    // Notify listeners
    const keyListeners = $fd2d3348854bcc99$var$listeners.get(key);
    if (keyListeners) keyListeners.forEach((callback)=>callback(value, oldValue));
}
function $fd2d3348854bcc99$export$ec068583843480e7(key, callback) {
    if (!$fd2d3348854bcc99$var$listeners.has(key)) $fd2d3348854bcc99$var$listeners.set(key, new Set());
    $fd2d3348854bcc99$var$listeners.get(key).add(callback);
    return ()=>{
        $fd2d3348854bcc99$var$listeners.get(key).delete(callback);
    };
}
function $fd2d3348854bcc99$export$8a452ee356909bac() {
    if ($fd2d3348854bcc99$export$ca000e230c0caa3e.currentClientId) return $fd2d3348854bcc99$export$ca000e230c0caa3e.currentClientId;
    const stored = localStorage.getItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).CLIENT_ID);
    if (stored) $fd2d3348854bcc99$export$ca000e230c0caa3e.currentClientId = stored;
    return stored;
}
function $fd2d3348854bcc99$export$515b2f2cc4592ad(clientId) {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.currentClientId = clientId;
    if (clientId) localStorage.setItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).CLIENT_ID, clientId);
    else localStorage.removeItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).CLIENT_ID);
}
function $fd2d3348854bcc99$export$98333c9677aec7cf() {
    if ($fd2d3348854bcc99$export$ca000e230c0caa3e.currentDossierId) return $fd2d3348854bcc99$export$ca000e230c0caa3e.currentDossierId;
    const stored = localStorage.getItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).DOSSIER_ID);
    if (stored) $fd2d3348854bcc99$export$ca000e230c0caa3e.currentDossierId = stored;
    return stored;
}
function $fd2d3348854bcc99$export$737a550610301656(dossierId) {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.currentDossierId = dossierId;
    if (dossierId) localStorage.setItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).DOSSIER_ID, dossierId);
    else localStorage.removeItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).DOSSIER_ID);
}
function $fd2d3348854bcc99$export$7809a8af6f3e4c63() {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.currentClientId = null;
    $fd2d3348854bcc99$export$ca000e230c0caa3e.currentDossierId = null;
    localStorage.removeItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).CLIENT_ID);
    localStorage.removeItem((0, $65136e012e05e2d7$export$5aae9b6b3e0e7094).DOSSIER_ID);
}
function $fd2d3348854bcc99$export$820f89a2d1928e86() {
    if ($fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId) {
        clearTimeout($fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId);
        $fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId = null;
    }
    $fd2d3348854bcc99$export$ca000e230c0caa3e.shouldScan = true;
}
function $fd2d3348854bcc99$export$89ad965bd9bf7a2f() {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.shouldScan = false;
    if ($fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId) {
        clearTimeout($fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId);
        $fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId = null;
    }
}
function $fd2d3348854bcc99$export$d9bb8408206af950() {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.shouldScan = true;
}
function $fd2d3348854bcc99$export$8b055fa43cbd19c0(reader) {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.barcodeReader = reader;
}
function $fd2d3348854bcc99$export$b68ab95a19e46e80() {
    return $fd2d3348854bcc99$export$ca000e230c0caa3e.barcodeReader;
}
function $fd2d3348854bcc99$export$9ef6e5a1f2a43303(timeoutId) {
    $fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId = timeoutId;
}
function $fd2d3348854bcc99$export$7508020b8122e73f() {
    return $fd2d3348854bcc99$export$ca000e230c0caa3e.scanTimeoutId;
}
function $fd2d3348854bcc99$export$933c896b5b68e1bf() {
    return $fd2d3348854bcc99$export$ca000e230c0caa3e.shouldScan;
}


/**
 * UI module - Alerts, notifications, and global UI updates
 */ /**
 * Escapes HTML special characters to prevent XSS attacks
 * @param {string} str - String to escape
 * @returns {string} Escaped string
 */ function $7dfa749f2904b093$export$4cf11838cdc2a8a8(str) {
    if (typeof str !== 'string') return String(str ?? '');
    const escapeMap = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
    };
    return str.replace(/[&<>"']/g, (char)=>escapeMap[char]);
}
function $7dfa749f2904b093$export$c8a8987d4410bf2d(tag, attributes = {}, content = null) {
    const element = document.createElement(tag);
    for (const [key, value] of Object.entries(attributes)){
        if (key === 'className') element.className = value;
        else if (key === 'dataset') for (const [dataKey, dataValue] of Object.entries(value))element.dataset[dataKey] = dataValue;
        else if (key.startsWith('on') && typeof value === 'function') element.addEventListener(key.slice(2).toLowerCase(), value);
        else if (value !== null && value !== undefined) element.setAttribute(key, value);
    }
    if (content !== null) {
        if (typeof content === 'string') element.textContent = content;
        else if (content instanceof Node) element.appendChild(content);
        else if (Array.isArray(content)) content.forEach((child)=>{
            if (child instanceof Node) element.appendChild(child);
            else if (typeof child === 'string') element.appendChild(document.createTextNode(child));
        });
    }
    return element;
}
function $7dfa749f2904b093$export$407ea597bae49e98(elements) {
    const fragment = document.createDocumentFragment();
    elements.forEach((el)=>fragment.appendChild(el));
    return fragment;
}
function $7dfa749f2904b093$export$741d8c6ea122e500(element, template, values = {}) {
    let result = template;
    for (const [key, value] of Object.entries(values)){
        const placeholder = `{{${key}}}`;
        result = result.replace(new RegExp(placeholder, 'g'), $7dfa749f2904b093$export$4cf11838cdc2a8a8(value));
    }
    element.innerHTML = result;
}
function $7dfa749f2904b093$export$99d4d4500133757a(product, options = {}) {
    const { quantity: quantity = 1, dossierProduitId: dossierProduitId = null } = options;
    const prixHt = parseFloat(product.option_prix_ht || product.dossier_produit_prix_ht || 0);
    const remise = parseFloat(product.option_remise_conseillee || product.dossier_produit_remise || 0);
    const prixNet = prixHt * (1 - remise / 100);
    const total = prixNet * quantity;
    const col = $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
        className: 'col-12 col-md-6 col-lg-4 mb-3',
        dataset: {
            productId: product.option_id,
            ...dossierProduitId && {
                dossierProduitId: dossierProduitId
            }
        }
    }, [
        $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
            className: 'card'
        }, [
            // Card header
            $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
                className: 'card-header d-flex justify-content-between align-items-center'
            }, [
                $7dfa749f2904b093$export$c8a8987d4410bf2d('h5', {
                    className: 'card-title mb-0'
                }, `${product.option_reference || ''} [${product.produit_id || product.option_id}]`),
                $7dfa749f2904b093$export$c8a8987d4410bf2d('button', {
                    type: 'button',
                    className: 'btn-close',
                    'aria-label': 'Close'
                })
            ]),
            // Card body
            $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
                className: 'card-body'
            }, [
                // Product name (if available)
                ...product.option_description || product.dossier_produit_nom ? [
                    $7dfa749f2904b093$export$c8a8987d4410bf2d('p', {
                        className: 'text-muted small'
                    }, product.option_description || product.dossier_produit_nom)
                ] : [],
                // Pricing info
                $7dfa749f2904b093$var$createPricingElement(prixHt, remise, prixNet),
                // Quantity and total row
                $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
                    className: 'd-flex justify-content-between align-items-center'
                }, [
                    $7dfa749f2904b093$export$c8a8987d4410bf2d('div', {
                        className: 'input-group w-50'
                    }, [
                        $7dfa749f2904b093$export$c8a8987d4410bf2d('span', {
                            className: 'input-group-text'
                        }, "Qt\xe9"),
                        $7dfa749f2904b093$export$c8a8987d4410bf2d('input', {
                            type: 'number',
                            className: 'form-control quantity-input',
                            value: String(quantity),
                            min: '1'
                        })
                    ]),
                    $7dfa749f2904b093$export$c8a8987d4410bf2d('p', {
                        className: 'card-text mb-0'
                    }, [
                        $7dfa749f2904b093$export$c8a8987d4410bf2d('strong', {}, 'Total: '),
                        $7dfa749f2904b093$export$c8a8987d4410bf2d('span', {
                            className: 'total-card'
                        }, total.toFixed(2))
                    ])
                ])
            ])
        ])
    ]);
    return col;
}
/**
 * Creates pricing element for card
 * @param {number} prixHt - Gross price
 * @param {number} remise - Discount percentage
 * @param {number} prixNet - Net price
 * @returns {HTMLElement} Pricing paragraph element
 */ function $7dfa749f2904b093$var$createPricingElement(prixHt, remise, prixNet) {
    const p = $7dfa749f2904b093$export$c8a8987d4410bf2d('p', {
        className: 'card-text'
    });
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('strong', {}, 'P. Brut:'));
    p.appendChild(document.createTextNode(` ${prixHt.toFixed(2)} `));
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('br'));
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('strong', {}, 'Remise:'));
    p.appendChild(document.createTextNode(` ${remise}% `));
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('br'));
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('strong', {
        className: 'prix-net-label'
    }, 'P. Net:'));
    p.appendChild(document.createTextNode(' '));
    p.appendChild($7dfa749f2904b093$export$c8a8987d4410bf2d('span', {
        className: 'prix-net'
    }, prixNet.toFixed(2)));
    return p;
}
function $7dfa749f2904b093$export$188572f6f214cb74(cardBody, prixHt, remise, prixNet) {
    const pricingElements = cardBody.querySelectorAll('.card-text');
    for (const element of pricingElements)if (element.querySelector('.prix-net')) {
        const newPricing = $7dfa749f2904b093$var$createPricingElement(prixHt, remise, prixNet);
        element.replaceWith(newPricing);
        break;
    }
}
function $7dfa749f2904b093$export$8fab56ae7bdc6ce7(message, variant = 'danger') {
    const alertEl = document.createElement('alert-element');
    alertEl.setAttribute('variant', variant);
    alertEl.setAttribute('dismissible', '');
    alertEl.setAttribute('open', '');
    // Create icon slot
    const iconSlot = $7dfa749f2904b093$export$c8a8987d4410bf2d('span', {
        slot: 'icon'
    });
    iconSlot.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
    </svg>
  `;
    alertEl.appendChild(iconSlot);
    alertEl.appendChild(document.createTextNode(message));
    return alertEl;
}
function $7dfa749f2904b093$export$d64887ed5573eb0f(errorMessage) {
    const alertEl = document.createElement('alert-element');
    alertEl.setAttribute('variant', 'danger');
    alertEl.setAttribute('open', '');
    const iconSlot = $7dfa749f2904b093$export$c8a8987d4410bf2d('span', {
        slot: 'icon'
    });
    iconSlot.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z"/>
      <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"/>
    </svg>
  `;
    alertEl.appendChild(iconSlot);
    // Add error message - use innerHTML only for trusted content
    const messageSpan = $7dfa749f2904b093$export$c8a8987d4410bf2d('span');
    messageSpan.innerHTML = $7dfa749f2904b093$export$4cf11838cdc2a8a8(errorMessage).replace(/&lt;br&gt;/g, '<br>');
    alertEl.appendChild(messageSpan);
    return alertEl;
}




/**
 * DOM element references
 */ let $c20213e7535e565e$var$alertsContainer = null;
function $c20213e7535e565e$export$538086cfe5d4570(elements) {
    $c20213e7535e565e$var$alertsContainer = elements.alertsContainer || document.getElementById('alerts-container');
}
function $c20213e7535e565e$export$de026b00723010c1(message, variant = 'danger') {
    const container = $c20213e7535e565e$var$alertsContainer || document.getElementById('alerts-container');
    if (!container) return;
    const alertEl = (0, $7dfa749f2904b093$export$8fab56ae7bdc6ce7)(message, variant);
    container.appendChild(alertEl);
    // Auto-dismiss handler
    alertEl.addEventListener('alert-close', ()=>{
        alertEl.remove();
    });
    // Auto-remove after timeout
    setTimeout(()=>{
        if (alertEl.parentNode) alertEl.remove();
    }, (0, $65136e012e05e2d7$export$6fa442c45400f9a));
}
function $c20213e7535e565e$export$3c2d3ebc3b75f7ad(card) {
    const prixNetEl = card.querySelector('.prix-net');
    const quantityInput = card.querySelector('.quantity-input');
    const totalElement = card.querySelector('.total-card');
    if (!prixNetEl || !quantityInput || !totalElement) return;
    const prixNet = parseFloat(prixNetEl.textContent) || 0;
    const quantity = parseInt(quantityInput.value, 10) || 1;
    const newTotal = (prixNet * quantity).toFixed(2);
    totalElement.textContent = newTotal;
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Updated card total for product ID: ${card.dataset?.productId} to ${newTotal}`);
    $c20213e7535e565e$export$2b19701dd06a773d();
}
function $c20213e7535e565e$export$2b19701dd06a773d() {
    const container = document.getElementById('scanned-items-container');
    if (!container) return;
    const cards = container.querySelectorAll('.card');
    let globalTotal = 0;
    cards.forEach((card)=>{
        const totalEl = card.querySelector('.total-card');
        if (totalEl) globalTotal += parseFloat(totalEl.textContent) || 0;
    });
    const newGlobalTotal = globalTotal.toFixed(2);
    const globalTotalEl = document.querySelector('#global-total span');
    if (globalTotalEl) globalTotalEl.textContent = newGlobalTotal;
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Updated global total to: ${newGlobalTotal}`);
}
function $c20213e7535e565e$export$a43d25dadcf0aa1f(cameraPanel, error) {
    if (!cameraPanel) return;
    let errorMessage;
    if (error.name === 'NotAllowedError') errorMessage = '<strong>Error accessing camera</strong><br>Permission to use webcam was denied or video Autoplay is disabled. Reload the page to give appropriate permissions to webcam.';
    else errorMessage = error.message || 'Unknown camera error';
    const alertEl = (0, $7dfa749f2904b093$export$d64887ed5573eb0f)(errorMessage);
    // Clear panel and add error
    cameraPanel.innerHTML = '';
    cameraPanel.appendChild(alertEl);
}
function $c20213e7535e565e$export$7fcae63386833ccc(elements, scanning) {
    const { scanBtn: scanBtn, scanFrameEl: scanFrameEl, videoCaptureActionsEl: videoCaptureActionsEl } = elements;
    if (scanning) {
        scanBtn?.setAttribute('hidden', '');
        scanFrameEl?.removeAttribute('hidden');
        videoCaptureActionsEl?.removeAttribute('hidden');
    } else {
        scanBtn?.removeAttribute('hidden');
        scanFrameEl?.setAttribute('hidden', '');
        videoCaptureActionsEl?.setAttribute('hidden', '');
    }
}
function $c20213e7535e565e$export$bace5d6e1556d485(dossierId, elements) {
    const { dossierDisplay: dossierDisplay, dossierInputContainer: dossierInputContainer, dossierDisplayContainer: dossierDisplayContainer } = elements;
    if (dossierDisplay) dossierDisplay.textContent = `Num\xe9ro dossier : ${dossierId}`;
    if (dossierInputContainer) dossierInputContainer.hidden = true;
    if (dossierDisplayContainer) dossierDisplayContainer.hidden = false;
}
function $c20213e7535e565e$export$6dc038c060890dd2() {
    const container = document.getElementById('scanned-items-container');
    if (container) container.innerHTML = '';
    $c20213e7535e565e$export$2b19701dd06a773d();
}


/**
 * Authentication and customer management module
 */ 
// Storage keys
const $51226bd2db976b33$var$STORAGE_PREFIX = 'barcode-scanner/';
const $51226bd2db976b33$var$TOKEN_KEY = $51226bd2db976b33$var$STORAGE_PREFIX + 'api-token';
const $51226bd2db976b33$var$TOKEN_EXPIRY_KEY = $51226bd2db976b33$var$STORAGE_PREFIX + 'api-token-expiry';
const $51226bd2db976b33$export$ca6dda5263526f75 = "https://devapp.elite-ll.be";
/**
 * Logs into the backend and retrieves a fresh authentication token.
 * The login credentials are expected to be provided at build time via environment variables.
 *
 * @returns {Promise<string>} The newly generated token.
 * @throws {Error} If the login request fails or the response is not successful.
 */ async function $51226bd2db976b33$var$login() {
    const login = "api_user";
    const password = "123456@";
    if (!login || !password) throw new Error('Missing API_LOGIN or API_PASSWORD environment variables.');
    const response = await fetch(`${$51226bd2db976b33$export$ca6dda5263526f75}/API/login.php`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            login: login,
            password: password
        })
    });
    const result = await response.json();
    if (result.status === 'success' && result.token) {
        // Token is valid for 1 hour (3600 seconds).
        const expiry = Date.now() + 3600000;
        await (0, $dc2f4a51b83babfd$export$adaa4cf7ef1b65be)($51226bd2db976b33$var$TOKEN_KEY, result.token);
        await (0, $dc2f4a51b83babfd$export$adaa4cf7ef1b65be)($51226bd2db976b33$var$TOKEN_EXPIRY_KEY, expiry);
        return result.token;
    }
    throw new Error(result.message || 'Failed to retrieve token');
}
async function $51226bd2db976b33$export$257b2d10b709d8ef() {
    const [token, expiry] = await Promise.all([
        (0, $dc2f4a51b83babfd$export$3988ae62b71be9a3)($51226bd2db976b33$var$TOKEN_KEY),
        (0, $dc2f4a51b83babfd$export$3988ae62b71be9a3)($51226bd2db976b33$var$TOKEN_EXPIRY_KEY)
    ]);
    if (token && expiry && Date.now() < expiry) return token;
    return $51226bd2db976b33$var$login();
}



/**
 * Default timeout for API requests in milliseconds
 */ const $6a3074733bac15c1$var$API_TIMEOUT = 30000;
/**
 * Creates an AbortController with a timeout
 * @param {number} timeout - Timeout in milliseconds
 * @returns {{ controller: AbortController, timeoutId: number }}
 */ function $6a3074733bac15c1$var$createTimeoutController(timeout = $6a3074733bac15c1$var$API_TIMEOUT) {
    const controller = new AbortController();
    const timeoutId = setTimeout(()=>controller.abort(), timeout);
    return {
        controller: controller,
        timeoutId: timeoutId
    };
}
/**
 * Handles API response and parses JSON
 * @param {Response} response - Fetch response
 * @returns {Promise<object>} Parsed JSON response
 * @throws {Error} If response is not OK or JSON parsing fails
 */ async function $6a3074733bac15c1$var$handleResponse(response) {
    if (!response.ok) {
        const errorText = await response.text().catch(()=>'Unknown error');
        throw new Error(`HTTP ${response.status}: ${errorText}`);
    }
    const responseText = await response.text();
    if (!responseText.trim()) throw new Error('Empty response from server');
    try {
        return JSON.parse(responseText);
    } catch (parseError) {
        throw new Error(`Invalid JSON response: ${responseText.substring(0, 100)}`);
    }
}
async function $6a3074733bac15c1$export$52e83573e7782585(endpoint, body = {}, options = {}) {
    const { timeout: timeout = $6a3074733bac15c1$var$API_TIMEOUT } = options;
    const { controller: controller, timeoutId: timeoutId } = $6a3074733bac15c1$var$createTimeoutController(timeout);
    try {
        const token = await (0, $51226bd2db976b33$export$257b2d10b709d8ef)();
        const url = `${(0, $51226bd2db976b33$export$ca6dda5263526f75)}${endpoint}`;
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                token: token,
                ...body
            }),
            signal: controller.signal
        });
        clearTimeout(timeoutId);
        return await $6a3074733bac15c1$var$handleResponse(response);
    } catch (error) {
        clearTimeout(timeoutId);
        if (error.name === 'AbortError') throw new Error("La requ\xeate a expir\xe9. Veuillez r\xe9essayer.");
        throw error;
    }
}
async function $6a3074733bac15c1$export$28eb87eac4188ed6(optionId) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Fetching product data for option ID: ${optionId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Produits/produit-options-list-v2.php', {
        option_id: optionId
    });
    if (result.status === 'success' && result.count > 0) {
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product API response:', result.data[0]);
        return result.data[0];
    }
    throw new Error("Produit non trouv\xe9");
}
async function $6a3074733bac15c1$export$1ee67a47131fdbdf(clientId) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Validating client ID: ${clientId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Clients/clients-list-v2.php', {
        client_id: clientId
    });
    if (result.status === 'success' && result.count > 0) return result.data[0];
    throw new Error("Client non trouv\xe9");
}
async function $6a3074733bac15c1$export$d692d494e9613bda(dossierId) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Loading dossier ID: ${dossierId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossiers-list-v2.php', {
        fromId: parseInt(dossierId, 10),
        toId: parseInt(dossierId, 10)
    });
    if (result.status === 'success' && result.count > 0) return result.data[0];
    throw new Error("Dossier non trouv\xe9");
}
async function $6a3074733bac15c1$export$11876c3e5b9626b8(clientId, products) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Creating dossier for client ID: ${clientId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossier-create-update.php', {
        action: 'create_dossier',
        client_id: parseInt(clientId, 10),
        products: products
    });
    if (result.status === 'success' && result.dossier_id) return result;
    throw new Error(result.message || "Erreur lors de la cr\xe9ation du dossier");
}
async function $6a3074733bac15c1$export$8a00ba0527e2b09e(dossierId, clientId, productId, quantity) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Adding product ${productId} to dossier ${dossierId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossier-create-update.php', {
        action: 'add_product',
        client_id: parseInt(clientId, 10),
        dossier_id: parseInt(dossierId, 10),
        product_id: parseInt(productId, 10),
        quantity: parseInt(quantity, 10)
    });
    if (result.status === 'success' && result.product) return result;
    throw new Error(result.message || "Erreur lors de l'ajout du produit");
}
async function $6a3074733bac15c1$export$dd598ddf04376bb0(dossierProduitId, quantity) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Updating quantity for dossier product ${dossierProduitId} to ${quantity}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossier-create-update.php', {
        action: 'update_product_quantity',
        dossier_produit_id: parseInt(dossierProduitId, 10),
        quantity: parseInt(quantity, 10)
    });
    if (result.status === 'success') return result;
    throw new Error(result.message || "Erreur lors de la mise \xe0 jour de la quantit\xe9");
}
async function $6a3074733bac15c1$export$e927885c75ec02b(dossierProduitId) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Removing dossier product ${dossierProduitId}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossier-create-update.php', {
        action: 'remove_product',
        dossier_produit_id: parseInt(dossierProduitId, 10)
    });
    if (result.status === 'success') return result;
    throw new Error(result.message || 'Erreur lors de la suppression du produit');
}
async function $6a3074733bac15c1$export$ea55d8cf14b35e8f(dossierId, reference) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Updating reference for dossier ${dossierId}: ${reference}`);
    const result = await $6a3074733bac15c1$export$52e83573e7782585('/API/Sales/dossier-create-update.php', {
        action: 'update_dossier_reference',
        dossier_id: parseInt(dossierId, 10),
        dossier_reference: reference
    });
    if (result.status === 'success') return result;
    throw new Error(result.message || "Erreur lors de la mise \xe0 jour de la r\xe9f\xe9rence");
}




const $8b67e0cfbd81e7b2$export$69d25b90d0002cf3 = {
    NETWORK_ERROR: "Erreur de connexion. Veuillez v\xe9rifier votre connexion internet.",
    TIMEOUT_ERROR: "La requ\xeate a expir\xe9. Veuillez r\xe9essayer.",
    AUTH_ERROR: "Session expir\xe9e. Veuillez vous reconnecter.",
    PRODUCT_NOT_FOUND: "Produit non trouv\xe9.",
    CLIENT_NOT_FOUND: "Client non trouv\xe9.",
    DOSSIER_NOT_FOUND: "Dossier non trouv\xe9.",
    DOSSIER_CREATE_ERROR: "Erreur lors de la cr\xe9ation du dossier.",
    DOSSIER_UPDATE_ERROR: "Erreur lors de la mise \xe0 jour du dossier.",
    VALIDATION_REQUIRED: "Veuillez d'abord valider un client.",
    INVALID_RESPONSE: "R\xe9ponse du serveur invalide.",
    EMPTY_RESPONSE: "Le serveur a retourn\xe9 une r\xe9ponse vide.",
    SCAN_ERROR: "Erreur lors du scan. Veuillez r\xe9essayer.",
    CAMERA_PERMISSION_DENIED: "Permission d'acc\xe8s \xe0 la cam\xe9ra refus\xe9e. Veuillez autoriser l'acc\xe8s.",
    CAMERA_NOT_FOUND: "Aucune cam\xe9ra trouv\xe9e.",
    UNKNOWN_ERROR: 'Une erreur inattendue est survenue.'
};
/**
 * Maps error types to user-friendly messages
 * @param {Error} error - The error object
 * @returns {string} User-friendly error message
 */ function $8b67e0cfbd81e7b2$var$getErrorMessage(error) {
    const message = error.message?.toLowerCase() || '';
    if (error.name === 'AbortError' || message.includes('timeout') || message.includes("expir\xe9")) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.TIMEOUT_ERROR;
    if (error.name === 'TypeError' && message.includes('fetch')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.NETWORK_ERROR;
    if (message.includes('network') || message.includes('connexion')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.NETWORK_ERROR;
    if (message.includes('401') || message.includes('unauthorized') || message.includes('token')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.AUTH_ERROR;
    if (message.includes("produit non trouv\xe9") || message.includes('product not found')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.PRODUCT_NOT_FOUND;
    if (message.includes("client non trouv\xe9") || message.includes('client not found')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.CLIENT_NOT_FOUND;
    if (message.includes("dossier non trouv\xe9") || message.includes('dossier not found')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.DOSSIER_NOT_FOUND;
    if (message.includes('empty response') || message.includes("r\xe9ponse vide")) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.EMPTY_RESPONSE;
    if (message.includes('invalid json') || message.includes('json')) return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.INVALID_RESPONSE;
    // Return the error message if it's already in French and user-friendly
    if (error.message && !message.includes('error') && error.message.length < 100) return error.message;
    return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.UNKNOWN_ERROR;
}
function $8b67e0cfbd81e7b2$export$bd98d6b2b559620a(error, context = 'API', options = {}) {
    const { showToast: showToast = true, customMessage: customMessage = null } = options;
    // Log error with context
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error(`[${context}] Error:`, error);
    // Get user-friendly message
    const userMessage = customMessage || $8b67e0cfbd81e7b2$var$getErrorMessage(error);
    // Show toast notification
    if (showToast) (0, $0344530667b8f8fd$export$cbcbdc571577a620)(userMessage, {
        variant: 'danger'
    });
    return userMessage;
}
function $8b67e0cfbd81e7b2$export$d0351fde57d74dda(error) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('[Scanner] Error:', error);
    const message = error.message?.toLowerCase() || '';
    if (message.includes('no barcode') || message.includes('not detected')) // Silent failure for no barcode - this is expected during continuous scanning
    return;
    (0, $0344530667b8f8fd$export$cbcbdc571577a620)($8b67e0cfbd81e7b2$export$69d25b90d0002cf3.SCAN_ERROR, {
        variant: 'danger'
    });
}
function $8b67e0cfbd81e7b2$export$ed854a9f7453e273(error) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('[Camera] Error:', error);
    if (error.name === 'NotAllowedError') return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.CAMERA_PERMISSION_DENIED;
    if (error.name === 'NotFoundError') return $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.CAMERA_NOT_FOUND;
    return error.message || $8b67e0cfbd81e7b2$export$69d25b90d0002cf3.UNKNOWN_ERROR;
}
function $8b67e0cfbd81e7b2$export$c874c20f7c9f97c(fn, context, options = {}) {
    return async (...args)=>{
        try {
            return await fn(...args);
        } catch (error) {
            $8b67e0cfbd81e7b2$export$bd98d6b2b559620a(error, context, options);
            throw error; // Re-throw if caller needs to handle it
        }
    };
}
function $8b67e0cfbd81e7b2$export$731102f58bbc1f6d(fn, context) {
    return async (...args)=>{
        try {
            return await fn(...args);
        } catch (error) {
            $8b67e0cfbd81e7b2$export$bd98d6b2b559620a(error, context);
            return null;
        }
    };
}







/**
 * DOM element references (initialized on setup)
 */ let $5842cb61af962293$var$customerNumberInput = null;
let $5842cb61af962293$var$validateCustomerBtn = null;
let $5842cb61af962293$var$customerInfoDiv = null;
let $5842cb61af962293$var$dossierInfoDiv = null;
/**
 * Temporary storage for pending client confirmation
 */ let $5842cb61af962293$var$pendingClientData = null;
function $5842cb61af962293$export$6d3c879d7a79980d(elements) {
    $5842cb61af962293$var$customerNumberInput = elements.customerNumberInput;
    $5842cb61af962293$var$validateCustomerBtn = elements.validateCustomerBtn;
    $5842cb61af962293$var$customerInfoDiv = elements.customerInfoDiv;
    $5842cb61af962293$var$dossierInfoDiv = elements.dossierInfoDiv;
    // Set up initial event listener
    $5842cb61af962293$var$validateCustomerBtn?.addEventListener('click', $5842cb61af962293$export$3f7e93f0788ae07a);
}
async function $5842cb61af962293$export$3f7e93f0788ae07a() {
    const clientId = $5842cb61af962293$var$customerNumberInput?.value?.trim();
    if (!clientId) {
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).EMPTY_CLIENT_ID, {
            variant: 'danger'
        });
        return;
    }
    try {
        const client = await (0, $6a3074733bac15c1$export$1ee67a47131fdbdf)(clientId);
        // Build welcome message
        let welcomeMessage = `Bonjour ${client.client_nom}`;
        if (client.client_num_tva) welcomeMessage += ` (${client.client_num_tva})`;
        // Update UI
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = welcomeMessage;
        if ($5842cb61af962293$var$customerNumberInput) {
            $5842cb61af962293$var$customerNumberInput.value = clientId;
            $5842cb61af962293$var$customerNumberInput.readOnly = true;
        }
        // Update button state
        if ($5842cb61af962293$var$validateCustomerBtn) {
            $5842cb61af962293$var$validateCustomerBtn.textContent = 'Modifier';
            $5842cb61af962293$var$validateCustomerBtn.classList.remove('btn-primary');
            $5842cb61af962293$var$validateCustomerBtn.classList.add('btn-warning');
            $5842cb61af962293$var$validateCustomerBtn.removeEventListener('click', $5842cb61af962293$export$3f7e93f0788ae07a);
            $5842cb61af962293$var$validateCustomerBtn.addEventListener('click', $5842cb61af962293$export$daeb73e8495871f0);
        }
        // Store client ID
        (0, $fd2d3348854bcc99$export$515b2f2cc4592ad)(clientId);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Customer validated: ${clientId}`);
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Customer Validation');
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = '';
    }
}
function $5842cb61af962293$export$daeb73e8495871f0() {
    if (!confirm((0, $65136e012e05e2d7$export$69d25b90d0002cf3).CONFIRM_EDIT_CUSTOMER)) return;
    // Reset input state
    if ($5842cb61af962293$var$customerNumberInput) $5842cb61af962293$var$customerNumberInput.readOnly = false;
    if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = '';
    // Reset button state
    if ($5842cb61af962293$var$validateCustomerBtn) {
        $5842cb61af962293$var$validateCustomerBtn.textContent = 'Valider';
        $5842cb61af962293$var$validateCustomerBtn.classList.remove('btn-warning');
        $5842cb61af962293$var$validateCustomerBtn.classList.add('btn-primary');
        $5842cb61af962293$var$validateCustomerBtn.removeEventListener('click', $5842cb61af962293$export$daeb73e8495871f0);
        $5842cb61af962293$var$validateCustomerBtn.addEventListener('click', $5842cb61af962293$export$3f7e93f0788ae07a);
    }
    // Clear stored data
    (0, $fd2d3348854bcc99$export$7809a8af6f3e4c63)();
    if ($5842cb61af962293$var$dossierInfoDiv) $5842cb61af962293$var$dossierInfoDiv.textContent = '';
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Customer edit mode enabled');
}
async function $5842cb61af962293$export$338ba8cd2efd0730(clientId) {
    if (!clientId) {
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = '';
        return;
    }
    try {
        const client = await (0, $6a3074733bac15c1$export$1ee67a47131fdbdf)(clientId);
        let welcomeMessage = `Bonjour ${client.client_nom}`;
        if (client.client_num_tva) welcomeMessage += ` (${client.client_num_tva})`;
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = welcomeMessage;
    } catch (error) {
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Error fetching customer info:', error);
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = (0, $65136e012e05e2d7$export$69d25b90d0002cf3).CLIENT_NOT_FOUND;
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).NETWORK_ERROR, {
            variant: 'danger'
        });
    }
}
function $5842cb61af962293$export$b6387ab7e5774447() {
    const clientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
    if (clientId && $5842cb61af962293$var$customerNumberInput) {
        $5842cb61af962293$var$customerNumberInput.value = clientId;
        $5842cb61af962293$export$338ba8cd2efd0730(clientId);
    } else if ($5842cb61af962293$var$customerNumberInput) {
        $5842cb61af962293$var$customerNumberInput.value = '';
        if ($5842cb61af962293$var$customerInfoDiv) $5842cb61af962293$var$customerInfoDiv.textContent = '';
    }
}
function $5842cb61af962293$export$5be0ad8f5a11efec(editing, editValidateBtn) {
    if ($5842cb61af962293$var$customerNumberInput) $5842cb61af962293$var$customerNumberInput.readOnly = !editing;
    if (editValidateBtn) {
        if (editing) {
            editValidateBtn.textContent = 'Valider';
            editValidateBtn.classList.remove('btn-warning');
            editValidateBtn.classList.add('btn-primary');
            $5842cb61af962293$var$customerNumberInput?.focus();
            $5842cb61af962293$var$customerNumberInput?.select();
        } else {
            editValidateBtn.textContent = 'Modifier';
            editValidateBtn.classList.remove('btn-primary');
            editValidateBtn.classList.add('btn-warning');
        }
    }
    return editing;
}
async function $5842cb61af962293$export$e74df61143124aea(newClientId, elements) {
    const { errorEl: errorEl, clientIdStep: clientIdStep, confirmStep: confirmStep, confirmNameEl: confirmNameEl, confirmVatEl: confirmVatEl } = elements;
    const trimmedId = newClientId?.trim();
    if (!trimmedId) {
        if (errorEl) errorEl.hidden = false;
        return false;
    }
    if (errorEl) errorEl.hidden = true;
    try {
        // Validate client with API
        const client = await (0, $6a3074733bac15c1$export$1ee67a47131fdbdf)(trimmedId);
        // Store pending data for confirmation
        $5842cb61af962293$var$pendingClientData = {
            clientId: trimmedId,
            clientName: client.client_nom,
            clientVat: client.client_num_tva
        };
        // Show confirmation step
        if (confirmNameEl) confirmNameEl.textContent = client.client_nom || 'Client';
        if (confirmVatEl) confirmVatEl.textContent = client.client_num_tva || '';
        if (clientIdStep) clientIdStep.hidden = true;
        if (confirmStep) confirmStep.hidden = false;
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Client validated, awaiting confirmation: ${trimmedId}`);
        return true;
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Client Validation');
        return false;
    }
}
async function $5842cb61af962293$export$dc59cd457aad55e2(elements) {
    const { modal: modal, mainContent: mainContent } = elements;
    if (!$5842cb61af962293$var$pendingClientData) {
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('No pending client data for confirmation');
        return false;
    }
    const currentClientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
    // Clear old data if client changed
    if (currentClientId && $5842cb61af962293$var$pendingClientData.clientId !== currentClientId) {
        await (0, $0eb43b201e9f90c7$export$b969c7435cea2ca6)();
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)("Ancien donn\xe9es client effac\xe9es.");
    }
    // Save the confirmed client
    (0, $fd2d3348854bcc99$export$515b2f2cc4592ad)($5842cb61af962293$var$pendingClientData.clientId);
    if (modal) modal.hidden = true;
    if (mainContent) mainContent.hidden = false;
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Client confirmed: ${$5842cb61af962293$var$pendingClientData.clientId}`);
    // Clear pending data
    $5842cb61af962293$var$pendingClientData = null;
    return true;
}
function $5842cb61af962293$export$24ee8f6b0e365210(elements) {
    const { clientIdStep: clientIdStep, confirmStep: confirmStep, clientIdInput: clientIdInput } = elements;
    // Clear pending data
    $5842cb61af962293$var$pendingClientData = null;
    // Return to step 1
    if (confirmStep) confirmStep.hidden = true;
    if (clientIdStep) clientIdStep.hidden = false;
    // Clear and focus input
    if (clientIdInput) {
        clientIdInput.value = '';
        clientIdInput.focus();
    }
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Client confirmation cancelled, returning to input');
}


/**
 * Dossier management module
 */ 





/**
 * Product module - Product fetching and card management
 */ 








/**
 * Product Confirmation Module - Handles the product confirmation popup
 */ 

/**
 * DOM element references
 */ let $7a5b8f925ffbbe37$var$modal = null;
let $7a5b8f925ffbbe37$var$productRefEl = null;
let $7a5b8f925ffbbe37$var$productDescEl = null;
let $7a5b8f925ffbbe37$var$prixBrutEl = null;
let $7a5b8f925ffbbe37$var$remiseEl = null;
let $7a5b8f925ffbbe37$var$prixNetEl = null;
let $7a5b8f925ffbbe37$var$quantityInput = null;
let $7a5b8f925ffbbe37$var$totalEl = null;
let $7a5b8f925ffbbe37$var$confirmBtn = null;
let $7a5b8f925ffbbe37$var$cancelBtn = null;
let $7a5b8f925ffbbe37$var$qtyDecreaseBtn = null;
let $7a5b8f925ffbbe37$var$qtyIncreaseBtn = null;
/**
 * Current product data and callbacks
 */ let $7a5b8f925ffbbe37$var$currentProduct = null;
let $7a5b8f925ffbbe37$var$onConfirmCallback = null;
let $7a5b8f925ffbbe37$var$onCancelCallback = null;
function $7a5b8f925ffbbe37$export$f8f1e389c63efc79() {
    $7a5b8f925ffbbe37$var$modal = document.getElementById('product-confirm-modal');
    $7a5b8f925ffbbe37$var$productRefEl = document.getElementById('confirm-product-ref');
    $7a5b8f925ffbbe37$var$productDescEl = document.getElementById('confirm-product-desc');
    $7a5b8f925ffbbe37$var$prixBrutEl = document.getElementById('confirm-prix-brut');
    $7a5b8f925ffbbe37$var$remiseEl = document.getElementById('confirm-remise');
    $7a5b8f925ffbbe37$var$prixNetEl = document.getElementById('confirm-prix-net');
    $7a5b8f925ffbbe37$var$quantityInput = document.getElementById('confirm-quantity');
    $7a5b8f925ffbbe37$var$totalEl = document.getElementById('confirm-total');
    $7a5b8f925ffbbe37$var$confirmBtn = document.getElementById('confirm-add-btn');
    $7a5b8f925ffbbe37$var$cancelBtn = document.getElementById('confirm-cancel-btn');
    $7a5b8f925ffbbe37$var$qtyDecreaseBtn = document.getElementById('qty-decrease');
    $7a5b8f925ffbbe37$var$qtyIncreaseBtn = document.getElementById('qty-increase');
    // Set up event listeners
    $7a5b8f925ffbbe37$var$confirmBtn?.addEventListener('click', $7a5b8f925ffbbe37$var$handleConfirm);
    $7a5b8f925ffbbe37$var$cancelBtn?.addEventListener('click', $7a5b8f925ffbbe37$var$handleCancel);
    $7a5b8f925ffbbe37$var$qtyDecreaseBtn?.addEventListener('click', $7a5b8f925ffbbe37$var$decreaseQuantity);
    $7a5b8f925ffbbe37$var$qtyIncreaseBtn?.addEventListener('click', $7a5b8f925ffbbe37$var$increaseQuantity);
    $7a5b8f925ffbbe37$var$quantityInput?.addEventListener('input', $7a5b8f925ffbbe37$var$updateTotal);
    $7a5b8f925ffbbe37$var$quantityInput?.addEventListener('change', $7a5b8f925ffbbe37$var$validateQuantity);
    // Close on escape key
    document.addEventListener('keydown', (e)=>{
        if (e.key === 'Escape' && $7a5b8f925ffbbe37$var$modal && !$7a5b8f925ffbbe37$var$modal.hidden) $7a5b8f925ffbbe37$var$handleCancel();
    });
    // Close on overlay click
    $7a5b8f925ffbbe37$var$modal?.addEventListener('click', (e)=>{
        if (e.target === $7a5b8f925ffbbe37$var$modal) $7a5b8f925ffbbe37$var$handleCancel();
    });
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product confirmation module initialized');
}
function $7a5b8f925ffbbe37$export$380acf7f39cff3bd(product, onConfirm, onCancel) {
    if (!$7a5b8f925ffbbe37$var$modal) {
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Product confirmation modal not initialized');
        return;
    }
    $7a5b8f925ffbbe37$var$currentProduct = product;
    $7a5b8f925ffbbe37$var$onConfirmCallback = onConfirm;
    $7a5b8f925ffbbe37$var$onCancelCallback = onCancel;
    // Populate modal with product data
    const prixHt = parseFloat(product.option_prix_ht || 0);
    const remise = parseFloat(product.option_remise_conseillee || 0);
    const prixNet = prixHt * (1 - remise / 100);
    $7a5b8f925ffbbe37$var$productRefEl.textContent = `${product.option_reference || ''} [${product.produit_id || product.option_id}]`;
    $7a5b8f925ffbbe37$var$productDescEl.textContent = product.option_description || '';
    $7a5b8f925ffbbe37$var$prixBrutEl.textContent = prixHt.toFixed(2);
    $7a5b8f925ffbbe37$var$remiseEl.textContent = remise.toFixed(0);
    $7a5b8f925ffbbe37$var$prixNetEl.textContent = prixNet.toFixed(2);
    // Reset quantity to 1
    $7a5b8f925ffbbe37$var$quantityInput.value = 1;
    $7a5b8f925ffbbe37$var$updateTotal();
    // Show modal
    $7a5b8f925ffbbe37$var$modal.hidden = false;
    // Focus quantity input for easy adjustment
    setTimeout(()=>$7a5b8f925ffbbe37$var$quantityInput?.focus(), 100);
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product confirmation modal shown for:', product.option_reference);
}
function $7a5b8f925ffbbe37$export$f7c7ef33c092cc() {
    if ($7a5b8f925ffbbe37$var$modal) $7a5b8f925ffbbe37$var$modal.hidden = true;
    $7a5b8f925ffbbe37$var$currentProduct = null;
    $7a5b8f925ffbbe37$var$onConfirmCallback = null;
    $7a5b8f925ffbbe37$var$onCancelCallback = null;
}
/**
 * Handles confirm button click
 */ async function $7a5b8f925ffbbe37$var$handleConfirm() {
    if (!$7a5b8f925ffbbe37$var$currentProduct || !$7a5b8f925ffbbe37$var$onConfirmCallback) return;
    const quantity = parseInt($7a5b8f925ffbbe37$var$quantityInput.value, 10) || 1;
    // Disable button while processing
    $7a5b8f925ffbbe37$var$confirmBtn.disabled = true;
    $7a5b8f925ffbbe37$var$confirmBtn.textContent = 'Ajout...';
    try {
        await $7a5b8f925ffbbe37$var$onConfirmCallback($7a5b8f925ffbbe37$var$currentProduct, quantity);
        // Show success toast
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)("Produit ajout\xe9 avec succ\xe8s!", {
            variant: 'success',
            duration: 3000
        });
        $7a5b8f925ffbbe37$export$f7c7ef33c092cc();
    } catch (error) {
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error('Error adding product:', error);
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)('Erreur lors de l\'ajout du produit', {
            variant: 'danger',
            duration: 5000
        });
    } finally{
        $7a5b8f925ffbbe37$var$confirmBtn.disabled = false;
        $7a5b8f925ffbbe37$var$confirmBtn.textContent = 'Valider';
    }
}
/**
 * Handles cancel button click
 */ function $7a5b8f925ffbbe37$var$handleCancel() {
    if ($7a5b8f925ffbbe37$var$onCancelCallback) $7a5b8f925ffbbe37$var$onCancelCallback();
    $7a5b8f925ffbbe37$export$f7c7ef33c092cc();
}
/**
 * Decreases quantity by 1
 */ function $7a5b8f925ffbbe37$var$decreaseQuantity() {
    const current = parseInt($7a5b8f925ffbbe37$var$quantityInput.value, 10) || 1;
    if (current > 1) {
        $7a5b8f925ffbbe37$var$quantityInput.value = current - 1;
        $7a5b8f925ffbbe37$var$updateTotal();
    }
}
/**
 * Increases quantity by 1
 */ function $7a5b8f925ffbbe37$var$increaseQuantity() {
    const current = parseInt($7a5b8f925ffbbe37$var$quantityInput.value, 10) || 1;
    $7a5b8f925ffbbe37$var$quantityInput.value = current + 1;
    $7a5b8f925ffbbe37$var$updateTotal();
}
/**
 * Validates quantity input
 */ function $7a5b8f925ffbbe37$var$validateQuantity() {
    const value = parseInt($7a5b8f925ffbbe37$var$quantityInput.value, 10);
    if (isNaN(value) || value < 1) $7a5b8f925ffbbe37$var$quantityInput.value = 1;
    $7a5b8f925ffbbe37$var$updateTotal();
}
/**
 * Updates the total display based on quantity
 */ function $7a5b8f925ffbbe37$var$updateTotal() {
    if (!$7a5b8f925ffbbe37$var$currentProduct) return;
    const prixHt = parseFloat($7a5b8f925ffbbe37$var$currentProduct.option_prix_ht || 0);
    const remise = parseFloat($7a5b8f925ffbbe37$var$currentProduct.option_remise_conseillee || 0);
    const prixNet = prixHt * (1 - remise / 100);
    const quantity = parseInt($7a5b8f925ffbbe37$var$quantityInput.value, 10) || 1;
    const total = prixNet * quantity;
    $7a5b8f925ffbbe37$var$totalEl.textContent = total.toFixed(2) + " \u20AC";
}


async function $da8cf946b66c37dc$export$af56ca1b22e54f7a(scannedId) {
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Fetching product data for scanned ID: ${scannedId}`);
    try {
        const product = await (0, $6a3074733bac15c1$export$28eb87eac4188ed6)(scannedId);
        // Show confirmation modal instead of adding directly
        (0, $7a5b8f925ffbbe37$export$380acf7f39cff3bd)(product, // On confirm: add product with specified quantity
        async (confirmedProduct, quantity)=>{
            await $da8cf946b66c37dc$export$584d755fd7b9b32f(confirmedProduct, quantity);
        }, // On cancel: just log and continue
        ()=>{
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product addition cancelled by user');
        });
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Fetch Product', {
            customMessage: (0, $65136e012e05e2d7$export$69d25b90d0002cf3).PRODUCT_NOT_FOUND
        });
    }
}
async function $da8cf946b66c37dc$export$584d755fd7b9b32f(product, quantity = 1) {
    const container = document.getElementById('scanned-items-container');
    if (!container) return;
    const existingCard = container.querySelector(`[data-product-id="${product.option_id}"]`);
    const dossierId = (0, $fd2d3348854bcc99$export$98333c9677aec7cf)();
    if (existingCard) {
        // Update existing card quantity
        const quantityInput = existingCard.querySelector('.quantity-input');
        if (quantityInput) {
            quantityInput.value = parseInt(quantityInput.value, 10) + quantity;
            (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Updated quantity for product ID: ${product.option_id} to ${quantityInput.value}`);
            (0, $c20213e7535e565e$export$3c2d3ebc3b75f7ad)(existingCard);
            await (0, $f8cb94557afd29ac$export$10e370133a3c5e1c)(existingCard);
        }
    } else {
        // Create new card with specified quantity (prepend to show latest first)
        const card = (0, $7dfa749f2904b093$export$99d4d4500133757a)(product, {
            quantity: quantity
        });
        container.prepend(card);
        // Set up event listeners
        const quantityInput = card.querySelector('.quantity-input');
        const deleteButton = card.querySelector('.btn-close');
        const addQuantityListener = ()=>{
            quantityInput?.addEventListener('change', async ()=>{
                (0, $c20213e7535e565e$export$3c2d3ebc3b75f7ad)(card);
                await (0, $f8cb94557afd29ac$export$10e370133a3c5e1c)(card);
            });
        };
        deleteButton?.addEventListener('click', ()=>(0, $f8cb94557afd29ac$export$e927885c75ec02b)(card));
        if (dossierId) {
            await (0, $f8cb94557afd29ac$export$8a00ba0527e2b09e)(card);
            addQuantityListener();
        } else addQuantityListener();
    }
    (0, $c20213e7535e565e$export$2b19701dd06a773d)();
    if (!dossierId) await (0, $f8cb94557afd29ac$export$9a28652b359ee373)();
}
function $da8cf946b66c37dc$export$7cff7b3f885b05eb(item, productDetails = null) {
    const container = document.getElementById('scanned-items-container');
    if (!container) return;
    const quantity = parseInt(item.dossier_produit_qte, 10);
    const prixHt = parseFloat(item.dossier_produit_prix_ht);
    const remise = parseFloat(item.dossier_produit_remise);
    const prixNet = prixHt * (1 - remise / 100);
    const total = prixNet * quantity;
    // Use product details if available, fallback to item data
    const optionReference = productDetails?.option_reference || item.option_reference || '';
    const produitId = productDetails?.produit_id || item.produit_id || item.option_id;
    // Create card using safe DOM methods
    const card = (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
        className: 'col-12 col-md-6 col-lg-4 mb-3',
        dataset: {
            productId: item.option_id,
            dossierProduitId: item.dossier_produit_id
        }
    }, [
        (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
            className: 'card'
        }, [
            // Header
            (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
                className: 'card-header d-flex justify-content-between align-items-center'
            }, [
                (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('h5', {
                    className: 'card-title mb-0'
                }, `${optionReference} [${produitId}]`),
                (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('button', {
                    type: 'button',
                    className: 'btn-close',
                    'aria-label': 'Close'
                })
            ]),
            // Body
            (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
                className: 'card-body'
            }, [
                (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('p', {
                    className: 'text-muted small'
                }, item.dossier_produit_nom || ''),
                $da8cf946b66c37dc$var$createPricingParagraph(prixHt, remise, prixNet),
                (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
                    className: 'd-flex justify-content-between align-items-center'
                }, [
                    (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('div', {
                        className: 'input-group w-50'
                    }, [
                        (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('span', {
                            className: 'input-group-text'
                        }, "Qt\xe9"),
                        (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('input', {
                            type: 'number',
                            className: 'form-control quantity-input',
                            value: String(quantity),
                            min: '1'
                        })
                    ]),
                    (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('p', {
                        className: 'card-text mb-0'
                    }, [
                        (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('strong', {}, 'Total: '),
                        (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('span', {
                            className: 'total-card'
                        }, total.toFixed(2))
                    ])
                ])
            ])
        ])
    ]);
    container.prepend(card);
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Added product from dossier to card:', item);
    // Set up event listeners
    const quantityInput = card.querySelector('.quantity-input');
    quantityInput?.addEventListener('change', async ()=>{
        (0, $c20213e7535e565e$export$3c2d3ebc3b75f7ad)(card);
        await (0, $f8cb94557afd29ac$export$10e370133a3c5e1c)(card);
    });
    const deleteButton = card.querySelector('.btn-close');
    deleteButton?.addEventListener('click', ()=>(0, $f8cb94557afd29ac$export$e927885c75ec02b)(card));
}
/**
 * Creates a pricing paragraph element
 * @param {number} prixHt - Gross price
 * @param {number} remise - Discount percentage
 * @param {number} prixNet - Net price
 * @returns {HTMLElement} Pricing paragraph
 */ function $da8cf946b66c37dc$var$createPricingParagraph(prixHt, remise, prixNet) {
    const p = (0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('p', {
        className: 'card-text'
    });
    p.appendChild((0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('strong', {}, 'P. Brut:'));
    p.appendChild(document.createTextNode(` ${prixHt.toFixed(2)} `));
    p.appendChild(document.createElement('br'));
    p.appendChild((0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('strong', {}, 'Remise:'));
    p.appendChild(document.createTextNode(` ${remise}% `));
    p.appendChild(document.createElement('br'));
    p.appendChild((0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('strong', {
        className: 'prix-net-label'
    }, 'P. Net:'));
    p.appendChild(document.createTextNode(' '));
    p.appendChild((0, $7dfa749f2904b093$export$c8a8987d4410bf2d)('span', {
        className: 'prix-net'
    }, prixNet.toFixed(2)));
    return p;
}
function $da8cf946b66c37dc$export$d10e179800549eda(card, productDetails) {
    // Set the dossier product ID
    card.setAttribute('data-dossier-produit-id', productDetails.dossier_produit_id);
    // Card title is already set correctly by createProductCard, no need to update
    // Update pricing information
    const cardBody = card.querySelector('.card-body');
    if (cardBody) {
        const prixNet = parseFloat(productDetails.final_price) / parseInt(productDetails.quantity, 10);
        const total = parseFloat(productDetails.final_price);
        const prixHt = parseFloat(productDetails.original_price);
        const remise = parseFloat(productDetails.applied_discount);
        // Update pricing display
        (0, $7dfa749f2904b093$export$188572f6f214cb74)(cardBody, prixHt, remise, prixNet);
        // Update total
        const totalElement = cardBody.querySelector('.total-card');
        if (totalElement) totalElement.textContent = total.toFixed(2);
        // Update quantity if changed
        const quantityInput = cardBody.querySelector('.quantity-input');
        if (quantityInput && parseInt(quantityInput.value, 10) !== productDetails.quantity) quantityInput.value = productDetails.quantity;
    }
    (0, $c20213e7535e565e$export$2b19701dd06a773d)();
}


/**
 * DOM element references (initialized on setup)
 */ let $f8cb94557afd29ac$var$dossierInputContainer = null;
let $f8cb94557afd29ac$var$dossierNumberInput = null;
let $f8cb94557afd29ac$var$dossierDisplayContainer = null;
let $f8cb94557afd29ac$var$dossierDisplay = null;
let $f8cb94557afd29ac$var$scannedItemsContainer = null;
let $f8cb94557afd29ac$var$dossierReferenceInput = null;
let $f8cb94557afd29ac$var$saveReferenceBtn = null;
let $f8cb94557afd29ac$var$referenceSavedIndicator = null;
let $f8cb94557afd29ac$var$endSessionBtn = null;
function $f8cb94557afd29ac$export$43ad82df239a300c(elements) {
    $f8cb94557afd29ac$var$dossierInputContainer = elements.dossierInputContainer;
    $f8cb94557afd29ac$var$dossierNumberInput = elements.dossierNumberInput;
    $f8cb94557afd29ac$var$dossierDisplayContainer = elements.dossierDisplayContainer;
    $f8cb94557afd29ac$var$dossierDisplay = elements.dossierDisplay;
    $f8cb94557afd29ac$var$scannedItemsContainer = elements.scannedItemsContainer || document.getElementById('scanned-items-container');
    // Reference elements
    $f8cb94557afd29ac$var$dossierReferenceInput = document.getElementById('dossier-reference');
    $f8cb94557afd29ac$var$saveReferenceBtn = document.getElementById('save-reference-btn');
    $f8cb94557afd29ac$var$referenceSavedIndicator = document.getElementById('reference-saved-indicator');
    $f8cb94557afd29ac$var$endSessionBtn = document.getElementById('end-session-btn');
    // Set up reference save handler
    $f8cb94557afd29ac$var$saveReferenceBtn?.addEventListener('click', $f8cb94557afd29ac$export$fb09bad7d3252a25);
    $f8cb94557afd29ac$var$dossierReferenceInput?.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            $f8cb94557afd29ac$export$fb09bad7d3252a25();
        }
    });
}
function $f8cb94557afd29ac$export$2869a3fb2e9dc4eb(dossierId, reference = '') {
    if ($f8cb94557afd29ac$var$dossierDisplay) $f8cb94557afd29ac$var$dossierDisplay.textContent = `Num\xe9ro dossier : ${dossierId}`;
    if ($f8cb94557afd29ac$var$dossierInputContainer) $f8cb94557afd29ac$var$dossierInputContainer.hidden = true;
    if ($f8cb94557afd29ac$var$dossierDisplayContainer) $f8cb94557afd29ac$var$dossierDisplayContainer.hidden = false;
    // Set reference if available
    if ($f8cb94557afd29ac$var$dossierReferenceInput) $f8cb94557afd29ac$var$dossierReferenceInput.value = reference || '';
    // Hide saved indicator when showing display
    if ($f8cb94557afd29ac$var$referenceSavedIndicator) $f8cb94557afd29ac$var$referenceSavedIndicator.hidden = true;
    // Show bottom end session button
    if ($f8cb94557afd29ac$var$endSessionBtn) $f8cb94557afd29ac$var$endSessionBtn.hidden = false;
}
function $f8cb94557afd29ac$export$fd4d6122d783d5cb() {
    if ($f8cb94557afd29ac$var$dossierNumberInput) $f8cb94557afd29ac$var$dossierNumberInput.value = '';
    if ($f8cb94557afd29ac$var$dossierInputContainer) $f8cb94557afd29ac$var$dossierInputContainer.hidden = false;
    if ($f8cb94557afd29ac$var$dossierDisplayContainer) $f8cb94557afd29ac$var$dossierDisplayContainer.hidden = true;
    // Reset reference field
    if ($f8cb94557afd29ac$var$dossierReferenceInput) $f8cb94557afd29ac$var$dossierReferenceInput.value = '';
    if ($f8cb94557afd29ac$var$referenceSavedIndicator) $f8cb94557afd29ac$var$referenceSavedIndicator.hidden = true;
    // Hide bottom end session button
    if ($f8cb94557afd29ac$var$endSessionBtn) $f8cb94557afd29ac$var$endSessionBtn.hidden = true;
}
async function $f8cb94557afd29ac$export$a23fbf1d8e34a2a3(dossierId) {
    if (!dossierId) return;
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Loading products for dossier ID: ${dossierId}`);
    try {
        const dossierData = await (0, $6a3074733bac15c1$export$d692d494e9613bda)(dossierId);
        const clientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
        // Check client match (convert both to string for comparison)
        if (clientId && String(dossierData.client_id) !== String(clientId)) {
            (0, $c20213e7535e565e$export$de026b00723010c1)(`Le dossier #${dossierId} est associ\xe9 \xe0 un autre client. La session du dossier a \xe9t\xe9 r\xe9initialis\xe9e.`);
            $f8cb94557afd29ac$export$f50eb229b7c582ed();
            return;
        }
        // Clear existing cards
        const container = $f8cb94557afd29ac$var$scannedItemsContainer || document.getElementById('scanned-items-container');
        if (container) container.innerHTML = '';
        // Add items to UI with product details
        if (dossierData.items) for (const item of dossierData.items){
            // Fetch product details to get option_reference
            let productDetails = null;
            try {
                productDetails = await (0, $6a3074733bac15c1$export$28eb87eac4188ed6)(item.option_id);
            } catch  {
                // Product details not available, continue with item data only
                (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Could not fetch details for product ${item.option_id}`);
            }
            (0, $da8cf946b66c37dc$export$7cff7b3f885b05eb)(item, productDetails);
        }
        (0, $c20213e7535e565e$export$2b19701dd06a773d)();
        (0, $fd2d3348854bcc99$export$737a550610301656)(dossierId);
        $f8cb94557afd29ac$export$2869a3fb2e9dc4eb(dossierId, dossierData.dossier_reference || '');
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Successfully loaded ${dossierData.items?.length || 0} products from dossier.`);
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Load Dossier');
        (0, $c20213e7535e565e$export$de026b00723010c1)(`Impossible de charger les produits du dossier ${dossierId}. Le dossier est peut-\xeatre vide ou a \xe9t\xe9 supprim\xe9.`);
        if ((0, $fd2d3348854bcc99$export$98333c9677aec7cf)() === dossierId) $f8cb94557afd29ac$export$f50eb229b7c582ed();
    }
}
async function $f8cb94557afd29ac$export$11876c3e5b9626b8(productCard) {
    const clientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
    if (!clientId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).VALIDATION_REQUIRED);
        return null;
    }
    const products = [
        {
            product_id: parseInt(productCard.dataset.productId, 10),
            quantity: parseInt(productCard.querySelector('.quantity-input').value, 10)
        }
    ];
    try {
        const result = await (0, $6a3074733bac15c1$export$11876c3e5b9626b8)(clientId, products);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Dossier created successfully:', result);
        // Update card with dossier product ID
        if (result.products && result.products.length > 0) productCard.setAttribute('data-dossier-produit-id', result.products[0].dossier_produit_id);
        return result.dossier_id;
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Create Dossier');
        return null;
    }
}
async function $f8cb94557afd29ac$export$8a00ba0527e2b09e(card) {
    const dossierId = (0, $fd2d3348854bcc99$export$98333c9677aec7cf)();
    const clientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
    if (!dossierId || !clientId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)('Dossier ou client non valide.');
        return;
    }
    try {
        const result = await (0, $6a3074733bac15c1$export$8a00ba0527e2b09e)(dossierId, clientId, card.dataset.productId, card.querySelector('.quantity-input').value);
        // Update card with detailed product information
        (0, $da8cf946b66c37dc$export$d10e179800549eda)(card, result.product);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product added to dossier:', result);
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Add Product to Dossier');
    }
}
async function $f8cb94557afd29ac$export$10e370133a3c5e1c(card) {
    let dossierProduitId = card.dataset.dossierProduitId;
    if (!dossierProduitId) {
        // Try to get from parent element
        const parentCard = card.closest('[data-dossier-produit-id]');
        if (parentCard) {
            dossierProduitId = parentCard.dataset.dossierProduitId;
            card.dataset.dossierProduitId = dossierProduitId;
        }
    }
    if (!dossierProduitId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).MISSING_DOSSIER_PRODUCT_ID + " Veuillez r\xe9essayer.");
        return;
    }
    try {
        await (0, $6a3074733bac15c1$export$dd598ddf04376bb0)(dossierProduitId, card.querySelector('.quantity-input').value);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product quantity updated successfully.');
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Update Quantity');
    }
}
async function $f8cb94557afd29ac$export$e927885c75ec02b(card) {
    const dossierProduitId = card.dataset.dossierProduitId;
    if (!dossierProduitId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).MISSING_DOSSIER_PRODUCT_ID);
        return;
    }
    if (!confirm((0, $65136e012e05e2d7$export$69d25b90d0002cf3).CONFIRM_DELETE_PRODUCT)) return;
    try {
        await (0, $6a3074733bac15c1$export$e927885c75ec02b)(dossierProduitId);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Product removed successfully.');
        card.remove();
        (0, $c20213e7535e565e$export$2b19701dd06a773d)();
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Remove Product');
    }
}
async function $f8cb94557afd29ac$export$9a28652b359ee373() {
    let dossierId = (0, $fd2d3348854bcc99$export$98333c9677aec7cf)();
    if (!dossierId) {
        const container = $f8cb94557afd29ac$var$scannedItemsContainer || document.getElementById('scanned-items-container');
        const firstCard = container?.querySelector('.card')?.parentElement;
        if (!firstCard) return;
        dossierId = await $f8cb94557afd29ac$export$11876c3e5b9626b8(firstCard);
        if (dossierId) {
            (0, $fd2d3348854bcc99$export$737a550610301656)(dossierId);
            $f8cb94557afd29ac$export$2869a3fb2e9dc4eb(dossierId);
        }
    }
}
function $f8cb94557afd29ac$export$f50eb229b7c582ed() {
    (0, $fd2d3348854bcc99$export$737a550610301656)(null);
    $f8cb94557afd29ac$export$fd4d6122d783d5cb();
    const container = $f8cb94557afd29ac$var$scannedItemsContainer || document.getElementById('scanned-items-container');
    if (container) container.innerHTML = '';
    (0, $c20213e7535e565e$export$2b19701dd06a773d)();
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Dossier has been reset.');
}
async function $f8cb94557afd29ac$export$9c5ff91e64a5a8f6() {
    const dossierId = $f8cb94557afd29ac$var$dossierNumberInput?.value;
    if (!dossierId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)((0, $65136e012e05e2d7$export$69d25b90d0002cf3).EMPTY_DOSSIER_ID);
        return;
    }
    await $f8cb94557afd29ac$export$a23fbf1d8e34a2a3(dossierId);
}
function $f8cb94557afd29ac$export$31fdaf8d0454dd9a() {
    if (confirm((0, $65136e012e05e2d7$export$69d25b90d0002cf3).CONFIRM_EDIT_DOSSIER)) $f8cb94557afd29ac$export$f50eb229b7c582ed();
}
function $f8cb94557afd29ac$export$130f1544a698ff47() {
    if (confirm((0, $65136e012e05e2d7$export$69d25b90d0002cf3).CONFIRM_END_SESSION)) $f8cb94557afd29ac$export$f50eb229b7c582ed();
}
async function $f8cb94557afd29ac$export$fb09bad7d3252a25() {
    const dossierId = (0, $fd2d3348854bcc99$export$98333c9677aec7cf)();
    const reference = $f8cb94557afd29ac$var$dossierReferenceInput?.value?.trim() || '';
    if (!dossierId) {
        (0, $c20213e7535e565e$export$de026b00723010c1)('Aucun dossier actif. Veuillez d\'abord scanner un produit.');
        return;
    }
    // Disable button while saving
    if ($f8cb94557afd29ac$var$saveReferenceBtn) {
        $f8cb94557afd29ac$var$saveReferenceBtn.disabled = true;
        $f8cb94557afd29ac$var$saveReferenceBtn.textContent = '...';
    }
    try {
        await (0, $6a3074733bac15c1$export$ea55d8cf14b35e8f)(dossierId, reference);
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Reference updated for dossier ${dossierId}: ${reference}`);
        // Show saved indicator
        if ($f8cb94557afd29ac$var$referenceSavedIndicator) {
            $f8cb94557afd29ac$var$referenceSavedIndicator.hidden = false;
            // Auto-hide after 3 seconds
            setTimeout(()=>{
                if ($f8cb94557afd29ac$var$referenceSavedIndicator) $f8cb94557afd29ac$var$referenceSavedIndicator.hidden = true;
            }, 3000);
        }
    } catch (error) {
        (0, $8b67e0cfbd81e7b2$export$bd98d6b2b559620a)(error, 'Update Reference');
    } finally{
        // Re-enable button
        if ($f8cb94557afd29ac$var$saveReferenceBtn) {
            $f8cb94557afd29ac$var$saveReferenceBtn.disabled = false;
            $f8cb94557afd29ac$var$saveReferenceBtn.textContent = 'Enregistrer';
        }
    }
}


/**
 * Scanner module - Barcode scanning functionality
 */ 

/**
 * Beep sound using the `AudioContext` interface.
 *
 * @param {Object} options
 * @param {Number} options.duration - Duration in milliseconds
 * @param {Number} options.frequency - Frequency in Hz
 * @param {Number} options.volume - Volume
 * @param {String} options.type - Type of oscillator
 * @param {Function} options.onEnded - Callback function when the sound ends
 */ const $db31dc56898b80b8$export$d6c943e433460aae = (()=>{
    const audioCtx = new (window.AudioContext || window.webkitAudioContext || window.audioContext)();
    if (!audioCtx) return;
    return (options)=>{
        const { duration: duration, frequency: frequency, volume: volume, type: type, onEnded: onEnded } = options;
        const oscillator = audioCtx.createOscillator();
        const gainNode = audioCtx.createGain();
        oscillator.connect(gainNode);
        gainNode.connect(audioCtx.destination);
        if (volume) gainNode.gain.value = volume;
        if (frequency) oscillator.frequency.value = frequency;
        if (type) oscillator.type = type;
        if (typeof onEnded === 'function') oscillator.onended = onEnded;
        oscillator.start(audioCtx.currentTime);
        oscillator.stop(audioCtx.currentTime + (duration || 500) / 1000);
    };
})();


/**
 * Vibrate the device.
 * If the device does not support vibration, this function will fail silently.
 *
 * @param {Number} [duration=0] - Duration in milliseconds
 */ async function $03fe6bc65045924f$export$3ca8e905da0a0ca8(duration = 0) {
    if (typeof window.navigator.vibrate !== 'function') return;
    try {
        window.navigator.vibrate(duration);
    } catch  {
    // Fail silently...
    }
}


const $a6838ab1dc4817e7$var$RATE_LIMIT = 1000;
let $a6838ab1dc4817e7$var$lastTriggerTime = 0;
async function $a6838ab1dc4817e7$export$9b466d13e2031a67(options = {}) {
    const { success: success = true } = options;
    const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
    if (!settings) return;
    const now = Date.now();
    if (now - $a6838ab1dc4817e7$var$lastTriggerTime < $a6838ab1dc4817e7$var$RATE_LIMIT) return;
    const beepConfig = success ? {
        duration: 200,
        frequency: 860,
        volume: 0.03,
        type: 'square'
    } : {
        duration: 300,
        frequency: 200,
        volume: 0.05,
        type: 'sawtooth'
    };
    settings.beep && (0, $db31dc56898b80b8$export$d6c943e433460aae)(beepConfig);
    settings.vibrate && (0, $03fe6bc65045924f$export$3ca8e905da0a0ca8)(success ? 100 : 200);
    $a6838ab1dc4817e7$var$lastTriggerTime = now;
}









/**
 * DOM element references
 */ let $20813bb081f79f56$var$videoCaptureEl = null;
let $20813bb081f79f56$var$videoCaptureVideoEl = null;
let $20813bb081f79f56$var$videoCaptureActionsEl = null;
let $20813bb081f79f56$var$scanBtn = null;
let $20813bb081f79f56$var$scanFrameEl = null;
let $20813bb081f79f56$var$scanInstructionsEl = null;
let $20813bb081f79f56$var$cameraPanel = null;
let $20813bb081f79f56$var$dropzoneEl = null;
let $20813bb081f79f56$var$bsHistoryEl = null;
let $20813bb081f79f56$var$cameraSelect = null;
let $20813bb081f79f56$var$torchButton = null;
function $20813bb081f79f56$export$ef95d85c6e8d5511(elements) {
    $20813bb081f79f56$var$videoCaptureEl = elements.videoCaptureEl;
    $20813bb081f79f56$var$videoCaptureVideoEl = elements.videoCaptureVideoEl;
    $20813bb081f79f56$var$videoCaptureActionsEl = elements.videoCaptureActionsEl;
    $20813bb081f79f56$var$scanBtn = elements.scanBtn;
    $20813bb081f79f56$var$scanFrameEl = elements.scanFrameEl;
    $20813bb081f79f56$var$scanInstructionsEl = elements.scanInstructionsEl;
    $20813bb081f79f56$var$cameraPanel = elements.cameraPanel;
    $20813bb081f79f56$var$dropzoneEl = elements.dropzoneEl;
    $20813bb081f79f56$var$bsHistoryEl = elements.bsHistoryEl;
    $20813bb081f79f56$var$cameraSelect = elements.cameraSelect;
    $20813bb081f79f56$var$torchButton = elements.torchButton;
}
/**
 * Extracts barcode value from detection result
 * @param {object} barcode - Barcode detection result
 * @returns {string} Barcode value or empty string
 */ function $20813bb081f79f56$var$extractBarcodeValue(barcode) {
    if (!barcode || typeof barcode !== 'object') return '';
    let value = barcode.rawValue || barcode.text || barcode.data || '';
    if (typeof value !== 'string') value = String(value || '');
    return value;
}
async function $20813bb081f79f56$export$c87d910e63d22ed6() {
    if (!(0, $fd2d3348854bcc99$export$933c896b5b68e1bf)()) return;
    (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info('Scanning...');
    $20813bb081f79f56$var$scanInstructionsEl?.removeAttribute('hidden');
    try {
        const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
        const barcodeReader = (0, $fd2d3348854bcc99$export$b68ab95a19e46e80)();
        // Get video element from shadow DOM dynamically
        const videoEl = $20813bb081f79f56$var$videoCaptureEl?.shadowRoot?.querySelector('video');
        if (!barcodeReader || !videoEl) throw new Error('Scanner not initialized');
        const barcode = await barcodeReader.detect(videoEl);
        const barcodeValue = $20813bb081f79f56$var$extractBarcodeValue(barcode);
        if (!barcodeValue) throw new Error('No barcode detected');
        (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Barcode detected: ${barcodeValue}`);
        await (0, $da8cf946b66c37dc$export$af56ca1b22e54f7a)(barcodeValue);
        if (settings?.addToHistory) $20813bb081f79f56$var$bsHistoryEl?.add(barcodeValue);
        (0, $a6838ab1dc4817e7$export$9b466d13e2031a67)();
        // Stop scanning if continuous mode is disabled
        if (!settings?.continueScanning) {
            const timeoutId = (0, $fd2d3348854bcc99$export$7508020b8122e73f)();
            if (timeoutId) {
                clearTimeout(timeoutId);
                (0, $fd2d3348854bcc99$export$9ef6e5a1f2a43303)(null);
            }
            $20813bb081f79f56$var$scanBtn?.removeAttribute('hidden');
            $20813bb081f79f56$var$scanFrameEl?.setAttribute('hidden', '');
            $20813bb081f79f56$var$videoCaptureActionsEl?.setAttribute('hidden', '');
            return;
        }
    } catch  {
    // No barcode detected - continue scanning silently
    }
    if ((0, $fd2d3348854bcc99$export$933c896b5b68e1bf)()) (0, $fd2d3348854bcc99$export$9ef6e5a1f2a43303)(setTimeout(()=>$20813bb081f79f56$export$c87d910e63d22ed6(), (0, $65136e012e05e2d7$export$d41d2f17218678e7)));
}
function $20813bb081f79f56$export$cc6cf2e4a9c15f61() {
    $20813bb081f79f56$var$scanBtn?.setAttribute('hidden', '');
    $20813bb081f79f56$var$scanFrameEl?.removeAttribute('hidden');
    $20813bb081f79f56$var$videoCaptureActionsEl?.removeAttribute('hidden');
    $20813bb081f79f56$export$c87d910e63d22ed6();
}
function $20813bb081f79f56$export$f40fb14f339debf(evt) {
    const tabId = evt.detail.tabId;
    const currentVideoCaptureEl = document.querySelector('video-capture');
    if (tabId === 'cameraTab') {
        (0, $fd2d3348854bcc99$export$d9bb8408206af950)();
        if (!currentVideoCaptureEl) return;
        if (!currentVideoCaptureEl.loading && $20813bb081f79f56$var$scanBtn?.hasAttribute('hidden')) {
            $20813bb081f79f56$var$scanFrameEl?.removeAttribute('hidden');
            $20813bb081f79f56$var$videoCaptureActionsEl?.removeAttribute('hidden');
            $20813bb081f79f56$export$c87d910e63d22ed6();
        }
        if (typeof currentVideoCaptureEl.startVideoStream === 'function') {
            const videoDeviceId = $20813bb081f79f56$var$cameraSelect?.value || undefined;
            currentVideoCaptureEl.startVideoStream(videoDeviceId);
        }
    } else if (tabId === 'fileTab') {
        (0, $fd2d3348854bcc99$export$89ad965bd9bf7a2f)();
        if (currentVideoCaptureEl && typeof currentVideoCaptureEl.stopVideoStream === 'function') currentVideoCaptureEl.stopVideoStream();
        $20813bb081f79f56$var$scanFrameEl?.setAttribute('hidden', '');
        $20813bb081f79f56$var$videoCaptureActionsEl?.setAttribute('hidden', '');
    }
}
async function $20813bb081f79f56$export$6fd8332a0203ee21(file) {
    if (!file) return;
    const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
    const image = new Image();
    const reader = new FileReader();
    reader.onload = (evt)=>{
        const data = evt.target.result;
        image.onload = async ()=>{
            try {
                const barcodeReader = (0, $fd2d3348854bcc99$export$b68ab95a19e46e80)();
                if (!barcodeReader) throw new Error('Scanner not initialized');
                const barcode = await barcodeReader.detect(image);
                const barcodeValue = $20813bb081f79f56$var$extractBarcodeValue(barcode);
                if (!barcodeValue) throw new Error('No barcode detected');
                (0, $6dda9643863448b4$export$bef1f36f5486a6a3).info(`Barcode detected from image: ${barcodeValue}`);
                await (0, $da8cf946b66c37dc$export$af56ca1b22e54f7a)(barcodeValue);
                if (settings?.addToHistory) $20813bb081f79f56$var$bsHistoryEl?.add(barcodeValue);
                (0, $a6838ab1dc4817e7$export$9b466d13e2031a67)();
            } catch (err) {
                (0, $6dda9643863448b4$export$bef1f36f5486a6a3).error(err);
                (0, $0344530667b8f8fd$export$cbcbdc571577a620)('<strong>No barcode detected</strong><br><small>Please try again with a different image.</small>', {
                    variant: 'danger',
                    trustDangerousInnerHTML: true
                });
                (0, $a6838ab1dc4817e7$export$9b466d13e2031a67)({
                    success: false
                });
            }
        };
        image.src = data;
        image.alt = 'Image preview';
        // Update dropzone preview
        if ($20813bb081f79f56$var$dropzoneEl) {
            $20813bb081f79f56$var$dropzoneEl.replaceChildren();
            const preview = document.createElement('div');
            preview.className = 'dropzone-preview';
            const imageWrapper = document.createElement('div');
            imageWrapper.className = 'dropzone-preview__image-wrapper';
            const fileNameWrapper = document.createElement('div');
            fileNameWrapper.className = 'dropzone-preview__file-name';
            fileNameWrapper.textContent = file.name;
            imageWrapper.appendChild(image);
            preview.appendChild(imageWrapper);
            preview.appendChild(fileNameWrapper);
            $20813bb081f79f56$var$dropzoneEl.prepend(preview);
        }
    };
    reader.readAsDataURL(file);
}
function $20813bb081f79f56$export$67bebf32e9fe906(evt) {
    const file = evt.detail.acceptedFiles[0];
    $20813bb081f79f56$export$6fd8332a0203ee21(file);
}
function $20813bb081f79f56$export$c1ec802ff41ca813() {
    const videoEl = $20813bb081f79f56$var$videoCaptureEl?.shadowRoot?.querySelector('video');
    if (videoEl && $20813bb081f79f56$var$scanFrameEl) (0, $451e357ed50655d6$export$1404f0e91c73fec)(videoEl, $20813bb081f79f56$var$scanFrameEl);
}
function $20813bb081f79f56$export$877c33e40c0d3bb4(evt) {
    if (!$20813bb081f79f56$var$videoCaptureEl) return;
    $20813bb081f79f56$var$videoCaptureEl.torch = !$20813bb081f79f56$var$videoCaptureEl.torch;
    (0, $ac0619973d2d242a$export$d1bd0b12fe0d046)({
        el: evt.currentTarget,
        isTorchOn: $20813bb081f79f56$var$videoCaptureEl.hasAttribute('torch')
    });
}
function $20813bb081f79f56$export$938392a9421a3cd6(evt) {
    if (typeof $20813bb081f79f56$var$videoCaptureEl?.restartVideoStream !== 'function') return;
    const videoDeviceId = evt.target.value || undefined;
    $20813bb081f79f56$var$videoCaptureEl.restartVideoStream(videoDeviceId);
}
function $20813bb081f79f56$export$7624c0f563491e2f(selectedTabId) {
    if (selectedTabId !== 'cameraTab') return;
    const currentVideoCaptureEl = document.querySelector('video-capture');
    if (document.visibilityState === 'hidden') {
        (0, $fd2d3348854bcc99$export$89ad965bd9bf7a2f)();
        if (currentVideoCaptureEl && typeof currentVideoCaptureEl.stopVideoStream === 'function') currentVideoCaptureEl.stopVideoStream();
    } else {
        (0, $fd2d3348854bcc99$export$d9bb8408206af950)();
        if (!currentVideoCaptureEl) return;
        if (!currentVideoCaptureEl.loading && $20813bb081f79f56$var$scanBtn?.hasAttribute('hidden')) $20813bb081f79f56$export$c87d910e63d22ed6();
        if (typeof currentVideoCaptureEl.startVideoStream === 'function') {
            const videoDeviceId = $20813bb081f79f56$var$cameraSelect?.value || undefined;
            currentVideoCaptureEl.startVideoStream(videoDeviceId);
        }
    }
}



/**
 * Main application initialization
 */ (async function() {
    // DOM Elements
    const tabGroupEl = document.querySelector('a-tab-group');
    const videoCaptureEl = document.querySelector('video-capture');
    const bsSettingsEl = document.querySelector('bs-settings');
    const bsHistoryEl = document.querySelector('bs-history');
    const cameraPanel = document.getElementById('cameraPanel');
    const scanInstructionsEl = document.getElementById('scanInstructions');
    const scanBtn = document.getElementById('scanBtn');
    const dropzoneEl = document.getElementById('dropzone');
    const resizeObserverEl = document.querySelector('resize-observer');
    const scanFrameEl = document.getElementById('scanFrame');
    const torchButton = document.getElementById('torchButton');
    const globalActionsEl = document.getElementById('globalActions');
    const historyBtn = document.getElementById('historyBtn');
    const historyDialog = document.getElementById('historyDialog');
    const settingsBtn = document.getElementById('settingsBtn');
    const settingsDialog = document.getElementById('settingsDialog');
    const settingsForm = document.getElementById('settingsForm');
    const cameraSelect = document.getElementById('cameraSelect');
    const customerNumberInput = document.getElementById('customer-number');
    const validateCustomerBtn = document.getElementById('validate-customer-btn');
    const customerInfoDiv = document.getElementById('customer-info');
    const dossierInfoDiv = document.getElementById('dossier-info');
    const alertsContainer = document.getElementById('alerts-container');
    const endSessionBtn = document.getElementById('end-session-btn');
    const endSessionBtnTop = document.getElementById('end-session-btn-top');
    const dossierInputContainer = document.getElementById('dossier-input-container');
    const dossierNumberInput = document.getElementById('dossier-number');
    const validateDossierBtn = document.getElementById('validate-dossier-btn');
    const dossierDisplayContainer = document.getElementById('dossier-display-container');
    const dossierDisplay = document.getElementById('dossier-display');
    const editDossierBtn = document.getElementById('edit-dossier-btn');
    // Initialize modules
    (0, $c20213e7535e565e$export$538086cfe5d4570)({
        alertsContainer: alertsContainer
    });
    (0, $5842cb61af962293$export$6d3c879d7a79980d)({
        customerNumberInput: customerNumberInput,
        validateCustomerBtn: validateCustomerBtn,
        customerInfoDiv: customerInfoDiv,
        dossierInfoDiv: dossierInfoDiv
    });
    (0, $f8cb94557afd29ac$export$43ad82df239a300c)({
        dossierInputContainer: dossierInputContainer,
        dossierNumberInput: dossierNumberInput,
        dossierDisplayContainer: dossierDisplayContainer,
        dossierDisplay: dossierDisplay
    });
    // Initialize product confirmation module
    (0, $7a5b8f925ffbbe37$export$f8f1e389c63efc79)();
    // Handle saved dossier ID after DOM is ready
    const handleSavedDossier = ()=>{
        const savedDossierId = (0, $fd2d3348854bcc99$export$98333c9677aec7cf)();
        if (savedDossierId) (0, $f8cb94557afd29ac$export$a23fbf1d8e34a2a3)(savedDossierId);
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', handleSavedDossier, {
        once: true
    });
    else handleSavedDossier();
    // Enable dialogs if supported
    if ((0, $2d4d0eca101a8031$export$c694186e9d94f0)()) {
        globalActionsEl?.removeAttribute('hidden');
        historyDialog?.removeAttribute('hidden');
        settingsDialog?.removeAttribute('hidden');
    }
    // Initialize barcode reader
    const { barcodeReaderError: barcodeReaderError } = await (0, $8510600959e31c2c$export$f21d9483ebeee00a).setup();
    if (barcodeReaderError) {
        const alertEl = document.getElementById('barcodeReaderError');
        (0, $fd2d3348854bcc99$export$89ad965bd9bf7a2f)();
        globalActionsEl?.setAttribute('hidden', '');
        tabGroupEl?.setAttribute('hidden', '');
        alertEl?.setAttribute('open', '');
        return;
    }
    const supportedBarcodeFormats = await (0, $8510600959e31c2c$export$f21d9483ebeee00a).getSupportedFormats();
    const [, settings] = await (0, $0eb43b201e9f90c7$export$4a647155031ece)();
    const initialFormats = settings?.formats || supportedBarcodeFormats;
    const barcodeReader = await (0, $8510600959e31c2c$export$f21d9483ebeee00a).create(initialFormats);
    (0, $fd2d3348854bcc99$export$8b055fa43cbd19c0)(barcodeReader);
    // Video capture setup
    const videoCaptureShadowRoot = videoCaptureEl?.shadowRoot;
    const videoCaptureVideoEl = videoCaptureShadowRoot?.querySelector('video');
    const videoCaptureActionsEl = videoCaptureShadowRoot?.querySelector('[part="actions-container"]');
    // Initialize scanner module
    (0, $20813bb081f79f56$export$ef95d85c6e8d5511)({
        videoCaptureEl: videoCaptureEl,
        videoCaptureVideoEl: videoCaptureVideoEl,
        videoCaptureActionsEl: videoCaptureActionsEl,
        scanBtn: scanBtn,
        scanFrameEl: scanFrameEl,
        scanInstructionsEl: scanInstructionsEl,
        cameraPanel: cameraPanel,
        dropzoneEl: dropzoneEl,
        bsHistoryEl: bsHistoryEl,
        cameraSelect: cameraSelect,
        torchButton: torchButton
    });
    dropzoneEl.accept = (0, $65136e012e05e2d7$export$63e7bed68b07a85c).join(',');
    bsSettingsEl.supportedFormats = supportedBarcodeFormats;
    // Video capture event handlers
    videoCaptureEl.addEventListener('video-capture:video-play', async (evt)=>{
        scanFrameEl?.removeAttribute('hidden');
        (0, $451e357ed50655d6$export$1404f0e91c73fec)(evt.detail.video, scanFrameEl);
        (0, $20813bb081f79f56$export$c87d910e63d22ed6)();
        const trackSettings = evt.target.getTrackSettings();
        const trackCapabilities = evt.target.getTrackCapabilities();
        const zoomLevelEl = document.getElementById('zoomLevel');
        // Torch control
        if (trackCapabilities?.torch) {
            torchButton?.addEventListener('click', (0, $20813bb081f79f56$export$877c33e40c0d3bb4));
            torchButton?.removeAttribute('hidden');
            if (videoCaptureEl.hasAttribute('torch')) (0, $ac0619973d2d242a$export$d1bd0b12fe0d046)({
                el: torchButton,
                isTorchOn: true
            });
        }
        // Zoom controls
        if (trackSettings?.zoom && trackCapabilities?.zoom) {
            const zoomControls = document.getElementById('zoomControls');
            const minZoom = trackCapabilities?.zoom?.min || 0;
            const maxZoom = trackCapabilities?.zoom?.max || 10;
            let currentZoom = trackSettings?.zoom || 1;
            const handleZoomControlsClick = (evt)=>{
                const zoomInBtn = evt.target.closest('[data-action="zoom-in"]');
                const zoomOutBtn = evt.target.closest('[data-action="zoom-out"]');
                if (zoomInBtn && currentZoom < maxZoom) currentZoom += 0.5;
                if (zoomOutBtn && currentZoom > minZoom) currentZoom -= 0.5;
                zoomLevelEl.textContent = currentZoom.toFixed(1);
                videoCaptureEl.zoom = currentZoom;
            };
            zoomControls?.addEventListener('click', handleZoomControlsClick);
            zoomControls?.removeAttribute('hidden');
            zoomLevelEl.textContent = currentZoom.toFixed(1);
        }
        // Camera select
        const videoInputDevices = await (0, $40cc5a5311c08f52$export$682e9ed90a89bb4a).getVideoInputDevices();
        videoInputDevices.forEach((device, index)=>{
            const option = document.createElement('option');
            option.value = device.deviceId;
            option.textContent = device.label || `Camera ${index + 1}`;
            cameraSelect.appendChild(option);
        });
        if (videoInputDevices.length > 1) {
            cameraSelect?.addEventListener('change', (0, $20813bb081f79f56$export$938392a9421a3cd6));
            cameraSelect?.removeAttribute('hidden');
        }
    }, {
        once: true
    });
    videoCaptureEl.addEventListener('video-capture:error', (evt)=>{
        const error = evt.detail.error;
        if (error.name === 'NotFoundError') return;
        (0, $c20213e7535e565e$export$a43d25dadcf0aa1f)(cameraPanel, error);
    }, {
        once: true
    });
    (0, $40cc5a5311c08f52$export$682e9ed90a89bb4a).defineCustomElement();
    // Settings handlers
    function handleSettingsButtonClick() {
        settingsDialog.open = true;
    }
    async function handleSettingsFormChange(evt) {
        evt.preventDefault();
        const newSettings = {};
        const formData = new FormData(settingsForm);
        const generalSettings = formData.getAll('general-settings');
        const formatsSettings = formData.getAll('formats-settings');
        generalSettings.forEach((value)=>newSettings[value] = true);
        newSettings.formats = formatsSettings;
        (0, $0eb43b201e9f90c7$export$dc86d17a64679bc7)(newSettings);
        if (evt.target.name === 'formats-settings') {
            const newBarcodeReader = await (0, $8510600959e31c2c$export$f21d9483ebeee00a).create(formatsSettings);
            (0, $fd2d3348854bcc99$export$8b055fa43cbd19c0)(newBarcodeReader);
        }
    }
    // History handlers
    function handleHistoryButtonClick() {
        historyDialog.open = true;
    }
    function handleHistorySuccess(evt) {
        const { type: type, message: message } = evt.detail;
        if (type === 'add') (0, $0344530667b8f8fd$export$cbcbdc571577a620)(message, {
            variant: 'success'
        });
    }
    function handleHistoryError(evt) {
        const { type: type, message: message } = evt.detail;
        if (type === 'remove' || type === 'empty') historyDialog?.hide();
        (0, $0344530667b8f8fd$export$cbcbdc571577a620)(message, {
            variant: 'danger'
        });
    }
    // Document handlers
    function handleDocumentKeyDown(evt) {
        if (evt.key === 'Escape') {
            const cameraTabSelected = tabGroupEl.querySelector('#cameraTab').hasAttribute('selected');
            const scanBtnVisible = !scanBtn.hidden;
            const settingsDialogOpen = settingsDialog.hasAttribute('open');
            const historyDialogOpen = historyDialog.hasAttribute('open');
            const anyDialogOpen = settingsDialogOpen || historyDialogOpen;
            if (!scanBtnVisible || !cameraTabSelected || anyDialogOpen) return;
            scanBtn.click();
        }
    }
    function handleVisibilityChange() {
        if (!tabGroupEl) return;
        const selectedTab = tabGroupEl.querySelector('[selected]');
        const tabId = selectedTab?.getAttribute('id');
        (0, $20813bb081f79f56$export$7624c0f563491e2f)(tabId);
    }
    // Compact view toggle
    const toggleViewBtn = document.getElementById('toggle-view-btn');
    const scannedItemsContainer = document.getElementById('scanned-items-container');
    const iconCompact = toggleViewBtn?.querySelector('.icon-compact');
    const iconDetailed = toggleViewBtn?.querySelector('.icon-detailed');
    toggleViewBtn?.addEventListener('click', ()=>{
        scannedItemsContainer?.classList.toggle('compact-mode');
        const isCompact = scannedItemsContainer?.classList.contains('compact-mode');
        // Toggle icons
        if (iconCompact && iconDetailed) {
            iconCompact.hidden = isCompact;
            iconDetailed.hidden = !isCompact;
        }
        // Save preference
        localStorage.setItem('compactViewEnabled', isCompact ? 'true' : 'false');
    });
    // Restore compact view preference
    if (localStorage.getItem('compactViewEnabled') === 'true') {
        scannedItemsContainer?.classList.add('compact-mode');
        if (iconCompact && iconDetailed) {
            iconCompact.hidden = true;
            iconDetailed.hidden = false;
        }
    }
    // Event listeners
    endSessionBtn?.addEventListener('click', (0, $f8cb94557afd29ac$export$130f1544a698ff47));
    endSessionBtnTop?.addEventListener('click', (0, $f8cb94557afd29ac$export$130f1544a698ff47));
    validateDossierBtn?.addEventListener('click', (0, $f8cb94557afd29ac$export$9c5ff91e64a5a8f6));
    editDossierBtn?.addEventListener('click', (0, $f8cb94557afd29ac$export$31fdaf8d0454dd9a));
    scanBtn?.addEventListener('click', (0, $20813bb081f79f56$export$cc6cf2e4a9c15f61));
    tabGroupEl?.addEventListener('a-tab-show', (0, $4481690a5b2e12d6$export$61fc7d43ac8f84b0)((0, $20813bb081f79f56$export$f40fb14f339debf), (0, $65136e012e05e2d7$export$1ec3328eed0aedd9)));
    dropzoneEl?.addEventListener('files-dropzone-drop', (0, $20813bb081f79f56$export$67bebf32e9fe906));
    resizeObserverEl?.addEventListener('resize-observer:resize', (0, $20813bb081f79f56$export$c1ec802ff41ca813));
    settingsBtn?.addEventListener('click', handleSettingsButtonClick);
    settingsForm?.addEventListener('change', (0, $4481690a5b2e12d6$export$61fc7d43ac8f84b0)(handleSettingsFormChange, (0, $65136e012e05e2d7$export$a236ec278a617d1d)));
    historyBtn?.addEventListener('click', handleHistoryButtonClick);
    document.addEventListener('visibilitychange', handleVisibilityChange);
    document.addEventListener('keydown', handleDocumentKeyDown);
    document.addEventListener('bs-history-success', handleHistorySuccess);
    document.addEventListener('bs-history-error', handleHistoryError);
    // Display version in footer
    const versionEl = document.getElementById('app-version');
    if (versionEl) versionEl.textContent = `v${0, $cb0eca7d9f6f47d1$export$a4ad2735b021c132}`;
})();
/**
 * Client ID Gate - Modal for initial client selection with confirmation step
 */ document.addEventListener('DOMContentLoaded', ()=>{
    // Modal elements
    const clientIdModal = document.getElementById('client-id-modal');
    const mainContent = document.getElementById('main-content');
    const clientIdInput = document.getElementById('client-id-input');
    const submitClientIdBtn = document.getElementById('submit-client-id-btn');
    const clientIdError = document.getElementById('client-id-error');
    // Step elements
    const clientIdStep = document.getElementById('client-id-step');
    const confirmStep = document.getElementById('confirm-identity-step');
    const confirmNameEl = document.getElementById('confirm-client-name');
    const confirmVatEl = document.getElementById('confirm-client-vat');
    const confirmYesBtn = document.getElementById('confirm-yes-btn');
    const confirmNoBtn = document.getElementById('confirm-no-btn');
    // Customer display elements
    const customerNumberInput = document.getElementById('customer-number');
    const editValidateBtn = document.getElementById('customer-edit-validate-btn');
    const storedClientId = (0, $fd2d3348854bcc99$export$8a452ee356909bac)();
    // Show/hide modal based on stored client
    if (storedClientId) {
        clientIdModal.hidden = true;
        mainContent.hidden = false;
    } else {
        clientIdModal.hidden = false;
        mainContent.hidden = true;
    }
    // Elements object for auth functions
    const modalElements = {
        modal: clientIdModal,
        mainContent: mainContent,
        clientIdInput: clientIdInput,
        errorEl: clientIdError,
        clientIdStep: clientIdStep,
        confirmStep: confirmStep,
        confirmNameEl: confirmNameEl,
        confirmVatEl: confirmVatEl
    };
    // Client ID submission handler - validates and shows confirmation
    const onClientIdSubmit = async ()=>{
        await (0, $5842cb61af962293$export$e74df61143124aea)(clientIdInput.value, modalElements);
    };
    // Confirmation handlers
    const onConfirmYes = async ()=>{
        const success = await (0, $5842cb61af962293$export$dc59cd457aad55e2)(modalElements);
        if (success) (0, $5842cb61af962293$export$b6387ab7e5774447)();
    };
    const onConfirmNo = ()=>{
        (0, $5842cb61af962293$export$24ee8f6b0e365210)(modalElements);
    };
    // Event listeners for modal
    submitClientIdBtn?.addEventListener('click', onClientIdSubmit);
    confirmYesBtn?.addEventListener('click', onConfirmYes);
    confirmNoBtn?.addEventListener('click', onConfirmNo);
    clientIdInput?.addEventListener('keypress', (e)=>{
        if (e.key === 'Enter') {
            e.preventDefault();
            onClientIdSubmit();
        }
    });
    // Customer edit button - shows modal for re-authentication
    editValidateBtn?.addEventListener('click', ()=>{
        // Reset modal to step 1
        if (clientIdStep) clientIdStep.hidden = false;
        if (confirmStep) confirmStep.hidden = true;
        if (clientIdInput) {
            clientIdInput.value = '';
            clientIdInput.focus();
        }
        // Show the modal
        if (clientIdModal) clientIdModal.hidden = false;
    });
    // Initial display update
    setTimeout(()=>{
        (0, $5842cb61af962293$export$b6387ab7e5774447)();
    }, 100);
});


//# sourceMappingURL=app.a9ae4235.js.map
